const ICON_BASE_URL = process.env.NEXT_PUBLIC_IMAGE_BASE_URL || "";

import advanceTechnology from "../images/restaurant_page/why konstant/advanced-technology-stack.svg";
import talentedTeamofExperts from "../images/restaurant_page/why konstant/talented-team-of-experts.svg";
import uiUX from "../images/restaurant_page/why konstant/ux-design.svg";
import agilemethology from "../images/restaurant_page/why konstant/agile-development-process.svg";
import multiplatformCompatiablity from "../images/restaurant_page/why konstant/multi-platform-compatibility.svg";
import budgetFriendly from "../images/restaurant_page/why konstant/budget-friendly-services.svg";
import onTimeDeliveryIcon from "../icons/frontend_icons/on-time-delivery.svg";
import agileDevelopmentIcon from "../icons/frontend_icons/agile-development-practices.svg";
import collaborativeApproachIcon from "../icons/frontend_icons/collaborative-approach.svg";
import transparentCommunicationIcon from "../icons/frontend_icons/transparent-communication.svg";
import supportContinuityIcon from "../icons/frontend_icons/support-continuity.svg";
import scalableSolutionsIcon from "../icons/frontend_icons/scalable-solutions.svg";

import increasedConversionRatesIcon from "../icons/frontend_icons/increased-conversion-rates.svg";
import powerfulFunctionalityIcon from "../icons/frontend_icons/powerful-functionality.svg";
import improvedNavigationIcon from "../icons/frontend_icons/improved-navigation.svg";
import crossDeviceCompatibilityIcon from "../icons/frontend_icons/cross-device-compatibility.svg";
import optimalPerformanceIcon from "../icons/frontend_icons/optimal-performance.svg";
import goodFirstImpressionIcon from "../icons/frontend_icons/good-first-impression.svg";

import frontendDesignAndArchitectureIcon from "../icons/frontend_icons/frontend-design-and-architecture.svg";
import customFrontendDevelopmentIcon from "../icons/frontend_icons/custom-frontend-development.svg";
import progressiveWebAppDevelopmentIcon from "../icons/frontend_icons/progressive-web-app-development.svg";
import microFrontendDevelopmentIcon from "../icons/frontend_icons/micro-frontend-development.svg";
import singlePageApplicationsIcon from "../icons/frontend_icons/single-page-applications.svg";
import responsiveWebDesignIcon from "../icons/frontend_icons/responsive-web-design.svg";

import backendAppDevelopmentIcon from "../icons/backend_icons/backend-app-development.svg";
import backendCodeRefactoringIcon from "../icons/backend_icons/backend-code-refactoring.svg";
import backendConsultingIcon from "../icons/backend_icons/backend-consulting.svg";
import backendMaintenanceAndSupportIcon from "../icons/backend_icons/backend-maintenance-and-support.svg";
import backendWebDevelopmentServicesIcon from "../icons/backend_icons/backend-web-development-services.svg";
import cloudBackendSolutionsIcon from "../icons/backend_icons/cloud-backend-solutions.svg";

import applicationLogicIcon from "../icons/backend_icons/application-logic.svg";
import excellentFunctionalityIcon from "../icons/backend_icons/excellent-functionality.svg";
import greatVarietyIcon from "../icons/backend_icons/great-variety.svg";
import highSecurityIcon from "../icons/backend_icons/high-security.svg";
import outstandingUserExperienceIcon from "../icons/backend_icons/outstanding-user-experience.svg";
import smoothOperationIcon from "../icons/backend_icons/smooth-operation.svg";

import complianceAdherenceIcon from "../icons/backend_icons/compliance-adherence.svg";
import prioritizingSecurityIcon from "../icons/backend_icons/prioritizing-security.svg";
import productOrientedApproachIcon from "../icons/backend_icons/product-oriented-approach.svg";
import provenExpertiseIcon from "../icons/backend_icons/proven-expertise.svg";
import qualityAssuranceIcon from "../icons/backend_icons/quality-assurance.svg";
import strongProjectManagementIcon from "../icons/backend_icons/strong-project-management.svg";

import customStripeIntegrationServicesIcon from "../icons/strip_icons/services/custom-stripe-integration-services.svg";
import hubspotStripeIntegrationIcon from "../icons/strip_icons/services/hubspot-stripe-integration.svg";
import shopifyStripeIntegrationIcon from "../icons/strip_icons/services/shopify-stripe-integration.svg";
import stripeDashboardSolutionsIcon from "../icons/strip_icons/services/stripe-dashboard-solutions.svg";
import stripeMobileAppIntegrationIcon from "../icons/strip_icons/services/stripe-mobile-app-integration.svg";
import stripeSalesforceIntegrationIcon from "../icons/strip_icons/services/stripe-salesforce-integration.svg";

import budgetFriendlyIcon from "../icons/strip_icons/why_konstant/budget-friendly.svg";
import certifiedExpertsIcon from "../icons/strip_icons/why_konstant/certified-experts.svg";
import improvedPaymentExperienceIcon from "../icons/strip_icons/why_konstant/improved-payment-experience.svg";
import resultFocusedApproachIcon from "../icons/strip_icons/why_konstant/result-focused-approach.svg";
import shopifyStripeIntegrationWhyIcon from "../icons/strip_icons/why_konstant/shopify-stripe-integration.svg";
import tailoredSolutionsIcon from "../icons/strip_icons/why_konstant/tailored-solutions.svg";

import builtInSecurityIcon from "../icons/strip_icons/why_stripe/built-in-security.svg";
import comprehensiveFeaturesIcon from "../icons/strip_icons/why_stripe/comprehensive-features.svg";
import developerFriendlyApiIcon from "../icons/strip_icons/why_stripe/developer-friendly-api.svg";
import flexibleBillingModelsIcon from "../icons/strip_icons/why_stripe/flexible-billing-models.svg";
import globalPaymentSupportIcon from "../icons/strip_icons/why_stripe/global-payment-support.svg";
import realTimeWebhooksIcon from "../icons/strip_icons/why_stripe/real-time-webhooks.svg";

import bankingAndFinanceIcon from "../icons/saas_icons/industry we serve/banking-and-finance.svg";
import ecommerceIcon from "../icons/saas_icons/industry we serve/ecommerce.svg";
import educationIcon from "../icons/saas_icons/industry we serve/education.svg";
import foodRestaurantIcon from "../icons/saas_icons/industry we serve/food-restaurant.svg";
import healthFitnessIcon from "../icons/saas_icons/industry we serve/health-fitness.svg";
import hospitalityTravelIcon from "../icons/saas_icons/industry we serve/hospitality-travel.svg";
import mediaEntertainmentIcon from "../icons/saas_icons/industry we serve/media-entertainment.svg";
import onDemandServicesIcon from "../icons/saas_icons/industry we serve/on-demand-services.svg";
import realEstateIcon from "../icons/saas_icons/industry we serve/real-estate.svg";
import socialNetworkingIcon from "../icons/saas_icons/industry we serve/social-networking.svg";

import saasAppSupportAndMaintenanceIcon from "../icons/saas_icons/services/saas-app-support-and-maintenance.svg";
import saasAppUiUxDesignIcon from "../icons/saas_icons/services/saas-app-ui-ux-design.svg";
// import saasConsultingServicesIcon from "../icons/saas_icons/services/saas-consulting-services.svg";
import saasMobileAppDevelopmentIcon from "../icons/saas_icons/services/saas-mobile-app-development.svg";
import saasModernizationAndSupportIcon from "../icons/saas_icons/services/saas-modernization-and-support.svg";
import saasProductDevelopmentIcon from "../icons/saas_icons/services/saas-product-development.svg";

import experienceDrivenIcon from "../icons/saas_icons/why konstant/experience-driven.svg";
import reliableSupportIcon from "../icons/saas_icons/why konstant/reliable-support.svg";
import saasExpertiseIcon from "../icons/saas_icons/why konstant/saas-expertise.svg";
import strongCapabilitiesIcon from "../icons/saas_icons/why konstant/strong-capabilities.svg";
import tailoredSolutionsIconSaas from "../icons/saas_icons/why konstant/tailored-solutions.svg";
import transparencyIcon from "../icons/saas_icons/why konstant/transparency.svg";

import advancedSolutionsIcon from "../icons/saas_icons/why SaaS/advanced-solutions.svg";
import costEffectiveIcon from "../icons/saas_icons/why SaaS/cost-effective.svg";
import dataSecurityIcon from "../icons/saas_icons/why SaaS/data-security.svg";
import easyToUseIcon from "../icons/saas_icons/why SaaS/easy-to-use.svg";
import fastDeploymentIcon from "../icons/saas_icons/why SaaS/fast-deployment.svg";
import scalabilityIcon from "../icons/saas_icons/why SaaS/scalability.svg";

import futureReadyStrategyIcon from "../icons/metaverse_icons/benefits/future-ready-strategy.svg";
import globalReachIcon from "../icons/metaverse_icons/benefits/global-reach.svg";
import improvedCollaborationIcon from "../icons/metaverse_icons/benefits/improved-collaboration.svg";
import innovativeExperiencesIcon from "../icons/metaverse_icons/benefits/innovative-experiences.svg";
import newRevenueOpportunitiesIcon from "../icons/metaverse_icons/benefits/new-revenue-opportunities.svg";
import personalizedCustomerExperiencesIcon from "../icons/metaverse_icons/benefits/personalized-customer-experiences.svg";
import strongerUserEngagementIcon from "../icons/metaverse_icons/benefits/stronger-user-engagement.svg";

import bankingAndFinanceIconMetaVerse from "../icons/metaverse_icons/industry_we_serve/banking-and-finance.svg";
import ecommerceIconMetaVerse from "../icons/metaverse_icons/industry_we_serve/ecommerce.svg";
import educationIconMetaVerse from "../icons/metaverse_icons/industry_we_serve/education.svg";
import foodRestaurantIconMetaVerse from "../icons/metaverse_icons/industry_we_serve/food-restaurant.svg";
import healthFitnessIconMetaVerse from "../icons/metaverse_icons/industry_we_serve/health-fitness.svg";
import hospitalityTravelIconMetaVerse from "../icons/metaverse_icons/industry_we_serve/hospitality-travel.svg";
import mediaEntertainmentIconMetaVerse from "../icons/metaverse_icons/industry_we_serve/media-entertainment.svg";
import onDemandServicesIconMetaVerse from "../icons/metaverse_icons/industry_we_serve/on-demand-services.svg";
import realEstateIconMetaVerse from "../icons/metaverse_icons/industry_we_serve/real-estate.svg";
import socialNetworkingIconMetaVerse from "../icons/metaverse_icons/industry_we_serve/social-networking.svg";

import space3dDevelopmentIcon from "../icons/metaverse_icons/services/3d-space-development.svg";
import metaverseAvatarDevelopmentIcon from "../icons/metaverse_icons/services/metaverse-3d-avatar-development.svg";
import metaverseAppDevelopmentServicesIcon from "../icons/metaverse_icons/services/metaverse-app-development-services.svg";
import metaverseEnterpriseIntegrationIcon from "../icons/metaverse_icons/services/metaverse-enterprise-integration.svg";
import metaverseGameDevelopmentServicesIcon from "../icons/metaverse_icons/services/metaverse-game-development-services.svg";
import metaverseNftMarketplaceDevelopmentIcon from "../icons/metaverse_icons/services/metaverse-nft-marketplace-development.svg";

import customizedSolutionsIcon from "../icons/metaverse_icons/why_konstant/customized-solutions.svg";
import enhancedSecurityIcon from "../icons/metaverse_icons/why_konstant/enhanced-security.svg";
import metaverseExpertiseIcon from "../icons/metaverse_icons/why_konstant/metaverse-expertise.svg";
import qualityAssuranceIconMetaVerse from "../icons/metaverse_icons/why_konstant/quality-assurance.svg";
import seamlessCollaborationIcon from "../icons/metaverse_icons/why_konstant/seamless-collaboration.svg";
import uncompromisedTransparencyIcon from "../icons/metaverse_icons/why_konstant/uncompromised-transparency.svg";

import continuousInnovationIcon from "../icons/ai_power_bus_icons/benefits/continuous-innovation.svg";
import customerCentricityIcon from "../icons/ai_power_bus_icons/benefits/customer-centricity.svg";
import dataBackedStrategyIcon from "../icons/ai_power_bus_icons/benefits/data-backed-strategy.svg";
import marketAdaptabilityIcon from "../icons/ai_power_bus_icons/benefits/market-adaptability.svg";
import operationalExcellenceIcon from "../icons/ai_power_bus_icons/benefits/operational-excellence.svg";
import sustainableGrowthIcon from "../icons/ai_power_bus_icons/benefits/sustainable-growth.svg";

import bankingAndFinanceIconAIPowered from "../icons/ai_power_bus_icons/industry_we_serve/banking-and-finance.svg";
import ecommerceIconAIPowered from "../icons/ai_power_bus_icons/industry_we_serve/ecommerce.svg";
import educationIconAIPowered from "../icons/ai_power_bus_icons/industry_we_serve/education.svg";
import foodRestaurantIconAIPowered from "../icons/ai_power_bus_icons/industry_we_serve/food-restaurant.svg";
import healthFitnessIconAIPowered from "../icons/ai_power_bus_icons/industry_we_serve/health-fitness.svg";
import hospitalityTravelIconAIPowered from "../icons/ai_power_bus_icons/industry_we_serve/hospitality-travel.svg";
import mediaEntertainmentIconAIPowered from "../icons/ai_power_bus_icons/industry_we_serve/media-entertainment.svg";
import onDemandServicesIconAIPowered from "../icons/ai_power_bus_icons/industry_we_serve/on-demand-services.svg";
import realEstateIconAIPowered from "../icons/ai_power_bus_icons/industry_we_serve/real-estate.svg";
import socialNetworkingIconAIPowered from "../icons/ai_power_bus_icons/industry_we_serve/social-networking.svg";

import aiAdoptionStrategyIcon from "../icons/ai_power_bus_icons/services/ai-adoption-strategy.svg";
import aiAndCustomerExperienceIcon from "../icons/ai_power_bus_icons/services/ai-and-customer-experience.svg";
import aiForOperationalEfficiencyIcon from "../icons/ai_power_bus_icons/services/ai-for-operational-efficiency.svg";
import aiGovernanceAndEthicsIcon from "../icons/ai_power_bus_icons/services/ai-governance-and-ethics.svg";
import aiInBusinessProcessAutomationIcon from "../icons/ai_power_bus_icons/services/ai-in-business-process-automation.svg";
import customAiBusinessTransformationIcon from "../icons/ai_power_bus_icons/services/custom-ai-business-transformation.svg";

import aiExpertiseIcon from "../icons/ai_power_bus_icons/why_konstant/ai-expertise.svg";
import customerFocusedStrategyIcon from "../icons/ai_power_bus_icons/why_konstant/customer-focused-strategy.svg";
import establishedPerformanceIcon from "../icons/ai_power_bus_icons/why_konstant/established-performance.svg";
import innovationIcon from "../icons/ai_power_bus_icons/why_konstant/innovation.svg";
import modernSolutionsIcon from "../icons/ai_power_bus_icons/why_konstant/modern-solutions.svg";
import scalabilityIconAIPowered from "../icons/ai_power_bus_icons/why_konstant/scalability.svg";

import automatingRepetitiveTasksIcon from "../icons/ai_integration_icons/benefits/automating-repetitive-tasks.svg";
import dataDrivenInsightsIcon from "../icons/ai_integration_icons/benefits/data-driven-insights.svg";
import personalizedCustomerExperiencesIconAIIntegrated from "../icons/ai_integration_icons/benefits/personalized-customer-experiences.svg";
import processOptimizationIcon from "../icons/ai_integration_icons/benefits/process-optimization.svg";
import riskMitigationIcon from "../icons/ai_integration_icons/benefits/risk-mitigation.svg";
import seamlessSystemIntegrationIcon from "../icons/ai_integration_icons/benefits/seamless-system-integration.svg";

import bankingAndFinanceIconAIIntegrated from "../icons/ai_integration_icons/industry_we_serve/banking-and-finance.svg";
import ecommerceIconAIIntegrated from "../icons/ai_integration_icons/industry_we_serve/ecommerce.svg";
import educationIconAIIntegrated from "../icons/ai_integration_icons/industry_we_serve/education.svg";
import foodRestaurantIconAIIntegrated from "../icons/ai_integration_icons/industry_we_serve/food-restaurant.svg";
import healthFitnessIconAIIntegrated from "../icons/ai_integration_icons/industry_we_serve/health-fitness.svg";
import hospitalityTravelIconAIIntegrated from "../icons/ai_integration_icons/industry_we_serve/hospitality-travel.svg";
import mediaEntertainmentIconAIIntegratedAIIntegrated from "../icons/ai_integration_icons/industry_we_serve/media-entertainment.svg";
import onDemandServicesIconAIIntegrated from "../icons/ai_integration_icons/industry_we_serve/on-demand-services.svg";
import realEstateIconAIIntegrated from "../icons/ai_integration_icons/industry_we_serve/real-estate.svg";
import socialNetworkingIconAIIntegrated from "../icons/ai_integration_icons/industry_we_serve/social-networking.svg";

import adaptiveAiIntegrationIcon from "../icons/ai_integration_icons/services/adaptive-ai-integration.svg";
import aiAndMlModelsIntegrationIcon from "../icons/ai_integration_icons/services/ai-and-ml-models-integration.svg";
import aiIntegrationConsultingIcon from "../icons/ai_integration_icons/services/ai-integration-consulting.svg";
import chatgptIntegrationServicesIcon from "../icons/ai_integration_icons/services/chatgpt-integration-services.svg";
import openAiIcon from "../icons/ai_case_study_icons/openai-icon.svg";
import dataIntegrationAndAnalyticsIcon from "../icons/ai_integration_icons/services/data-integration-and-analytics.svg";
import generativeAiIntegrationIcon from "../icons/ai_integration_icons/services/generative-ai-integration.svg";

import aiExpertiseIconAIIntegrated from "../icons/ai_integration_icons/why _konstant/ai-expertise.svg";
import commitmentToInnovationIcon from "../icons/ai_integration_icons/why _konstant/commitment-to-innovation.svg";
import dedicatedSupportIcon from "../icons/ai_integration_icons/why _konstant/dedicated-support.svg";
import endToEndImplementationIcon from "../icons/ai_integration_icons/why _konstant/end-to-end-implementation.svg";
import provenSuccessIcon from "../icons/ai_integration_icons/why _konstant/proven-success.svg";
import seamlessIntegrationIcon from "../icons/ai_integration_icons/why _konstant/seamless-integration.svg";
import tailoredSolutionsIconAIIntegrated from "../icons/ai_integration_icons/why _konstant/tailored-solutions.svg";

import efficientProblemSolvingIcon from "../icons/ai_consulting_icons/benefits/efficient-problem-solving.svg";
import enhancedCustomerExperiencesIcon from "../icons/ai_consulting_icons/benefits/enhanced-customer-experiences.svg";
import facilitatedRecruitmentIcon from "../icons/ai_consulting_icons/benefits/facilitated-recruitment.svg";
import improvedCybersecurityIcon from "../icons/ai_consulting_icons/benefits/improved-cybersecurity.svg";
import increasedEmployeeProductivityIcon from "../icons/ai_consulting_icons/benefits/increased-employee-productivity.svg";
import newRevenueStreamsIcon from "../icons/ai_consulting_icons/benefits/new-revenue-streams.svg";

import bankingAndFinanceIconAiCp from "../icons/ai_consulting_icons/industry_we_serve/banking-and-finance.svg";
import ecommerceIconAiConsulting from "../icons/ai_consulting_icons/industry_we_serve/ecommerce.svg";
import educationIconAiConsulting from "../icons/ai_consulting_icons/industry_we_serve/education.svg";
import foodRestaurantIconAiConsulting from "../icons/ai_consulting_icons/industry_we_serve/food-restaurant.svg";
import healthFitnessIconAiConsulting from "../icons/ai_consulting_icons/industry_we_serve/health-fitness.svg";
import hospitalityTravelIconAiConsulting from "../icons/ai_consulting_icons/industry_we_serve/hospitality-travel.svg";
import mediaEntertainmentIconAiConsulting from "../icons/ai_consulting_icons/industry_we_serve/media-entertainment.svg";
import onDemandServicesIconAiConsulting from "../icons/ai_consulting_icons/industry_we_serve/on-demand-services.svg";
import realEstateIconAiConsulting from "../icons/ai_consulting_icons/industry_we_serve/real-estate.svg";
import socialNetworkingIconAiConsulting from "../icons/ai_consulting_icons/industry_we_serve/social-networking.svg";

import aiRapidPrototypingIcon from "../icons/ai_consulting_icons/services/ai-rapid-prototyping.svg";
import aiStrategyAndValueIdentificationIcon from "../icons/ai_consulting_icons/services/ai-strategy-and-value-identification.svg";
import aiTechnologyConsultingIcon from "../icons/ai_consulting_icons/services/ai-technology-consulting.svg";
import dataReadinessConsultingIcon from "../icons/ai_consulting_icons/services/data-readiness-consulting.svg";
import enterpriseAiConsultingIcon from "../icons/ai_consulting_icons/services/enterprise-ai-consulting.svg";
import generativeAiConsultingIcon from "../icons/ai_consulting_icons/services/generative-ai-consulting.svg";

import businessFirstApproachIcon from "../icons/ai_consulting_icons/why_konstant/business-first-approach.svg";
import focusOnSuccessIcon from "../icons/ai_consulting_icons/why_konstant/focus-on-success.svg";
import ongoingSupportIcon from "../icons/ai_consulting_icons/why_konstant/ongoing-support.svg";
import provenExpertiseIconAiConsulting from "../icons/ai_consulting_icons/why_konstant/proven-expertise.svg";
import responsibleAiPracticesIcon from "../icons/ai_consulting_icons/why_konstant/responsible-ai-practices.svg";
import tailoredSolutionsIconAiConsulting from "../icons/ai_consulting_icons/why_konstant/tailored-solutions.svg";

import boostProfitabilityIconGenerativeAI from "../icons/generative_ai_icons/benefits/boost-profitability.svg";
import dataDrivenInsightsIconGenerativeAI from "../icons/generative_ai_icons/benefits/data-driven-insights.svg";
import efficiencyAndAutomationIconGenerativeAI from "../icons/generative_ai_icons/benefits/efficiency-and-automation.svg";
import personalizedExperiencesIconGenerativeAI from "../icons/generative_ai_icons/benefits/personalized-experiences.svg";
import smartWorkflowOptimizationIconGenerativeAI from "../icons/generative_ai_icons/benefits/smart-workflow-optimization.svg";
import smootherOperationsIconGenerativeAI from "../icons/generative_ai_icons/benefits/smoother-operations.svg";

import bankingAndFinanceIconGenerativeAI from "../icons/generative_ai_icons/industry_we_serve/banking-and-finance.svg";
import ecommerceIconGenerativeAI from "../icons/generative_ai_icons/industry_we_serve/ecommerce.svg";
import educationIconGenerativeAI from "../icons/generative_ai_icons/industry_we_serve/education.svg";
import foodRestaurantIconGenerativeAI from "../icons/generative_ai_icons/industry_we_serve/food-restaurant.svg";
import healthFitnessIconGenerativeAI from "../icons/generative_ai_icons/industry_we_serve/health-fitness.svg";
import hospitalityTravelIconGenerativeAI from "../icons/generative_ai_icons/industry_we_serve/hospitality-travel.svg";
import mediaEntertainmentIconGenerativeAI from "../icons/generative_ai_icons/industry_we_serve/media-entertainment.svg";
import onDemandServicesIconGenerativeAI from "../icons/generative_ai_icons/industry_we_serve/on-demand-services.svg";
import realEstateIconGenerativeAI from "../icons/generative_ai_icons/industry_we_serve/real-estate.svg";
import socialNetworkingIconGenerativeAI from "../icons/generative_ai_icons/industry_we_serve/social-networking.svg";

import generativeAiAppDevelopmentIconGenerativeAI from "../icons/generative_ai_icons/services/generative-ai-app-development.svg";
import generativeAiConsultingIconGenerativeAI from "../icons/generative_ai_icons/services/generative-ai-consulting.svg";
import generativeAiIntegrationIconGenerativeAI from "../icons/generative_ai_icons/services/generative-ai-integration.svg";
import generativeAiModelDevelopmentIconGenerativeAI from "../icons/generative_ai_icons/services/generative-ai-model-development.svg";
import generativeAiModelFineTuningIconGenerativeAI from "../icons/generative_ai_icons/services/generative-ai-model-fine-tuning.svg";
import generativeAiModelReplicationIconGenerativeAI from "../icons/generative_ai_icons/services/generative-ai-model-replication.svg";

import competitiveSolutionsIconGenerativeAI from "../icons/generative_ai_icons/why_konstant/competitive-solutions.svg";
import domainSpecificCustomizationIconGenerativeAI from "../icons/generative_ai_icons/why_konstant/domain-specific-customization.svg";
import fullStackExpertiseIconGenerativeAI from "../icons/generative_ai_icons/why_konstant/full-stack-expertise.svg";
import provenTrackRecordIconGenerativeAI from "../icons/generative_ai_icons/why_konstant/proven-track-record.svg";
import strategicConversationIconGenerativeAI from "../icons/generative_ai_icons/why_konstant/strategic-conversation.svg";
import transparentCommunicationIconGenerativeAI from "../icons/generative_ai_icons/why_konstant/transparent-communication.svg";

// Benefits
// import consistentServiceQualityIconAIChatBot from "../icons/ai_chatbot_icons/benefits/consistent-service-quality.svg";
import costEfficiencyIconAIChatBot from "../icons/ai_chatbot_icons/benefits/cost-efficiency.svg";
import humanLikePersonalizationIconAIChatBot from "../icons/ai_chatbot_icons/benefits/human-like-personalization.svg";
import realTimeResponsesIconAIChatBot from "../icons/ai_chatbot_icons/benefits/real-time-responses.svg";
import roundTheClockAvailabilityIconAIChatBot from "../icons/ai_chatbot_icons/benefits/round-the-clock-availability.svg";
import workflowAutomationIconAIChatBot from "../icons/ai_chatbot_icons/benefits/workflow-automation.svg";

// Industries We Serve
// import bankingAndFinanceIconAIChatBot from "../icons/ai_chatbot_icons/industry_we_serve/banking-and-finance.svg";
// import ecommerceIconAIChatBot from "../icons/ai_chatbot_icons/industry_we_serve/ecommerce.svg";
// import educationIconAIChatBot from "../icons/ai_chatbot_icons/industry_we_serve/education.svg";
// import foodRestaurantIconAIChatBot from "../icons/ai_chatbot_icons/industry_we_serve/food-restaurant.svg";
// import frame3IconAIChatBot from "../icons/ai_chatbot_icons/industry_we_serve/Frame-3.svg";
// import hospitalityTravelIconAIChatBot from "../icons/ai_chatbot_icons/industry_we_serve/hospitality-travel.svg";
// import mediaEntertainmentIconAIChatBot from "../icons/ai_chatbot_icons/industry_we_serve/media-entertainment.svg";
// import onDemandServicesIconAIChatBot from "../icons/ai_chatbot_icons/industry_we_serve/on-demand-services.svg";
// import realEstateIconAIChatBot from "../icons/ai_chatbot_icons/industry_we_serve/real-estate.svg";
// import socialNetworkingIconAIChatBot from "../icons/ai_chatbot_icons/industry_we_serve/social-networking.svg";

// // Services
// import aiChatbotConsultingIconAIChatBot from "../icons/ai_chatbot_icons/services/ai-chatbot-consulting.svg";
// import aiChatbotDesignIconAIChatBot from "../icons/ai_chatbot_icons/services/ai-chatbot-design.svg";
// import aiChatbotMaintenanceSupportIconAIChatBot from "../icons/ai_chatbot_icons/services/ai-chatbot-maintenance-support.svg";
// import aiChatbotTestingIconAIChatBot from "../icons/ai_chatbot_icons/services/ai-chatbot-testing.svg";
// import aiChatbotUpgradeIconAIChatBot from "../icons/ai_chatbot_icons/services/ai-chatbot-upgrade.svg";
// import customAiChatbotDevelopmentIconAIChatBot from "../icons/ai_chatbot_icons/services/custom-ai-chatbot-development.svg";

// Why Konstant
import businessFirstApproachIconAIChatBot from "../icons/ai_chatbot_icons/why_konstant/business-first-approach.svg";
import dynamicCustomizationIconAIChatBot from "../icons/ai_chatbot_icons/why_konstant/dynamic-customization.svg";
import flexibleEngagementModelsIconAIChatBot from "../icons/ai_chatbot_icons/why_konstant/flexible-engagement-models.svg";
import scalabilityIconAIChatBot from "../icons/ai_chatbot_icons/why_konstant/scalability.svg";
import securityIconAIChatBot from "../icons/ai_chatbot_icons/why_konstant/security.svg";
import skilledCertifiedDevelopersIconAIChatBot from "../icons/ai_chatbot_icons/why_konstant/skilled-certified-developers.svg";

// Benefits
import costSavingsIcon from "../icons/vr_development_icons/benefits/cost-savings.svg";
import enhancedUserEngagementIcon from "../icons/vr_development_icons/benefits/enhanced-user-engagement.svg";
import immersiveExperiencesIcon from "../icons/vr_development_icons/benefits/immersive-experiences.svg";
import innovativeDifferentiationIcon from "../icons/vr_development_icons/benefits/innovative-differentiation.svg";
import innovativeTrainingIcon from "../icons/vr_development_icons/benefits/innovative-training.svg";
import marketingEdgeIcon from "../icons/vr_development_icons/benefits/marketing-edge.svg";

// Industries We Serve
import bankingAndFinanceIconVR from "../icons/vr_development_icons/industry_we_serve/banking-and-finance.svg";
import ecommerceIconVR from "../icons/vr_development_icons/industry_we_serve/ecommerce.svg";
import educationIconVR from "../icons/vr_development_icons/industry_we_serve/education.svg";
import foodRestaurantIconVR from "../icons/vr_development_icons/industry_we_serve/food-restaurant.svg";
import healthFitnessIconVR from "../icons/vr_development_icons/industry_we_serve/health-fitness.svg";
import hospitalityTravelIconVR from "../icons/vr_development_icons/industry_we_serve/hospitality-travel.svg";
import mediaEntertainmentIconVR from "../icons/vr_development_icons/industry_we_serve/media-entertainment.svg";
import onDemandServicesIconVR from "../icons/vr_development_icons/industry_we_serve/on-demand-services.svg";
import realEstateIconVR from "../icons/vr_development_icons/industry_we_serve/real-estate.svg";
import socialNetworkingIconVR from "../icons/vr_development_icons/industry_we_serve/social-networking.svg";

// Services
import customVrAppDevelopmentIconVR from "../icons/vr_development_icons/services/custom-vr-app-development.svg";
import vrConsultationIconVR from "../icons/vr_development_icons/services/VR Consultation.svg";
import vrGameDevelopmentServicesIconVR from "../icons/vr_development_icons/services/vr-game-development-services.svg";
import vrHeadsetAppDevelopmentIconVR from "../icons/vr_development_icons/services/vr-headset-app-development.svg";
import vrSupportAndMaintenanceIconVR from "../icons/vr_development_icons/services/vr-support-and-maintenance.svg";
import vrWebAppDevelopmentIconVR from "../icons/vr_development_icons/services/vr-web-app-development.svg";

// Why Konstant
import agileMethodologyIconVR from "../icons/vr_development_icons/why_konstant/agile-methodology.svg";
import competitiveRatesIconVR from "../icons/vr_development_icons/why_konstant/competitive-rates.svg";
import quickTurnaroundIconVR from "../icons/vr_development_icons/why_konstant/quick-turnaround.svg";
import strongTeamIconVR from "../icons/vr_development_icons/why_konstant/strong-team.svg";
import supportAndMaintenanceIconVR from "../icons/vr_development_icons/why_konstant/support-and-maintenance.svg";
import vastExperienceIconVR from "../icons/vr_development_icons/why_konstant/vast-experience.svg";

// Benefits
import contentFlexibilityIcon from "../icons/ar-development_icons/benefits/content-flexibility.svg";
import enhancedBrandAwarenessIcon from "../icons/ar-development_icons/benefits/enhanced-brand-awareness.svg";
import fastAdaptationIcon from "../icons/ar-development_icons/benefits/fast-adaptation.svg";
import immersiveUserExperienceIcon from "../icons/ar-development_icons/benefits/immersive-user-experience.svg";
import reducingLanguageBarriersIcon from "../icons/ar-development_icons/benefits/reducing-language-barriers.svg";
import seamlessConnectivityIcon from "../icons/ar-development_icons/benefits/seamless-connectivity.svg";

// Industries We Serve
import bankingAndFinanceARIcon from "../icons/ar-development_icons/industry_we-serve/banking-and-finance.svg";
import ecommerceARIcon from "../icons/ar-development_icons/industry_we-serve/ecommerce.svg";
import educationARIcon from "../icons/ar-development_icons/industry_we-serve/education.svg";
import foodRestaurantARIcon from "../icons/ar-development_icons/industry_we-serve/food-restaurant.svg";
import healthFitnessARIcon from "../icons/ar-development_icons/industry_we-serve/health-fitness.svg";
import hospitalityTraveARlIcon from "../icons/ar-development_icons/industry_we-serve/hospitality-travel.svg";
import mediaEntertainmentARIcon from "../icons/ar-development_icons/industry_we-serve/media-entertainment.svg";
import onDemandServicesARIcon from "../icons/ar-development_icons/industry_we-serve/on-demand-services.svg";
import realEstateARIcon from "../icons/ar-development_icons/industry_we-serve/real-estate.svg";
import socialNetworkingARIcon from "../icons/ar-development_icons/industry_we-serve/social-networking.svg";

// Services
import arAppConsultationARIcon from "../icons/ar-development_icons/services/ar-app-consultation.svg";
import arAppSupportAndMaintenanceARIcon from "../icons/ar-development_icons/services/ar-app-support-and-maintenance.svg";
import arGameAppDevelopmentARIcon from "../icons/ar-development_icons/services/ar-game-app-development.svg";
import arUiUxDesignARIcon from "../icons/ar-development_icons/services/ar-ui-ux-design.svg";
import customArAppSolutionsARIcon from "../icons/ar-development_icons/services/custom-ar-app-solutions.svg";

// Why Konstant
import builtInScalabilityARIcon from "../icons/ar-development_icons/why_konstant/built-in-scalability.svg";
import clientCentricApproachARIcon from "../icons/ar-development_icons/why_konstant/client-centric-approach.svg";
import domainExpertiseARIcon from "../icons/ar-development_icons/why_konstant/domain-expertise.svg";
import experiencedTeamARIcon from "../icons/ar-development_icons/why_konstant/experienced-team.svg";
import onTimeDeliveryARIcon from "../icons/ar-development_icons/why_konstant/on-time-delivery.svg";
import provenTrackRecordARIcon from "../icons/ar-development_icons/why_konstant/proven-track-record.svg";

// Benefits
import advancedPersonalizationIcon from "../icons/machine_learning_icons/benefits/advanced-personalization.svg";
import boostedOperationalEfficiencyIcon from "../icons/machine_learning_icons/benefits/boosted-operational-efficiency.svg";
import enhancedCustomerSatisfactionIcon from "../icons/machine_learning_icons/benefits/enhanced-customer-satisfaction.svg";
import improvedForecastIcon from "../icons/machine_learning_icons/benefits/improved-forecast.svg";
import predictiveMaintenanceIcon from "../icons/machine_learning_icons/benefits/predictive-maintenance.svg";
import smarterFinancialAnalysisIcon from "../icons/machine_learning_icons/benefits/smarter-financial-analysis.svg";

// Industries We Serve
import bankingAndFinanceMLIcon from "../icons/machine_learning_icons/industry_we_serve/banking-and-finance.svg";
import ecommerceMLIcon from "../icons/machine_learning_icons/industry_we_serve/ecommerce.svg";
import educationMLIcon from "../icons/machine_learning_icons/industry_we_serve/education.svg";
import foodRestaurantMLIcon from "../icons/machine_learning_icons/industry_we_serve/food-restaurant.svg";
import healthFitnessMLIcon from "../icons/machine_learning_icons/industry_we_serve/health-fitness.svg";
import hospitalityTraveMLlIcon from "../icons/machine_learning_icons/industry_we_serve/hospitality-travel.svg";
import mediaEntertainmentMLIcon from "../icons/machine_learning_icons/industry_we_serve/media-entertainment.svg";
import onDemandServicesMLIcon from "../icons/machine_learning_icons/industry_we_serve/on-demand-services.svg";
import realEstateMLIcon from "../icons/machine_learning_icons/industry_we_serve/real-estate.svg";
import socialNetworkingMLIcon from "../icons/machine_learning_icons/industry_we_serve/social-networking.svg";

// Services
import machineLearningAsAServiceIcon from "../icons/machine_learning_icons/services/machine-learning-as-a-service.svg";
import machineLearningConsultingIcon from "../icons/machine_learning_icons/services/machine-learning-consulting.svg";
import machineLearningDevelopmentIcon from "../icons/machine_learning_icons/services/machine-learning-development.svg";
import mlModelDevelopmentIcon from "../icons/machine_learning_icons/services/ml-model-development.svg";
import mlopsServicesIcon from "../icons/machine_learning_icons/services/mlops-services.svg";
import modelTrainingAndFineTuningIcon from "../icons/machine_learning_icons/services/model-training-and-fine-tuning.svg";

// Why Konstant
import businessFirstApproachMLIcon from "../icons/machine_learning_icons/why_konstant/business-first-approach.svg";
import onTimeDeliveryMLIcon from "../icons/machine_learning_icons/why_konstant/on-time-delivery.svg";
import sophisticatedTechnologyMLIcon from "../icons/machine_learning_icons/why_konstant/sophisticated-technology.svg";
import transparencyMLIcon from "../icons/machine_learning_icons/why_konstant/transparency.svg";
import trustworthyPartnerMLIcon from "../icons/machine_learning_icons/why_konstant/trustworthy-partner.svg";
import vettedProfessionalsMLIcon from "../icons/machine_learning_icons/why_konstant/vetted-professionals.svg";

// Benefits
import availability247AIAgentIcon from "../icons/ai_agent_icons/benefits/24-7-availability.svg";
import automateRepetitiveTasksAIAgentIcon from "../icons/ai_agent_icons/benefits/automate-repetitive-tasks.svg";
import costEfficiencyAIAgentIcon from "../icons/ai_agent_icons/benefits/cost-efficiency.svg";
import enhancedDecisionMakingAIAgentIcon from "../icons/ai_agent_icons/benefits/enhanced-decision-making.svg";
import scalabilityAIAgentIcon from "../icons/ai_agent_icons/benefits/scalability.svg";
import tailoredUserExperienceAIAgentIcon from "../icons/ai_agent_icons/benefits/tailored-user-experience.svg";

// Industries We Serve
import bankingAndFinanceAIAgentIcon from "../icons/ai_agent_icons/industry_we_serve/banking-and-finance.svg";
import ecommerceAIAgentIcon from "../icons/ai_agent_icons/industry_we_serve/ecommerce.svg";
import educationAIAgentIcon from "../icons/ai_agent_icons/industry_we_serve/education.svg";
import foodRestaurantAIAgentIcon from "../icons/ai_agent_icons/industry_we_serve/food-restaurant.svg";
import healthFitnessAIAgentIcon from "../icons/ai_agent_icons/industry_we_serve/health-fitness.svg";
import hospitalityTravelAIAgentIcon from "../icons/ai_agent_icons/industry_we_serve/hospitality-travel.svg";
import mediaEntertainmentAIAgentIcon from "../icons/ai_agent_icons/industry_we_serve/media-entertainment.svg";
import onDemandServicesAIAgentIcon from "../icons/ai_agent_icons/industry_we_serve/on-demand-services.svg";
import realEstateAIAgentIcon from "../icons/ai_agent_icons/industry_we_serve/real-estate.svg";
import socialNetworkingAIAgentIcon from "../icons/ai_agent_icons/industry_we_serve/social-networking.svg";

// Services
import agentBehavioralModellingAIAgentIcon from "../icons/ai_agent_icons/services/agent-behavioral-modelling.svg";
import aiAgentDeploymentAndScalabilityAIAgentIcon from "../icons/ai_agent_icons/services/ai-agent-deployment-and-scalability.svg";
import aiAgentIntegrationServicesAIAgentIcon from "../icons/ai_agent_icons/services/ai-agent-integration-services.svg";
import aiAgentOptimizationAIAgentIcon from "../icons/ai_agent_icons/services/ai-agent-optimization.svg";
import aiAgentStrategyConsultingAIAgentIcon from "../icons/ai_agent_icons/services/ai-agent-strategy-consulting.svg";
import customAiAgentDevelopmentAIAgentIcon from "../icons/ai_agent_icons/services/custom-ai-agent-development.svg";

// Why Konstant
import agenticAiExpertiseAIAgentIcon from "../icons/ai_agent_icons/why_konstant/agentic-ai-expertise.svg";
import businessOutcomeFocusAIAgentIcon from "../icons/ai_agent_icons/why_konstant/business-outcome-focus.svg";
import endToEndSolutionsAIAgentIcon from "../icons/ai_agent_icons/why_konstant/end-to-end-solutions.svg";
import fullyCustomAgentsAIAgentIcon from "../icons/ai_agent_icons/why_konstant/fully-custom-agents.svg";
import futureProofStrategyAIAgentIcon from "../icons/ai_agent_icons/why_konstant/future-proof-strategy.svg";
import scalableSolutionsAIAgentIcon from "../icons/ai_agent_icons/why_konstant/scalable-solutions.svg";

// Benefits
import consistentServiceQualityAIChatbotIcon from "../icons/ai_chatbot_icons/benefits/consistent-service-quality.svg";
import costEfficiencyAIChatbotIcon from "../icons/ai_chatbot_icons/benefits/cost-efficiency.svg";
import humanLikePersonalizationAIChatbotIcon from "../icons/ai_chatbot_icons/benefits/human-like-personalization.svg";
import realTimeResponsesAIChatbotIcon from "../icons/ai_chatbot_icons/benefits/real-time-responses.svg";
import roundTheClockAvailabilityAIChatbotIcon from "../icons/ai_chatbot_icons/benefits/round-the-clock-availability.svg";
import workflowAutomationAIChatbotIcon from "../icons/ai_chatbot_icons/benefits/workflow-automation.svg";

// Industries
import bankingAndFinanceAIChatbotIcon from "../icons/ai_chatbot_icons/industry_we_serve/banking-and-finance.svg";
import ecommerceAIChatbotIcon from "../icons/ai_chatbot_icons/industry_we_serve/ecommerce.svg";
import educationAIChatbotIcon from "../icons/ai_chatbot_icons/industry_we_serve/education.svg";
import foodRestaurantAIChatbotIcon from "../icons/ai_chatbot_icons/industry_we_serve/food-restaurant.svg";
import genericIndustryAIChatbotIcon from "../icons/ai_chatbot_icons/industry_we_serve/Frame-3.svg";
import hospitalityTravelAIChatbotIcon from "../icons/ai_chatbot_icons/industry_we_serve/hospitality-travel.svg";
import mediaEntertainmentAIChatbotIcon from "../icons/ai_chatbot_icons/industry_we_serve/media-entertainment.svg";
import onDemandServicesAIChatbotIcon from "../icons/ai_chatbot_icons/industry_we_serve/on-demand-services.svg";
import realEstateAIChatbotIcon from "../icons/ai_chatbot_icons/industry_we_serve/real-estate.svg";
import socialNetworkingAIChatbotIcon from "../icons/ai_chatbot_icons/industry_we_serve/social-networking.svg";

// Services
import aiChatbotConsultingAIChatbotIcon from "../icons/ai_chatbot_icons/services/ai-chatbot-consulting.svg";
import aiChatbotDesignAIChatbotIcon from "../icons/ai_chatbot_icons/services/ai-chatbot-design.svg";
import aiChatbotMaintenanceSupportAIChatbotIcon from "../icons/ai_chatbot_icons/services/ai-chatbot-maintenance-support.svg";
import aiChatbotTestingAIChatbotIcon from "../icons/ai_chatbot_icons/services/ai-chatbot-testing.svg";
import aiChatbotUpgradeAIChatbotIcon from "../icons/ai_chatbot_icons/services/ai-chatbot-upgrade.svg";
import customAiChatbotDevelopmentAIChatbotIcon from "../icons/ai_chatbot_icons/services/custom-ai-chatbot-development.svg";

// Why Konstant
import businessFirstApproachAIChatbotIcon from "../icons/ai_chatbot_icons/why_konstant/business-first-approach.svg";
import dynamicCustomizationAIChatbotIcon from "../icons/ai_chatbot_icons/why_konstant/dynamic-customization.svg";
import flexibleEngagementModelsAIChatbotIcon from "../icons/ai_chatbot_icons/why_konstant/flexible-engagement-models.svg";
import scalabilityAIChatbotIcon from "../icons/ai_chatbot_icons/why_konstant/scalability.svg";
import securityAIChatbotIcon from "../icons/ai_chatbot_icons/why_konstant/security.svg";
import skilledCertifiedDevelopersAIChatbotIcon from "../icons/ai_chatbot_icons/why_konstant/skilled-certified-developers.svg";
import security from "../icons/ai_chatbot_icons/why_konstant/security.svg";

import amazonLexIcon from "../icons/ai_chatbot_tech_icons/amazon-lex.svg";
import angularIcon from "../icons/ai_chatbot_tech_icons/angular.svg";
import awsIcon from "../icons/ai_chatbot_tech_icons/aws.svg";
import azureIcon from "../icons/ai_chatbot_tech_icons/azure.svg";
import djangoIcon from "../icons/ai_chatbot_tech_icons/django.svg";
import fastApiIcon from "../icons/ai_chatbot_tech_icons/fast-api.svg";
import flaskIcon from "../icons/ai_chatbot_tech_icons/flask.svg";
import gcpIcon from "../icons/ai_chatbot_tech_icons/gcp.svg";
import googleDialogflowIcon from "../icons/ai_chatbot_tech_icons/google-dialogflow.svg";
import hallucinationControlIcon from "../icons/ai_chatbot_tech_icons/hallucination-control.svg";
import ibmWatsonAssistantIcon from "../icons/ai_chatbot_tech_icons/ibm-watson-assistant.svg";
import llmsIcon from "../icons/ai_chatbot_tech_icons/llms.svg";
import microsoftBotFrameworkIcon from "../icons/ai_chatbot_tech_icons/microsoft-bot-framework.svg";
import microsoftCognitiveToolkitIcon from "../icons/ai_chatbot_tech_icons/microsoft-cognitive-toolkit.svg";
import multiChannelBotsIcon from "../icons/ai_chatbot_tech_icons/multi-channel-bots.svg";
import nodeJsIcon from "../icons/ai_chatbot_tech_icons/node-js.svg";
import promptEngineeringIcon from "../icons/ai_chatbot_tech_icons/prompt-engineering.svg";
import pythonIcon from "../icons/ai_chatbot_tech_icons/python.svg";
import pytorchIcon from "../icons/ai_chatbot_tech_icons/pytorch.svg";
import ragIcon from "../icons/ai_chatbot_tech_icons/rag.svg";
import reactIcon from "../icons/ai_chatbot_tech_icons/react.svg";
import rubyIcon from "../icons/ai_chatbot_tech_icons/ruby.svg";
import spacyIcon from "../icons/ai_chatbot_tech_icons/spacy.svg";
import tensorflowIcon from "../icons/ai_chatbot_tech_icons/tensorflow.svg";
import vectorDatabasesIcon from "../icons/ai_chatbot_tech_icons/vector-databases.svg";
import vuejsIcon from "../icons/ai_chatbot_tech_icons/vuejs.svg";

import aFrameIcon from "../icons/vr_development_tech_icons/a_frame.svg";
import babylonjsIcon from "../icons/vr_development_tech_icons/babylonjs.svg";
import cPlusPlusIcon from "../icons/vr_development_tech_icons/c_plus_plus.svg";
import cSharpIcon from "../icons/vr_development_tech_icons/c_sharp.svg";
import firebaseIcon from "../icons/vr_development_tech_icons/firebase.svg";
import godotIcon from "../icons/vr_development_tech_icons/godot.svg";
import javascriptIcon from "../icons/vr_development_tech_icons/javascript.svg";
import metaQuestDkIcon from "../icons/vr_development_tech_icons/meta_quest_dk.svg";
import openxrIcon from "../icons/vr_development_tech_icons/openxr.svg";
import react360Icon from "../icons/vr_development_tech_icons/react_360.svg";
import steamvrIcon from "../icons/vr_development_tech_icons/steamvr.svg";
import threeJsIcon from "../icons/vr_development_tech_icons/three-js.svg";
import unityIcon from "../icons/vr_development_tech_icons/unity.svg";
import unrealEngineIcon from "../icons/vr_development_tech_icons/unreal_engine.svg";

import arcoreIcon from "../icons/ar_development_tech_icons/arcore.svg";
import arkitIcon from "../icons/ar_development_tech_icons/arkit.svg";
import artoolkitIcon from "../icons/ar_development_tech_icons/artoolkit.svg";
import googleCloudIcon from "../icons/ar_development_tech_icons/google-cloud.svg";
import kotlinIcon from "../icons/ar_development_tech_icons/kotlin.svg";
import maxstIcon from "../icons/ar_development_tech_icons/maxst.svg";
import swiftIcon from "../icons/ar_development_tech_icons/swift.svg";
import vueJsIcon from "../icons/ar_development_tech_icons/vue-js.svg";
import vuforiaIcon from "../icons/ar_development_tech_icons/vuforia.svg";
import webarIcon from "../icons/ar_development_tech_icons/webar.svg";
import wikitudeIcon from "../icons/ar_development_tech_icons/wikitude.svg";

import agentWorkflowsIcon from "../icons/generative_ai_tech_icons/agent-workflows.svg";
import claudeIcon from "../icons/generative_ai_tech_icons/claude.svg";
import dockerIcon from "../icons/generative_ai_tech_icons/docker.svg";
import faissIcon from "../icons/generative_ai_tech_icons/faiss.svg";
import geminiIcon from "../icons/generative_ai_tech_icons/gemini.svg";
import gpt45Gpt4oIcon from "../icons/generative_ai_tech_icons/gpt-4-5-gpt-4o.svg";
import kerasIcon from "../icons/generative_ai_tech_icons/keras.svg";
import langChainIcon from "../icons/generative_ai_tech_icons/lang-chain.svg";
import langChainTechIcon from "../icons/ai_case_study_icons/lang-chain-tech.svg";
import ragTechIcon from "../icons/ai_case_study_icons/rag-icon.svg";
import semanticVectorIcon from "../icons/ai_case_study_icons/semantic-vector-icon.svg";
import openAiImageIcon from "../icons/ai_case_study_icons/open-ai-image-icon.svg";
import stabilityAiIcon from "../icons/ai_case_study_icons/stability-ai-icon.svg";
import awsS3Icon from "../icons/ai_case_study_icons/aws-s3-icon.svg";
import awsEc2Icon from "../icons/ai_case_study_icons/aws-ec2-icon.svg";
import awsRdsIcon from "../icons/ai_case_study_icons/aws-rds-icon.svg";
import awsCloudFrontIcon from "../icons/ai_case_study_icons/aws-cloudfront-icon.svg";
import cdnAssetIcon from "../icons/ai_case_study_icons/cdn-asset-icon.svg";
import restApiIcon from "../icons/ai_case_study_icons/rest-api-icon.svg";
import kafkaIcon from "../icons/ai_case_study_icons/kafka-icon.svg";
import ebayApiIcon from "../icons/ai_case_study_icons/ebay-api-icon.svg";
import amazonPrdouctIcon from "../icons/ai_case_study_icons/amazon-product-api.svg";
import secureTokenIcon from "../icons/ai_case_study_icons/secure-token-icon.svg";
import backgroundJobIcon from "../icons/ai_case_study_icons/background-job-icon.svg";
import deepSeekIcon from "../icons/ai_case_study_icons/deep-seek-icon.svg";
import recruitWorkflowIcon from "../icons/ai_case_study_icons/recruit-workflow-icon.svg";
import aiCandidateIcon from "../icons/ai_case_study_icons/ai-candidate-icon.svg";
import semanticSearchIcon from "../icons/ai_case_study_icons/semantic-search-icon.svg";
import convIcon from "../icons/ai_case_study_icons/conv-ai-icon.svg";
import ciCdIcon from "../icons/ai_case_study_icons/ci-cd-icon.svg";
import stripeIcon from "../icons/ai_case_study_icons/stripe-icon.svg";
import twilioIcon from "../icons/ai_case_study_icons/twilio-icon.svg";
import rocketReachIcon from "../icons/ai_case_study_icons/rocket-reach-icon.svg";
import mariaDbIcon from "../icons/ai_case_study_icons/maria-db-icon.svg";
import otpAuthIcon from "../icons/ai_case_study_icons/otp-auth-icon.svg";
import roleBasedIcon from "../icons/ai_case_study_icons/role-based-icon.svg";
import apiSecurityIcon from "../icons/ai_case_study_icons/api-security-icon.svg";
import aiSeoIcon from "../icons/ai_case_study_icons/ai-seo-icon.svg";
import promptIcon from "../icons/ai_case_study_icons/prompt-icon.svg";
import automatedInsightIcon from "../icons/ai_case_study_icons/automated-insight-icon.svg";
import pandasIcon from "../icons/ai_case_study_icons/pandas-icon.svg";
import grokIcon from "../icons/ai_case_study_icons/grok-icon.svg";
import whatsappBusinessIcon from "../icons/ai_case_study_icons/whatsapp-business-icon.svg";
import typescriptIcon from "../icons/ai_case_study_icons/typescript-icon.svg";
import rechartsIcon from "../icons/ai_case_study_icons/recharts-icon.svg";
import llamaIndexIcon from "../icons/generative_ai_tech_icons/llama-index.svg";
import llamaIcon from "../icons/generative_ai_tech_icons/llama.svg";
import memoryReasoningChainsIcon from "../icons/generative_ai_tech_icons/memory-reasoning-chains.svg";
import mistralIcon from "../icons/generative_ai_tech_icons/mistral.svg";
import opensearchIcon from "../icons/generative_ai_tech_icons/opensearch.svg";
import pineconeIcon from "../icons/generative_ai_tech_icons/pinecone.svg";
import qdrantIcon from "../icons/generative_ai_tech_icons/qdrant.svg";
import toolCallingIcon from "../icons/generative_ai_tech_icons/tool-calling.svg";
import weaviateIcon from "../icons/generative_ai_tech_icons/weaviate.svg";

import earlyUserFeedbackLoopsIcon from "../icons/mvp_tech_icons/early-user-feedback-loops.svg";
import expressJsIcon from "../icons/mvp_tech_icons/express-js.svg";
import featurePrioritizationIcon from "../icons/mvp_tech_icons/feature-prioritization.svg";
import flutterIcon from "../icons/mvp_tech_icons/flutter.svg";
import githubIcon from "../icons/mvp_tech_icons/github.svg";
import iterativeReleasesIcon from "../icons/mvp_tech_icons/Iterative-releases.svg";
import mongodbIcon from "../icons/mvp_tech_icons/mongodb.svg";
import mvpDeliveryIcon from "../icons/mvp_tech_icons/mvp-delivery.svg";
import nestjsIcon from "../icons/mvp_tech_icons/nestjs.svg";
import nextJsIcon from "../icons/mvp_tech_icons/next-js.svg";
import postgresqlIcon from "../icons/mvp_tech_icons/postgresql.svg";
import rapidPrototypingIcon from "../icons/mvp_tech_icons/rapid-prototyping.svg";
import rasaIcon from "../icons/mvp_tech_icons/rasa.svg";
import reactJsIcon from "../icons/mvp_tech_icons/react-js.svg";
import reactNativeIcon from "../icons/mvp_tech_icons/react-native.svg";

import dotNetCoreIcon from "../icons/enterprise_app-tech_icons/.net-core.svg";
import erpCrmIntegrationIcon from "../icons/enterprise_app-tech_icons/erp-crm-integration.svg";
import javaIcon from "../icons/enterprise_app-tech_icons/java.svg";
import kubernetesIcon from "../icons/enterprise_app-tech_icons/kubernetes.svg";
import legacySystemConnectivityIcon from "../icons/enterprise_app-tech_icons/legacy-system-connectivity.svg";
import mysqlIcon from "../icons/enterprise_app-tech_icons/mysql.svg";
import restApisIcon from "../icons/enterprise_app-tech_icons/rest-apis.svg";
import thirdPartySystemIntegrationIcon from "../icons/enterprise_app-tech_icons/third-party-system-integration.svg";

import customFitnessAppDevelopment from "../icons/fitness_app_development_icons/services/custom-fitness-app-development.svg";
import fitnessAppConsulting from "../icons/fitness_app_development_icons/services/fitness-app-consulting.svg";
import fitnessAppModernization from "../icons/fitness_app_development_icons/services/fitness-app-modernization.svg";
import fitnessAppTesting from "../icons/fitness_app_development_icons/services/fitness-app-testing.svg";
import fitnessAppUiUxDesign from "../icons/fitness_app_development_icons/services/fitness-app-ui-ux-design.svg";
import fitnessWebsiteDevelopment from "../icons/fitness_app_development_icons/services/fitness-website-development.svg";

import advancedTechnology from "../icons/fitness_app_development_icons/why_konstant/advanced-technology.svg";
import costEffective from "../icons/fitness_app_development_icons/why_konstant/cost-effective.svg";
import endToEndSupport from "../icons/fitness_app_development_icons/why_konstant/end-to-end-support.svg";
import expertise from "../icons/fitness_app_development_icons/why_konstant/expertise.svg";
import onTimeDelivery from "../icons/fitness_app_development_icons/why_konstant/on-time-delivery.svg";
import scalableSolutions from "../icons/fitness_app_development_icons/why_konstant/scalable-solutions.svg";

import crossPlatformSocialMediaApp from "../icons/social_media_app_development_icons/services/cross-platform-social-media-app.svg";
import customSocialMediaApp from "../icons/social_media_app_development_icons/services/custom-social-media-app.svg";
import socialMediaAppMaintenance from "../icons/social_media_app_development_icons/services/social-media-app-maintenance.svg";
import socialMediaAppTesting from "../icons/social_media_app_development_icons/services/social-media-app-testing.svg";
import socialMediaAppUiUxDesign from "../icons/social_media_app_development_icons/services/social-media-app-ui-ux-design.svg";
import socialMediaAppUpgradation from "../icons/social_media_app_development_icons/services/social-media-app-upgradation.svg";

import clientCentricApproach from "../icons/social_media_app_development_icons/why_konstant/client-centric-approach.svg";
import creativity from "../icons/social_media_app_development_icons/why_konstant/creativity.svg";
import crossPlatformExpertise from "../icons/social_media_app_development_icons/why_konstant/cross-platform-expertise.svg";
import cuttingEdgeTechnologies from "../icons/social_media_app_development_icons/why_konstant/cutting-edge-technologies.svg";
import supportMonitoring from "../icons/social_media_app_development_icons/why_konstant/support-monitoring.svg";
import transparentCommunication from "../icons/social_media_app_development_icons/why_konstant/transparent-communication.svg";

import collaborativeCare from "../icons/telemedicine_app_development_icons/benefits/collaborative-care.svg";
import confidentiality from "../icons/telemedicine_app_development_icons/benefits/confidentiality.svg";
import reducedHealthcareCosts from "../icons/telemedicine_app_development_icons/benefits/reduced-healthcare-costs.svg";
import timeManagement from "../icons/telemedicine_app_development_icons/benefits/time-management.svg";
import widespreadReach from "../icons/telemedicine_app_development_icons/benefits/widespread-reach.svg";
import workOptimization from "../icons/telemedicine_app_development_icons/benefits/work-optimization.svg";

import dermatologyTelemedicine from "../icons/telemedicine_app_development_icons/solutions/dermatology-telemedicine.svg";
import neurologyTelemedicine from "../icons/telemedicine_app_development_icons/solutions/neurology-telemedicine.svg";
import pediatricsTelemedicine from "../icons/telemedicine_app_development_icons/solutions/pediatrics-telemedicine.svg";
import primaryCareTelemedicine from "../icons/telemedicine_app_development_icons/solutions/primary-care-telemedicine.svg";
import storeAndForwardSystems from "../icons/telemedicine_app_development_icons/solutions/store-and-forward-systems.svg";
import teleicuSystems from "../icons/telemedicine_app_development_icons/solutions/teleicu-systems.svg";

import agileDevelopmentApproach from "../icons/telemedicine_app_development_icons/why_konstant/agile-development-approach.svg";
import dedicatedDevelopers from "../icons/telemedicine_app_development_icons/why_konstant/dedicated-developers.svg";
import domainKnowledge from "../icons/telemedicine_app_development_icons/why_konstant/domain-knowledge.svg";
import innovativeSolutions from "../icons/telemedicine_app_development_icons/why_konstant/innovative-solutions.svg";
import regulatoryCompliance from "../icons/telemedicine_app_development_icons/why_konstant/regulatory-compliance.svg";
import securityFirstApproach from "../icons/telemedicine_app_development_icons/why_konstant/security-first-approach.svg";

import brandLoyalty from "../icons/music_streaming_app_development_icons/benefits/brand-loyalty.svg";
import collaborations from "../icons/music_streaming_app_development_icons/benefits/collaborations.svg";
import crossPromotionSynergies from "../icons/music_streaming_app_development_icons/benefits/cross-promotion-synergies.svg";
import dataMonetization from "../icons/music_streaming_app_development_icons/benefits/data-monetization.svg";
import universalReach from "../icons/music_streaming_app_development_icons/benefits/universal-reach.svg";
import userRetention from "../icons/music_streaming_app_development_icons/benefits/user-retention.svg";

import audiobookApps from "../icons/music_streaming_app_development_icons/solutions/audiobook-apps.svg";
import karaokeApps from "../icons/music_streaming_app_development_icons/solutions/karaoke-apps.svg";
import liveMusicStreamingApps from "../icons/music_streaming_app_development_icons/solutions/live-music-streaming-apps.svg";
import podcastApps from "../icons/music_streaming_app_development_icons/solutions/podcast-apps.svg";
import radioStationApps from "../icons/music_streaming_app_development_icons/solutions/radio-station-apps.svg";
import socialMusicApps from "../icons/music_streaming_app_development_icons/solutions/social-music-apps.svg";

import domainExpertise from "../icons/music_streaming_app_development_icons/why_konstant/domain-expertise.svg";
import flexibleEngagementModels from "../icons/music_streaming_app_development_icons/why_konstant/flexible-engagement-models.svg";
import fluentCommunication from "../icons/music_streaming_app_development_icons/why_konstant/fluent-communication.svg";
import globalClientele from "../icons/music_streaming_app_development_icons/why_konstant/global-clientele.svg";
import signNda from "../icons/music_streaming_app_development_icons/why_konstant/sign-nda.svg";
import updatedWithLatestTrends from "../icons/music_streaming_app_development_icons/why_konstant/updated-with-latest-trends.svg";

import automatingRoutineTasksIcon from "../icons/computer_vision_icons/benefits/automating-routine-tasks.svg";
import costReductionIcon from "../icons/computer_vision_icons/benefits/cost-reduction.svg";
import enhancedCustomerExperiencesComputerVisionIcon from "../icons/computer_vision_icons/benefits/enhanced-customer-experiences.svg";
import increasedEfficiencyIcon from "../icons/computer_vision_icons/benefits/increased-efficiency.svg";
import qualityControlIcon from "../icons/computer_vision_icons/benefits/quality-control.svg";
import riskMitigationComputerVisionIcon from "../icons/computer_vision_icons/benefits/risk-mitigation.svg";

import bankingAndFinanceComputerVisionIcon from "../icons/computer_vision_icons/industry we serve/banking-and-finance.svg";
import ecommerceComputerVisionIcon from "../icons/computer_vision_icons/industry we serve/ecommerce.svg";
import educationComputerVisionIcon from "../icons/computer_vision_icons/industry we serve/education.svg";
import foodRestaurantComputerVisionIcon from "../icons/computer_vision_icons/industry we serve/food-restaurant.svg";
import healthFitnessComputerVisionIcon from "../icons/computer_vision_icons/industry we serve/health-fitness.svg";
import hospitalityTravelComputerVisionIcon from "../icons/computer_vision_icons/industry we serve/hospitality-travel.svg";
import mediaEntertainmentComputerVisionIcon from "../icons/computer_vision_icons/industry we serve/media-entertainment.svg";
import onDemandServicesComputerVisionIcon from "../icons/computer_vision_icons/industry we serve/on-demand-services.svg";
import realEstateComputerVisionIcon from "../icons/computer_vision_icons/industry we serve/real-estate.svg";
import socialNetworkingComputerVisionIcon from "../icons/computer_vision_icons/industry we serve/social-networking.svg";

import aiBasedImageRecognitionIcon from "../icons/computer_vision_icons/services/ai-based-image-recognition.svg";
import computerVisionConsultingServicesIcon from "../icons/computer_vision_icons/services/computer-vision-consulting-services.svg";
import computerVisionDataServicesIcon from "../icons/computer_vision_icons/services/computer-vision-data-services.svg";
import computerVisionSystemIntegrationIcon from "../icons/computer_vision_icons/services/computer-vision-system-integration.svg";
import customComputerVisionDevelopmentIcon from "../icons/computer_vision_icons/services/custom-computer-vision-development.svg";
import facialRecognitionIcon from "../icons/computer_vision_icons/services/facial-recognition.svg";
import modelDesignAndOptimizationIcon from "../icons/computer_vision_icons/services/model-design-and-optimization.svg";

import customizedDevelopmentIcon from "../icons/computer_vision_icons/why konstant/customized-development.svg";
import flexibleEngagementModelsIcon from "../icons/computer_vision_icons/why konstant/flexible-engagement-models.svg";
import industrySpecificSolutionsIcon from "../icons/computer_vision_icons/why konstant/industry-specific-solutions.svg";
import provenExpertiseComputerVisionIcon from "../icons/computer_vision_icons/why konstant/proven-expertise.svg";
import technicalExcellenceIcon from "../icons/computer_vision_icons/why konstant/technical-excellence.svg";
import transparentCommunicationComputerVisionIcon from "../icons/computer_vision_icons/why konstant/transparent-communication.svg";

import brandLoyaltyIcon from "../icons/liquor_icons/benefits/brand-loyalty.svg";
import enhancedShoppingExperienceIcon from "../icons/liquor_icons/benefits/enhanced-shopping-experience.svg";
import highDemhighDemandandIcon from "../icons/liquor_icons/benefits/High Demhigh-demandand.svg";
import improvedSupportIcon from "../icons/liquor_icons/benefits/improved-support.svg";
import stayingCompetitiveIcon from "../icons/liquor_icons/benefits/staying-competitive.svg";
import targetedPromotionsIcon from "../icons/liquor_icons/benefits/targeted-promotions.svg";

import barsPubsIcon from "../icons/liquor_icons/solutions/bars-pubs.svg";
import breweryDistilleryIcon from "../icons/liquor_icons/solutions/brewery-distillery.svg";
import liquorAggregatorPlatformsIcon from "../icons/liquor_icons/solutions/liquor-aggregator-platforms.svg";
import liquorChainIcon from "../icons/liquor_icons/solutions/liquor-chain.svg";
import liquorDeliveryServicesIcon from "../icons/liquor_icons/solutions/liquor-delivery-services.svg";
import wineShopsIcon from "../icons/liquor_icons/solutions/wine-shops.svg";

import comprehensiveFeaturesLiquorIcon from "../icons/liquor_icons/why_konstant/comprehensive-features.svg";
import customizedSolutionsLiquorIcon from "../icons/liquor_icons/why_konstant/customized-solutions.svg";
import endToEndSupportIcon from "../icons/liquor_icons/why_konstant/end-to-end-support.svg";
import provenExpertiseLiquorIcon from "../icons/liquor_icons/why_konstant/proven-expertise.svg";
import scalabilityLiquorIcon from "../icons/liquor_icons/why_konstant/scalability.svg";
import transparencyLiquorIcon from "../icons/liquor_icons/why_konstant/transparency.svg";

import convenienceIcon from "../icons/fuel_delivery_icons/benefits/convenience.svg";
import costEfficiencyIcon from "../icons/fuel_delivery_icons/benefits/cost-efficiency.svg";
import ecoFriendlyIcon from "../icons/fuel_delivery_icons/benefits/eco-friendly.svg";
import highQualityFuelIcon from "../icons/fuel_delivery_icons/benefits/high-quality-fuel.svg";
import lowMaintenanceIcon from "../icons/fuel_delivery_icons/benefits/low-maintenance.svg";
import supportDuringEmergenciesIcon from "../icons/fuel_delivery_icons/benefits/support-during-emergencies.svg";

import carRefuelingAppIcon from "../icons/fuel_delivery_icons/solutions/car-refueling-app.svg";
import emergencyFuelDeliveryAppIcon from "../icons/fuel_delivery_icons/solutions/emergency-fuel-delivery-app.svg";
import fuelDeliveryAggregatorsIcon from "../icons/fuel_delivery_icons/solutions/fuel-delivery-aggregators.svg";
import fuelPriceComparisonAppIcon from "../icons/fuel_delivery_icons/solutions/fuel-price-comparison-app.svg";
import fuelStationOwnersIcon from "../icons/fuel_delivery_icons/solutions/fuel-station-owners.svg";
import oilAndGasCompaniesIcon from "../icons/fuel_delivery_icons/solutions/oil-and-gas-companies.svg";

import support24x7TechnicalIcon from "../icons/fuel_delivery_icons/why_konstant/technical-support.svg";
import advancedTechnologyIcon from "../icons/fuel_delivery_icons/why_konstant/advanced-technology.svg";
import postLaunchSupportIcon from "../icons/fuel_delivery_icons/why_konstant/post-launch-support.svg";
import qualityDevelopmentIcon from "../icons/fuel_delivery_icons/why_konstant/quality-development.svg";
import scalableSolutionsFuelDeliveryIcon from "../icons/fuel_delivery_icons/why_konstant/scalable-solutions.svg";
import transparentCommunicationFuelDeliveryIcon from "../icons/fuel_delivery_icons/why_konstant/transparent-communication.svg";

import complianceAndSecurityIcon from "../icons/doctors_on_demand_icons/benefits/compliance-and-security.svg";
import costTimeSavingsIcon from "../icons/doctors_on_demand_icons/benefits/cost-time-savings.svg";
import highPatientEngagementIcon from "../icons/doctors_on_demand_icons/benefits/high-patient-engagement.svg";
import improvesEfficiencyIcon from "../icons/doctors_on_demand_icons/benefits/improves-efficiency.svg";
import increasedRevenueIcon from "../icons/doctors_on_demand_icons/benefits/increased-revenue.svg";
import increasedSatisfactionIcon from "../icons/doctors_on_demand_icons/benefits/increased-satisfaction.svg";

import liveVideoConsultationAppsIcon from "../icons/doctors_on_demand_icons/solutions/live-video-consultation-apps.svg";
import medicationManagementAppsIcon from "../icons/doctors_on_demand_icons/solutions/medication-management-apps.svg";
import mentalHealthAppsIcon from "../icons/doctors_on_demand_icons/solutions/mental-health-apps.svg";
import remotePatientMonitoringAppsIcon from "../icons/doctors_on_demand_icons/solutions/remote-patient-monitoring-apps.svg";
import specialtyAppsIcon from "../icons/doctors_on_demand_icons/solutions/specialty-apps.svg";
import symptomCheckerAppsIcon from "../icons/doctors_on_demand_icons/solutions/symptom-checker-apps.svg";

import dataSecurityAndComplianceIcon from "../icons/doctors_on_demand_icons/why_konstant/data-security-and-compliance.svg";
import experiencedTeamIcon from "../icons/doctors_on_demand_icons/why_konstant/experienced-team.svg";
import scalableFeaturesIcon from "../icons/doctors_on_demand_icons/why_konstant/scalable-features.svg";
import supportAndMaintenanceIcon from "../icons/doctors_on_demand_icons/why_konstant/support-and-maintenance.svg";
import thirdPartyIntegrationsIcon from "../icons/doctors_on_demand_icons/why_konstant/third-party-integrations.svg";
import userFriendlyExperienceIcon from "../icons/doctors_on_demand_icons/why_konstant/user-friendly-experience.svg";

import agriculture from "../icons/industries_we_serve_icons/agriculture.svg";
import education from "../icons/industries_we_serve_icons/education.svg";
import eventTickets from "../icons/industries_we_serve_icons/event-tickets.svg";
import fitness from "../icons/industries_we_serve_icons/fitness.svg";
import gameDevelopment from "../icons/industries_we_serve_icons/game-development.svg";
import healthcare from "../icons/industries_we_serve_icons/healthcare.svg";
import hospitalityTravel from "../icons/industries_we_serve_icons/hospitality-travel.svg";
import insurance from "../icons/industries_we_serve_icons/insurance.svg";
import logistics from "../icons/industries_we_serve_icons/logistics.svg";
import mediaEntertainment from "../icons/industries_we_serve_icons/media-entertainment.svg";
import oilAndGas from "../icons/industries_we_serve_icons/oil-and-gas.svg";
import socialNetworking from "../icons/industries_we_serve_icons/social-networking.svg";
import sports from "../icons/industries_we_serve_icons/sports.svg";
import transportationAutomotive from "../icons/industries_we_serve_icons/transportation-automotive.svg";

import cloudNativeSolutionDevelopmentIcon from "../icons/google_cloud_platform_icons/services/cloud-native-solution-development.svg";
import cloudSecurityServicesIcon from "../icons/google_cloud_platform_icons/services/cloud-security-services.svg";
import gcpDataAndAnalyticsIcon from "../icons/google_cloud_platform_icons/services/gcp-data-and-analytics.svg";
import googleCloudMigrationServicesIcon from "../icons/google_cloud_platform_icons/services/google-cloud-migration-services.svg";
import googleCloudStrategyIcon from "../icons/google_cloud_platform_icons/services/google-cloud-strategy.svg";
import infrastructureManagementIcon from "../icons/google_cloud_platform_icons/services/infrastructure-management.svg";

import automaticBackupsIcon from "../icons/google_cloud_platform_icons/why_gcp/automatic-backups.svg";
import communitySupportIcon from "../icons/google_cloud_platform_icons/why_gcp/community-support.svg";
import costEffectiveGCPIcon from "../icons/google_cloud_platform_icons/why_gcp/cost-effective.svg";
import flexibleIcon from "../icons/google_cloud_platform_icons/why_gcp/flexible.svg";
import improvedPerformanceIcon from "../icons/google_cloud_platform_icons/why_gcp/improved-performance.svg";
import secureIcon from "../icons/google_cloud_platform_icons/why_gcp/secure.svg";

import agileApproachIcon from "../icons/google_cloud_platform_icons/why_konstant/agile-approach.svg";
import complianceAndSecurityGCPIcon from "../icons/google_cloud_platform_icons/why_konstant/compliance-and-security.svg";
import costEfficientSupportIcon from "../icons/google_cloud_platform_icons/why_konstant/cost-efficient-support.svg";
import endToEndConsultingIcon from "../icons/google_cloud_platform_icons/why_konstant/end-to-end-consulting.svg";
import industryExpertiseIcon from "../icons/google_cloud_platform_icons/why_konstant/industry-expertise.svg";
import proactiveSupportIcon from "../icons/google_cloud_platform_icons/why_konstant/proactive-support.svg";

import odooAppDevelopment from "../icons/odoo_development_services_icons/services/odoo-app-development.svg";
import odooAppUiUxDesign from "../icons/odoo_development_services_icons/services/odoo-app-ui-ux-design.svg";
import odooCustomizationIntegration from "../icons/odoo_development_services_icons/services/odoo-customization-integration.svg";
import odooModuleDevelopment from "../icons/odoo_development_services_icons/services/odoo-module-development.svg";
import odooStoreDevelopment from "../icons/odoo_development_services_icons/services/odoo-store-development.svg";
import odooThemeDevelopment from "../icons/odoo_development_services_icons/services/odoo-theme-development.svg";
import odooWebsiteDevelopment from "../icons/odoo_development_services_icons/services/odoo-website-development.svg";

import betterBusinessOutput from "../icons/odoo_development_services_icons/why_konstant/better-business-output.svg";
import odooCostAffordability from "../icons/odoo_development_services_icons/why_konstant/cost-affordability.svg";
import odooOpenSourcePlatform from "../icons/odoo_development_services_icons/why_konstant/open-source-platform.svg";
import odooPreExistedScalability from "../icons/odoo_development_services_icons/why_konstant/pre-existed-scalability.svg";
import odooRobustArchitecture from "../icons/odoo_development_services_icons/why_konstant/robust-architecture.svg";
import odooUpdatedTechnology from "../icons/odoo_development_services_icons/why_konstant/updated-technology.svg";

import odooCostEffective from "../icons/odoo_development_services_icons/why_odoo/cost-effective.svg";
import deliveryDeadline from "../icons/odoo_development_services_icons/why_odoo/delivery-deadline.svg";
import easyCustomization from "../icons/odoo_development_services_icons/why_odoo/easy-customization.svg";
import longTermSupport from "../icons/odoo_development_services_icons/why_odoo/long-term-support.svg";
import odooExperts from "../icons/odoo_development_services_icons/why_odoo/odoo-experts.svg";
import personalizedConsulting from "../icons/odoo_development_services_icons/why_odoo/personalized-consulting.svg";

import awsCloudApplicationServices from "../icons/aws_consulting_services_icons/services/aws-cloud-application-services.svg";
import awsCloudConsulting from "../icons/aws_consulting_services_icons/services/aws-cloud-consulting.svg";
import awsCloudMigration from "../icons/aws_consulting_services_icons/services/aws-cloud-migration.svg";
import awsCostOptimization from "../icons/aws_consulting_services_icons/services/aws-cost-optimization.svg";
import awsDataAnalyticsServices from "../icons/aws_consulting_services_icons/services/aws-data-analytics-services.svg";
import awsManagedServices from "../icons/aws_consulting_services_icons/services/aws-managed-services.svg";
import awsSolutionDevelopment from "../icons/aws_consulting_services_icons/services/aws-solution-development.svg";

import advancedTechnologies from "../icons/aws_consulting_services_icons/why_aws/advanced-technologies.svg";
import costEffectiveSolutions from "../icons/aws_consulting_services_icons/why_aws/cost-effective-solutions.svg";
import enhancedSecurity from "../icons/aws_consulting_services_icons/why_aws/enhanced-security.svg";
import globalAvailability from "../icons/aws_consulting_services_icons/why_aws/global-availability.svg";
import industryLeadingPerformance from "../icons/aws_consulting_services_icons/why_aws/industry-leading-performance.svg";
import sustainabilityInitiatives from "../icons/aws_consulting_services_icons/why_aws/sustainability-initiatives.svg";

import continuousSupport from "../icons/aws_consulting_services_icons/why_konstant/continuous-support.svg";
import highSecurity from "../icons/aws_consulting_services_icons/why_konstant/high-security.svg";
import holisticEngagement from "../icons/aws_consulting_services_icons/why_konstant/holistic-engagement.svg";
import seamlessMigration from "../icons/aws_consulting_services_icons/why_konstant/seamless-migration.svg";
import successFocused from "../icons/aws_consulting_services_icons/why_konstant/success-focused.svg";
import tailoredCertifiedProfessionals from "../icons/aws_consulting_services_icons/why_konstant/tailored-certified-professionals.svg";

import betterGrowth from "../icons/chat_messaging_app_development_icons/benefit/better-growth.svg";
import competitiveAdvantage from "../icons/chat_messaging_app_development_icons/benefit/competitive-advantage.svg";
import greatBusinessOpportunity from "../icons/chat_messaging_app_development_icons/benefit/great-business-opportunity.svg";
import increasedUserEngagement from "../icons/chat_messaging_app_development_icons/benefit/increased-user-engagement.svg";
import loyalUserBase from "../icons/chat_messaging_app_development_icons/benefit/loyal-user-base.svg";
import stayUpdated from "../icons/chat_messaging_app_development_icons/benefit/stay-updated.svg";

import businessMessagingApps from "../icons/chat_messaging_app_development_icons/solutions/business-messaging-apps.svg";
import datingMessagingApps from "../icons/chat_messaging_app_development_icons/solutions/dating-messaging-apps.svg";
import personalMessagingApps from "../icons/chat_messaging_app_development_icons/solutions/personal-messaging-apps.svg";
import socialMediaMessagingApps from "../icons/chat_messaging_app_development_icons/solutions/social-media-messaging-apps.svg";
import teamCollaborationApps from "../icons/chat_messaging_app_development_icons/solutions/team-collaboration-apps.svg";

import chatCustomizedSolutions from "../icons/chat_messaging_app_development_icons/why_konstant/customized-solutions.svg";
import cuttingEdgeTechnology from "../icons/chat_messaging_app_development_icons/why_konstant/cutting-edge-technology.svg";
import endToEndService from "../icons/chat_messaging_app_development_icons/why_konstant/end-to-end-service.svg";
import chatExpertise from "../icons/chat_messaging_app_development_icons/why_konstant/expertise.svg";
import chatProvenTrackRecord from "../icons/chat_messaging_app_development_icons/why_konstant/proven-track-record.svg";
import chatUserCentricDesign from "../icons/chat_messaging_app_development_icons/why_konstant/user-centric-design.svg";

import betterCustomerConnections from "../icons/directory_app_development_icons/benefit/better-customer-connections.svg";
import efficientBusinessManagement from "../icons/directory_app_development_icons/benefit/efficient-business-management.svg";
import improvedDiscovery from "../icons/directory_app_development_icons/benefit/improved-discovery.svg";
import multiplePlatformsAccess from "../icons/directory_app_development_icons/benefit/multiple-platforms-access.svg";
import scalableRevenue from "../icons/directory_app_development_icons/benefit/scalable-revenue.svg";
import strongerCustomerEngagement from "../icons/directory_app_development_icons/benefit/stronger-customer-engagement.svg";

import businessListingDirectory from "../icons/directory_app_development_icons/solutions/business-listing-directory.svg";
import enterpriseDirectoryApplications from "../icons/directory_app_development_icons/solutions/enterprise-directory-applications.svg";
import locationBasedDirectories from "../icons/directory_app_development_icons/solutions/location-based-directories.svg";
import membershipDirectoriesApplications from "../icons/directory_app_development_icons/solutions/membership-directories-applications.svg";
import mobilePhoneDirectory from "../icons/directory_app_development_icons/solutions/mobile-phone-directory.svg";
import restaurantDirectoryApplications from "../icons/directory_app_development_icons/solutions/restaurant-directory-applications.svg";

import customSolutions from "../icons/directory_app_development_icons/why_konstant/custom-solutions.svg";
import extensiveSupport from "../icons/directory_app_development_icons/why_konstant/extensive-support.svg";
import directoryHighQuality from "../icons/directory_app_development_icons/why_konstant/high-quality.svg";
import infrastructuralSecurity from "../icons/directory_app_development_icons/why_konstant/infrastructural-security.svg";
import modernTechnologies from "../icons/directory_app_development_icons/why_konstant/modern-technologies.svg";
import multichannelApproach from "../icons/directory_app_development_icons/why_konstant/multichannel-approach.svg";

//event app development (services)
import customEventAppDevelopment from "../icons/event_app_development_icons/services/custom-event-app-development.svg";
import eventAppConsultation from "../icons/event_app_development_icons/services/event-app-consultation.svg";
import eventAppDesign from "../icons/event_app_development_icons/services/event-app-design.svg";
import eventAppMaintenanceSupport from "../icons/event_app_development_icons/services/event-app-maintenance-support.svg";
import eventTicketAppDevelopment from "../icons/event_app_development_icons/services/event-ticket-app-development.svg";
import hireEventAppDevelopers from "../icons/event_app_development_icons/services/hire-event-app-developers.svg";

//event app development (why konstant)
import Support from "../icons/event_app_development_icons/why_konstant/24-7-support.svg";
import agileMethodology from "../icons/event_app_development_icons/why_konstant/agile-methodology.svg";
import crossPlatformCompatibility from "../icons/event_app_development_icons/why_konstant/cross-platform-compatibility.svg";
import customizedSolutions from "../icons/event_app_development_icons/why_konstant/customized-solutions.svg";
import provenExpertise from "../icons/event_app_development_icons/why_konstant/proven-expertise.svg";
import realTimeAnalytics from "../icons/event_app_development_icons/why_konstant/real-time-analytics.svg";

//Game App Developememt Icon
import service2D3D from "../icons/game_app_development_icons/services/2d-3d-game-app-development.svg";
import serviceAndroidGame from "../icons/game_app_development_icons/services/android-game-development.svg";
import serviceCrossPlatform from "../icons/game_app_development_icons/services/cross-platform-development.svg";
import serviceFullCycle from "../icons/game_app_development_icons/services/full-cycle-game-development.svg";
import serviceIosGame from "../icons/game_app_development_icons/services/ios-game-app-development.svg";
import serviceWebGame from "../icons/game_app_development_icons/services/web-game-development.svg";
//Game App Developememt Image
import whyAdvanceMone from "../icons/game_app_development_icons/why_konstant/advanced-monetization.svg";
import whyCoDevelopment from "../icons/game_app_development_icons/why_konstant/co-development-excellence.svg";
import whyCuttingEdge from "../icons/game_app_development_icons/why_konstant/cutting-edge-technology.svg";
import whyDynamicRetention from "../icons/game_app_development_icons/why_konstant/dynamic-retention.svg";
import whyHighQualit from "../icons/game_app_development_icons/why_konstant/high-quality.svg";
import whyIndustryExpertise from "../icons/game_app_development_icons/why_konstant/industry-expertise.svg";
//Transport App Developement Icon
import serviceCustomGood from "../icons/transportation-app-development_icons/services/custom-goods-transport-app.svg";
import serviceHireTransport from "../icons/transportation-app-development_icons/services/hire-transport-app-developers.svg";
import serviceOnDemand from "../icons/transportation-app-development_icons/services/on-demand-transport-app.svg";
import serviceTransportAppConsulting from "../icons/transportation-app-development_icons/services/transport-app-consulting-services.svg";
import serviceTransportAppSupport from "../icons/transportation-app-development_icons/services/transport-app-support-and-maintenance.svg";
import serviceTransportAppUxUi from "../icons/transportation-app-development_icons/services/transport-app-ux-ui-design.svg";
//Transport App Developement Icon
import whyCostEfficiency from "../icons/transportation-app-development_icons/why_konstant/cost-efficiency.svg";
import whyCustomizedSlutions from "../icons/transportation-app-development_icons/why_konstant/customized-solutions.svg";
import whyCuttingEdgeTech from "../icons/transportation-app-development_icons/why_konstant/cutting-edge-technology.svg";
import whyExcellence from "../icons/transportation-app-development_icons/why_konstant/excellence.svg";
import whyKonsIndustryExpertise from "../icons/transportation-app-development_icons/why_konstant/industry-expertise.svg";
import whySeamlessIntegration from "../icons/transportation-app-development_icons/why_konstant/seamless-integration.svg";

// Dating app development(benefits)
import globalReach from "../icons/dating_app_development_icons/benefits/global-reach.svg";
import marketPotential from "../icons/dating_app_development_icons/benefits/market-potential.svg";
import monetizationOpportunities from "../icons/dating_app_development_icons/benefits/monetization-opportunities.svg";
import scalability from "../icons/dating_app_development_icons/benefits/scalability.svg";
import tailorMadeFeatures from "../icons/dating_app_development_icons/benefits/tailor-made-features.svg";
import uniqueSellingPoint from "../icons/dating_app_development_icons/benefits/unique-selling-point.svg";

// Dating app development(solutions)
import hookUpApps from "../icons/dating_app_development_icons/solutions/hookup-apps.svg";
import matchMakingDatingApp from "../icons/dating_app_development_icons/solutions/matchmaking-dating-apps.svg";
import professionBasedDatingApps from "../icons/dating_app_development_icons/solutions/profession-based-dating-apps.svg";
import religiousBasedDatingApps from "../icons/dating_app_development_icons/solutions/religion-based-dating-apps.svg";
import seniorDatingApps from "../icons/dating_app_development_icons/solutions/senior-dating-apps.svg";

// Dating app development(why konstant)
import datingCustomSolutions from "../icons/dating_app_development_icons/why_konstant/custom-solutions.svg";
import endToEndDevelopment from "../icons/dating_app_development_icons/why_konstant/end-to-end-development.svg";
import experience from "../icons/dating_app_development_icons/why_konstant/experience.svg";
import provenTrackRecord from "../icons/dating_app_development_icons/why_konstant/proven-track-record.svg";
import qualityAssurance from "../icons/dating_app_development_icons/why_konstant/quality-assurance.svg";
import userCentricDesign from "../icons/dating_app_development_icons/why_konstant/user-centric-design.svg";
import Third_Party_Integration from "../icons/why_choose/third_party_integration.png";
import DailySupport from "../icons/why_choose/daily_support.png";

import mvpDevelopment from "../icons/startup_app_tech_icons/mvp-development.svg";
import rapidPrototyping from "../icons/startup_app_tech_icons/rapid-prototyping.svg";
import costOptimizedArchitecture from "../icons/startup_app_tech_icons/cost-optimized-architecture.svg";
import scaleReadyDesign from "../icons/startup_app_tech_icons/scale-ready-design.svg";
import IterativeReleases from "../icons/startup_app_tech_icons/iterative_releases.svg";
import NFT_Music_Marketplace_Development from "../icons/our_services_icons/NFT_Music_Marketplace_Development.svg";

import automotive from "../icons/cross_platform_app_development_icons/automotive.svg";
import industryFitness from "../icons/cross_platform_app_development_icons/fitness.svg";
import industrySports from "../icons/cross_platform_app_development_icons/sports.svg";

import competitivePricing from "../icons/become_a_partner_icons/competitive-pricing.svg";
import dedicatedAccountManager from "../icons/become_a_partner_icons/dedicated-account-manager.svg";
import futureReadySolutions from "../icons/become_a_partner_icons/future-ready-solutions.svg";
import industryLeadingTechnologies from "../icons/become_a_partner_icons/industry-leading-technologies.svg";
import internationallyRecognized from "../icons/become_a_partner_icons/internationally-recognized.svg";
import loyalClientele from "../icons/become_a_partner_icons/loyal-clientele.svg";
import richDiversePortfolio from "../icons/become_a_partner_icons/rich-diverse-portfolio.svg";
import strongFoundation from "../icons/become_a_partner_icons/strong-foundation.svg";

// Taxi page (bundled icons under taxi_page_icons)
import taxiPageIconBenefit247Availability from "../icons/taxi_page_icons/benefits/24-7-availability.svg";
import taxiPageIconBenefitCostSavings from "../icons/taxi_page_icons/benefits/cost-savings.svg";
import taxiPageIconBenefitEnhancedUserExperience from "../icons/taxi_page_icons/benefits/enhanced-user-experience.svg";
import taxiPageIconBenefitEfficiency from "../icons/taxi_page_icons/benefits/efficiency.svg";
import taxiPageIconBenefitIncreasedRevenue from "../icons/taxi_page_icons/benefits/increased-revenue.svg";
import taxiPageIconBenefitRealTimeAnalytics from "../icons/taxi_page_icons/benefits/real-time-analytics.svg";
import taxiPageIconSolutionCarRentalStartups from "../icons/taxi_page_icons/solutions/car-rental-startups.png";
import taxiPageIconSolutionCarpoolingAppDevelopment from "../icons/taxi_page_icons/solutions/carpooling-app-development.png";
import taxiPageIconSolutionCorporateTaxiApps from "../icons/taxi_page_icons/solutions/corporate-taxi-apps.png";
import taxiPageIconSolutionDeliveryAndLogisticsApps from "../icons/taxi_page_icons/solutions/delivery-and-logistics-apps.png";
import taxiPageIconSolutionOnDemandBikeApp from "../icons/taxi_page_icons/solutions/on-demand-bike-app.png";
import taxiPageIconSolutionPrivateTaxiBusiness from "../icons/taxi_page_icons/solutions/private-taxi-business.svg";
import taxiPageIconWhyAgileMethodology from "../icons/taxi_page_icons/why_konstant/agile-methodology.svg";
import taxiPageIconWhyComprehensiveSupport from "../icons/taxi_page_icons/why_konstant/comprehensive-support.svg";
import taxiPageIconWhyHighQualitySolutions from "../icons/taxi_page_icons/why_konstant/high-quality-solutions.svg";
import taxiPageIconWhySeamlessCommunication from "../icons/taxi_page_icons/why_konstant/seamless-communication.svg";
import taxiPageIconWhyTimelyDelivery from "../icons/taxi_page_icons/why_konstant/timely-delivery.svg";
import taxiPageIconWhyUserFocusedDesign from "../icons/taxi_page_icons/why_konstant/user-focused-design.svg";
import customRubyOnRailsDevelopment from "../icons/ruby_on_rails_development_icons/services/custom-ruby-on-rails-development.svg";
import rubyOnRailsAppMigration from "../icons/ruby_on_rails_development_icons/services/ruby-on-rails-app-migration.svg";
import rubyOnRailsAppUiUxDesign from "../icons/ruby_on_rails_development_icons/services/ruby-on-rails-app-ui-ux-design.svg";
import rubyOnRailsConsulting from "../icons/ruby_on_rails_development_icons/services/ruby-on-rails-consulting.svg";
import rubyOnRailsSupportMaintenance from "../icons/ruby_on_rails_development_icons/services/ruby-on-rails-support-maintenance.svg";
import rubyOnRailsWebDevelopment from "../icons/ruby_on_rails_development_icons/services/ruby-on-rails-web-development.svg";

import certifiedExperts from "../icons/ruby_on_rails_development_icons/why_konstant/certified-experts.svg";
import rubyClientCentricApproach from "../icons/ruby_on_rails_development_icons/why_konstant/client-centric-approach.svg";
import codeQuality from "../icons/ruby_on_rails_development_icons/why_konstant/code-quality.svg";
import rubyOnTimeDelivery from "../icons/ruby_on_rails_development_icons/why_konstant/on-time-delivery.svg";
import proactiveSupport from "../icons/ruby_on_rails_development_icons/why_konstant/proactive-support.svg";
import rubyProvenTrackRecord from "../icons/ruby_on_rails_development_icons/why_konstant/proven-track-record.svg";

import budgetSavings from "../icons/ruby_on_rails_development_icons/why_ruby_on_rails/budget-savings.svg";
import commendableQuality from "../icons/ruby_on_rails_development_icons/why_ruby_on_rails/commendable-quality.svg";
import fasterTimeToMarket from "../icons/ruby_on_rails_development_icons/why_ruby_on_rails/faster-time-to-market.svg";
import reducedRisks from "../icons/ruby_on_rails_development_icons/why_ruby_on_rails/reduced-risks.svg";
import rubyScalability from "../icons/ruby_on_rails_development_icons/why_ruby_on_rails/scalability.svg";
import rubySecurity from "../icons/ruby_on_rails_development_icons/why_ruby_on_rails/security.svg";

import customLogisticsAppDevelopment from "../icons/logistics_app_development_icons/services/custom-logistics-app-development.svg";
import logisticsAnalyticsSolutions from "../icons/logistics_app_development_icons/services/logistics-analytics-solutions.svg";
import logisticsAppIntegration from "../icons/logistics_app_development_icons/services/logistics-app-integration.svg";
import logisticsAppSupport from "../icons/logistics_app_development_icons/services/logistics-app-support.svg";
import logisticsWebApplicationDevelopment from "../icons/logistics_app_development_icons/services/logistics-web-application-development.svg";
import onDemandLogisticsApplications from "../icons/logistics_app_development_icons/services/on-demand-logistics-applications.svg";

import experiencedDevelopers from "../icons/logistics_app_development_icons/why_konstant/experienced-developers.svg";
import logisticsFlexibleEngagementModels from "../icons/logistics_app_development_icons/why_konstant/flexible-engagement-models.svg";
import logisticsSupportAndMaintenance from "../icons/logistics_app_development_icons/why_konstant/support-and-maintenance.svg";
import timelyDelivery from "../icons/logistics_app_development_icons/why_konstant/timely-delivery.svg";
import logisticsTransparentCommunication from "../icons/logistics_app_development_icons/why_konstant/transparent-communication.svg";
import logisticsUserCentricDesign from "../icons/logistics_app_development_icons/why_konstant/user-centric-design.svg";

//handyMan Icons
import boostRevenue from "../icons/handyman_app_icons/benefits/boost-revenue.svg";
import onDemandService from "../icons/handyman_app_icons/benefits/on-demand-service.svg";
import reachWiderAudience from "../icons/handyman_app_icons/benefits/reach-wider-audience.svg";
import realTimeTracking from "../icons/handyman_app_icons/benefits/real-time-tracking.svg";
import streamlinedProcess from "../icons/handyman_app_icons/benefits/streamlined-process.svg";
import userFriendly from "../icons/handyman_app_icons/benefits/user-friendly.svg";

import emergencyHandymanApp from "../icons/handyman_app_icons/solutions/emergency-handyman-app.svg";
import enterpriseHandymanManagementApp from "../icons/handyman_app_icons/solutions/enterprise-handyman-management-app.svg";
import handymanMarketplaceApp from "../icons/handyman_app_icons/solutions/handyman-marketplace-app.svg";
import multiServiceHandymanApp from "../icons/handyman_app_icons/solutions/multi-service-handyman-app.svg";
import onDemandHandymanApp from "../icons/handyman_app_icons/solutions/on-demand-handyman-app.svg";
import subscriptionBasedHandymanApp from "../icons/handyman_app_icons/solutions/subscription-based-handyman-app.svg";

import support247 from "../icons/handyman_app_icons/why_konstant/24-7-support.svg";
import experiencedDedicatedTeam from "../icons/handyman_app_icons/why_konstant/experienced-dedicated-team.svg";
import flexibleEngagementModelsHandMan from "../icons/handyman_app_icons/why_konstant/flexible-engagement-models.svg";
import qualityFirst from "../icons/handyman_app_icons/why_konstant/quality-first.svg";
import timelyProjectDelivery from "../icons/handyman_app_icons/why_konstant/timely-project-delivery.svg";
import transparency from "../icons/handyman_app_icons/why_konstant/transparency.svg";

//Car Wash Icons
import customSolutionsCarWash from "../icons/car_wash_icons/benefits/custom-solutions.svg";
import customerAcquisition from "../icons/car_wash_icons/benefits/customer-acquisition.svg";
import improvedManagement from "../icons/car_wash_icons/benefits/improved-management.svg";
import onTimeDeliveryCarWash from "../icons/car_wash_icons/benefits/on-time-delivery.svg";
import reduceExpenses from "../icons/car_wash_icons/benefits/reduce-expenses.svg";
import seamlessMarketing from "../icons/car_wash_icons/benefits/seamless-marketing.svg";

import aggregatorCarWashApp from "../icons/car_wash_icons/solutions/aggregator-car-wash-app.svg";
import fleetManagementApp from "../icons/car_wash_icons/solutions/fleet-management-app.svg";
import hybridCarWashApp from "../icons/car_wash_icons/solutions/hybrid-car-wash-app.svg";
import selfServiceCarWashApp from "../icons/car_wash_icons/solutions/self-service-car-wash-app.svg";
import standaloneBusinessApp from "../icons/car_wash_icons/solutions/standalone-business-app.svg";
import subscriptionBasedCarWashApp from "../icons/car_wash_icons/solutions/subscription-based-car-wash-app.svg";

import agileMethodologyCarWash from "../icons/car_wash_icons/why_konstant/agile-methodology.svg";
import customizedSolutionsCarWash from "../icons/car_wash_icons/why_konstant/customized-solutions.svg";
import dedicatedSupport from "../icons/car_wash_icons/why_konstant/dedicated-support.svg";
import experiencedDevelopersCarWash from "../icons/car_wash_icons/why_konstant/experienced-developers.svg";
import provenTrackRecordCarWash from "../icons/car_wash_icons/why_konstant/proven-track-record.svg";
import transparentCommunicationCarWash from "../icons/car_wash_icons/why_konstant/transparent-communication.svg";

//Edtech Icons
import costEfficiency from "../icons/edtech_icons/benefits/cost-efficiency.svg";
import flexibleLearning from "../icons/edtech_icons/benefits/flexible-learning.svg";
import immersiveLearning from "../icons/edtech_icons/benefits/immersive-learning.svg";
import improvedPerformance from "../icons/edtech_icons/benefits/improved-performance.svg";
import instantAccess from "../icons/edtech_icons/benefits/instant-access.svg";
import revenueOpportunities from "../icons/edtech_icons/benefits/revenue-opportunities.svg";

import corporateTrainingApps from "../icons/edtech_icons/solutions/corporate-training-apps.svg";
import gamifiedLearningApps from "../icons/edtech_icons/solutions/gamified-learning-apps.svg";
import learningManagementSystem from "../icons/edtech_icons/solutions/learning-management-system.svg";
import onDemandELearningApps from "../icons/edtech_icons/solutions/on-demand-e-learning-apps.svg";
import selfLearningApps from "../icons/edtech_icons/solutions/self-learning-apps.svg";
import virtualClassroomApps from "../icons/edtech_icons/solutions/virtual-classroom-apps.svg";

import customizedSolutionsEdtech from "../icons/edtech_icons/why_konstant/customized-solutions.svg";
import onTimeDeliveryEdtech from "../icons/edtech_icons/why_konstant/on-time-delivery.svg";
import postDeliverySupport from "../icons/edtech_icons/why_konstant/post-delivery-support.svg";
import provenTrackRecordEdtech from "../icons/edtech_icons/why_konstant/proven-track-record.svg";
import skilledDevelopers from "../icons/edtech_icons/why_konstant/skilled-developers.svg";
import userFocusedDesign from "../icons/edtech_icons/why_konstant/user-focused-design.svg";

//Smart Tv Icons
import audienceReach from "../icons/smart_tv_icons/benefits/audience-reach.svg";
import crossPlatformIntegration from "../icons/smart_tv_icons/benefits/cross-platform-integration.svg";
import enhancedUserEngagement from "../icons/smart_tv_icons/benefits/enhanced-user-engagement.svg";
import futureProofingSolutions from "../icons/smart_tv_icons/benefits/future-proofing-solutions.svg";
import marketplaceExposure from "../icons/smart_tv_icons/benefits/marketplace-exposure.svg";
import monetizationOpportunitiesSmartTv from "../icons/smart_tv_icons/benefits/monetization-opportunities.svg";

import androidTvApp from "../icons/smart_tv_icons/solutions/android-tv-app.svg";
import appleTvApp from "../icons/smart_tv_icons/solutions/apple-tv-app.svg";
import audioStreamingApp from "../icons/smart_tv_icons/solutions/audio-streaming-app.svg";
import liveStreamingApp from "../icons/smart_tv_icons/solutions/live-streaming-app.svg";
import ottAppDevelopment from "../icons/smart_tv_icons/solutions/ott-app-development.svg";
import vodAppDevelopment from "../icons/smart_tv_icons/solutions/vod-app-development.svg";

import codeOwnership from "../icons/smart_tv_icons/why_konstant/code-ownership.svg";
import customSolutionsSmartTv from "../icons/smart_tv_icons/why_konstant/custom-solutions.svg";
import dedicatedTeam from "../icons/smart_tv_icons/why_konstant/dedicated-team.svg";
import greatExperience from "../icons/smart_tv_icons/why_konstant/great-experience.svg";
import onBudget from "../icons/smart_tv_icons/why_konstant/on-budget.svg";
import platformAlignedDevelopment from "../icons/smart_tv_icons/why_konstant/platform-aligned-development.svg";

import customOilAndGasApp from "../icons/oil-and-gas-app-development_icons/services/custom-oil-and-gas-app.svg";
import oilAndGasAppConsulting from "../icons/oil-and-gas-app-development_icons/services/oil-and-gas-app-consulting.svg";
import oilAndGasAppMaintenance from "../icons/oil-and-gas-app-development_icons/services/oil-and-gas-app-maintenance.svg";
import oilAndGasAppUiUx from "../icons/oil-and-gas-app-development_icons/services/oil-and-gas-app-ui-ux.svg";
import oilAndGasSoftwareDevelopment from "../icons/oil-and-gas-app-development_icons/services/oil-and-gas-software-development.svg";
import oilAndGasWebDevelopment from "../icons/oil-and-gas-app-development_icons/services/oil-and-gas-web-development.svg";

import oilAndGasCompetitivePricing from "../icons/oil-and-gas-app-development_icons/why_konstant/competitive-pricing.svg";
import oilAndGasFlexibleEngagementModels from "../icons/oil-and-gas-app-development_icons/why_konstant/flexible-engagement-models.svg";
import oilAndGasQualityAssurance from "../icons/oil-and-gas-app-development_icons/why_konstant/quality-assurance.svg";
import oilAndGasTechnicalSupport from "../icons/oil-and-gas-app-development_icons/why_konstant/technical-support.svg";
import oilAndGasTimelyDelivery from "../icons/oil-and-gas-app-development_icons/why_konstant/timely-delivery.svg";
import oilAndGasTransparency from "../icons/oil-and-gas-app-development_icons/why_konstant/transparency.svg";

import automotiveAppConsulting from "../icons/automotive_app_development_icons/services/automotive-app-consulting.svg";
import automotiveAppCustomization from "../icons/automotive_app_development_icons/services/automotive-app-customization.svg";
import automotiveAppDesign from "../icons/automotive_app_development_icons/services/automotive-app-design.svg";
import automotiveAppIntegration from "../icons/automotive_app_development_icons/services/automotive-app-integration.svg";
import automotiveAppMaintenance from "../icons/automotive_app_development_icons/services/automotive-app-maintenance.svg";
import automotiveAppModernization from "../icons/automotive_app_development_icons/services/automotive-app-modernization.svg";

import support24_7 from "../icons/automotive_app_development_icons/why_konstant/24-7-support.svg";
import automotiveAdvancedTechnology from "../icons/automotive_app_development_icons/why_konstant/advanced-technology.svg";
import automotiveExperiencedTeam from "../icons/automotive_app_development_icons/why_konstant/experienced-team.svg";
import automotiveOnTimeDelivery from "../icons/automotive_app_development_icons/why_konstant/on-time-delivery.svg";
import automotiveQuality from "../icons/automotive_app_development_icons/why_konstant/quality.svg";
import resultDrivenApproach from "../icons/automotive_app_development_icons/why_konstant/result-driven-approach.svg";

import agricultureAppConsulting from "../icons/agriculture_app_development_icons/services/agriculture-app-consulting.svg";
import agricultureAppDesigning from "../icons/agriculture_app_development_icons/services/agriculture-app-designing.svg";
import agricultureAppModernization from "../icons/agriculture_app_development_icons/services/agriculture-app-modernization.svg";
import agricultureAppTesting from "../icons/agriculture_app_development_icons/services/agriculture-app-testing.svg";
import agricultureWebAppDevelopment from "../icons/agriculture_app_development_icons/services/agriculture-web-app-development.svg";
import customAgricultureApp from "../icons/agriculture_app_development_icons/services/custom-agriculture-app.svg";

import dataDrivenApproach from "../icons/agriculture_app_development_icons/why_konstant/data-driven-approach.svg";
import deepExpertise from "../icons/agriculture_app_development_icons/why_konstant/deep-expertise.svg";
import agricultureModernTechnologies from "../icons/agriculture_app_development_icons/why_konstant/modern-technologies.svg";
import solidSecurity from "../icons/agriculture_app_development_icons/why_konstant/solid-security.svg";
import agricultureSupport from "../icons/agriculture_app_development_icons/why_konstant/support.svg";
import transparentWorkflows from "../icons/agriculture_app_development_icons/why_konstant/transparent-workflows.svg";

// Ott Icons
import adPodding from "../icons/ott_icons/benefits/ad-podding.svg";
import betterConsumerOutreach from "../icons/ott_icons/benefits/better-consumer-outreach.svg";
import betterMonetization from "../icons/ott_icons/benefits/better-monetization.svg";
import consumerBehaviorAnalysis from "../icons/ott_icons/benefits/consumer-behavior-analysis.svg";
import enhancedUserExperience from "../icons/ott_icons/benefits/enhanced-user-experience.svg";
import measurableOutcomes from "../icons/ott_icons/benefits/measurable-outcomes.svg";

import corporateOttApps from "../icons/ott_icons/solutions/corporate-ott-apps.svg";
import educationOttApps from "../icons/ott_icons/solutions/education-ott-apps.svg";
import liveTvStreamingApps from "../icons/ott_icons/solutions/live-tv-streaming-apps.svg";
import musicStreamingApps from "../icons/ott_icons/solutions/music-streaming-apps.svg";
import smartTvAppDevelopment from "../icons/ott_icons/solutions/smart-tv-app-development.svg";
import videoStreamingApps from "../icons/ott_icons/solutions/video-streaming-apps.svg";

import completeTransparency from "../icons/ott_icons/why_konstant/complete-transparency.svg";
import customerCentricApproach from "../icons/ott_icons/why_konstant/customer-centric-approach.svg";
import customizedSolutionsOtt from "../icons/ott_icons/why_konstant/customized-solutions.svg";
import endToEndDevelopmentOtt from "../icons/ott_icons/why_konstant/end-to-end-development.svg";
import latestTechnologyStack from "../icons/ott_icons/why_konstant/latest-technology-stack.svg";
import supportAndMaintenance from "../icons/ott_icons/why_konstant/support-and-maintenance.svg";

import androidSportsAppDevelopment from "../icons/sports_app_development_icons/services/android-sports-app-development.svg";
import crossPlatformAppDevelopment from "../icons/sports_app_development_icons/services/cross-platform-app-development.svg";
import customSportsAppDevelopment from "../icons/sports_app_development_icons/services/custom-sports-app-development.svg";
import iosSportsAppDevelopment from "../icons/sports_app_development_icons/services/ios-sports-app-development.svg";
import sportsAppDesignServices from "../icons/sports_app_development_icons/services/sports-app-design-services.svg";
import sportsAppMaintenance from "../icons/sports_app_development_icons/services/sports-app-maintenance.svg";

import sportsAgileMethodology from "../icons/sports_app_development_icons/why_konstant/agile-methodology.svg";
import sportsClientCentricApproach from "../icons/sports_app_development_icons/why_konstant/client-centric-approach.svg";
import sportsCostEffective from "../icons/sports_app_development_icons/why_konstant/cost-effective.svg";
import sportsSeamlessCommunication from "../icons/sports_app_development_icons/why_konstant/seamless-communication.svg";
import sportsSkilledDevelopers from "../icons/sports_app_development_icons/why_konstant/skilled-developers.svg";
import sportsTimelyDelivery from "../icons/sports_app_development_icons/why_konstant/timely-delivery.svg";

//Laudry Icons
import dataDrivenInsights from "../icons/laundry_app_icons/benefits/data-driven-insights.svg";
import enhancedConvenience from "../icons/laundry_app_icons/benefits/enhanced-convenience.svg";
import improvedBrandLoyalty from "../icons/laundry_app_icons/benefits/improved-brand-loyalty.svg";
import increasedRevenue from "../icons/laundry_app_icons/benefits/increased-revenue.svg";
import securePayments from "../icons/laundry_app_icons/benefits/secure-payments.svg";
import streamlinedOperations from "../icons/laundry_app_icons/benefits/streamlined-operations.svg";

import costEffectiveSolutionsLaundryIcons from "../icons/laundry_app_icons/why_konstant/cost-effective-solutions.svg";
import deadlineCommitmentLaundryIcons from "../icons/laundry_app_icons/why_konstant/deadline-commitment.svg";
import dedicatedTeamLaundryIcons from "../icons/laundry_app_icons/why_konstant/dedicated-team.svg";
import flexibleEngagementModelsLaundryIcons from "../icons/laundry_app_icons/why_konstant/flexible-engagement-models.svg";
import onTimeDeliveryLaundryIcons from "../icons/laundry_app_icons/why_konstant/on-time-delivery.svg";
import qualityAssuranceLaundryIcons from "../icons/laundry_app_icons/why_konstant/quality-assurance.svg";

import garmentCareApp from "../icons/laundry_app_icons/solutions/garment-care-app.svg";
import laundryInventoryApp from "../icons/laundry_app_icons/solutions/laundry-inventory-app.svg";
import laundryLockerApp from "../icons/laundry_app_icons/solutions/laundry-locker-app.svg";
import laundryProductMarketplace from "../icons/laundry_app_icons/solutions/laundry-product-marketplace.svg";
import laundrySubscriptionApp from "../icons/laundry_app_icons/solutions/laundry-subscription-app.svg";
import onDemandLaundryApp from "../icons/laundry_app_icons/solutions/on-demand-laundry-app.svg";

//Video Streaming Icons
import brandAuthority from "../icons/video_streaming_icons/benefits/brand-authority.svg";
import competitiveEdge from "../icons/video_streaming_icons/benefits/competitive-edge.svg";
import dataDrivenInsightsVideoStreamIcons from "../icons/video_streaming_icons/benefits/data-driven-insights.svg";
import improvedUserEngagement from "../icons/video_streaming_icons/benefits/improved-user-engagement.svg";
import newRevenueStreams from "../icons/video_streaming_icons/benefits/new-revenue-streams.svg";
import widerAudienceReach from "../icons/video_streaming_icons/benefits/wider-audience-reach.svg";

import educationVideoStreamingApp from "../icons/video_streaming_icons/solutions/education-video-streaming-app.svg";
import eventStreamingAppDevelopment from "../icons/video_streaming_icons/solutions/event-streaming-app-development.svg";
import ottAppDevelopmentVideoStreamIcons from "../icons/video_streaming_icons/solutions/ott-app-development.svg";
import socialVideoAppDevelopment from "../icons/video_streaming_icons/solutions/social-video-app-development.svg";
import sportsStreamingAppDevelopment from "../icons/video_streaming_icons/solutions/sports-streaming-app-development.svg";
import videoOnDemandAppDevelopment from "../icons/video_streaming_icons/solutions/video-on-demand-app-development.svg";

import advancedTechnicalSkills from "../icons/video_streaming_icons/why_konstant/advanced-technical-skills.svg";
import customization from "../icons/video_streaming_icons/why_konstant/customization.svg";
import maintenanceSupport from "../icons/video_streaming_icons/why_konstant/maintenance-support.svg";
import nonDisclosureAgreement from "../icons/video_streaming_icons/why_konstant/non-disclosure-agreement.svg";
import provenExpertiseVideoStreamIcons from "../icons/video_streaming_icons/why_konstant/proven-expertise.svg";
import timelyDeliveryVideoStreamIcons from "../icons/video_streaming_icons/why_konstant/timely-delivery.svg";

//Flower Icons

import betterOperationalEfficiencyFlowerIcons from "../icons/flower_delivery_icons/benefits/better-operational-efficiency.svg";
import boostedProfitsFlowerIcons from "../icons/flower_delivery_icons/benefits/boosted-profits.svg";
import improvedLoyaltyFlowerIcons from "../icons/flower_delivery_icons/benefits/improved-loyalty.svg";
import increasedUserEngagementFlowerIcons from "../icons/flower_delivery_icons/benefits/increased-user-engagement.svg";
import strongerBrandIdentityFlowerIcons from "../icons/flower_delivery_icons/benefits/stronger-brand-identity.svg";
import valuableInsightsFlowerIcons from "../icons/flower_delivery_icons/benefits/valuable-insights.svg";

import charityFlowerDeliveryApps from "../icons/flower_delivery_icons/solutions/charity-flower-delivery-apps.svg";
import eventBasedFlowerDeliveryApps from "../icons/flower_delivery_icons/solutions/event-based-flower-delivery-apps.svg";
import flowerAndBouquetChainApps from "../icons/flower_delivery_icons/solutions/flower-and-bouquet-chain-apps.svg";
import luxuryFlowerDeliveryApps from "../icons/flower_delivery_icons/solutions/luxury-flower-delivery-apps.svg";
import onDemandFlowerDeliveryApps from "../icons/flower_delivery_icons/solutions/on-demand-flower-delivery-apps.svg";
import sameDayFlowerDeliveryApps from "../icons/flower_delivery_icons/solutions/same-day-flower-delivery-apps.svg";

import agileDevelopmentFlowerIcons from "../icons/flower_delivery_icons/why_konstant/agile-development.svg";
import comprehensiveSupportFlowerIcons from "../icons/flower_delivery_icons/why_konstant/comprehensive-support.svg";
import customizedSolutionsFlowerIcons from "../icons/flower_delivery_icons/why_konstant/customized-solutions.svg";
import expertiseFlowerIcons from "../icons/flower_delivery_icons/why_konstant/expertise.svg";
import robustSecurityFlowerIcons from "../icons/flower_delivery_icons/why_konstant/robust-security.svg";
import skilledDevelopmentFlowerIcons from "../icons/flower_delivery_icons/why_konstant/skilled-development.svg";

//Milk Delivery Icons
import automatedDelivery from "../icons/milk_delivery_icons/benefits/automated-delivery.svg";
import customizableSubscription from "../icons/milk_delivery_icons/benefits/customizable-subscription.svg";
import easyScheduling from "../icons/milk_delivery_icons/benefits/easy-scheduling.svg";
import enhancedCustomerService from "../icons/milk_delivery_icons/benefits/enhanced-customer-service.svg";
import enhancedOperationalEfficiency from "../icons/milk_delivery_icons/benefits/enhanced-operational-efficiency.svg";
import realTimeMonitoring from "../icons/milk_delivery_icons/benefits/real-time-monitoring.svg";

import b2bDairyDistributors from "../icons/milk_delivery_icons/solutions/b2b-dairy-distributors.svg";
import dairyMarketplaces from "../icons/milk_delivery_icons/solutions/dairy-marketplaces.svg";
import dairyRetailers from "../icons/milk_delivery_icons/solutions/dairy-retailers.svg";
import dairyStartups from "../icons/milk_delivery_icons/solutions/dairy-startups.svg";
import farmToConsumerDairies from "../icons/milk_delivery_icons/solutions/farm-to-consumer-dairies.svg";
import organicDairyBrands from "../icons/milk_delivery_icons/solutions/organic-dairy-brands.svg";

import affordableEngagementModelsMilkDeliveryIcon from "../icons/milk_delivery_icons/why_konstant/affordable-engagement-models.svg";
import agileMethodologyMilkDeliveryIcon from "../icons/milk_delivery_icons/why_konstant/agile-methodology.svg";
import expertAppDevelopersMilkDeliveryIcon from "../icons/milk_delivery_icons/why_konstant/expert-app-developers.svg";
import secureArchitectureMilkDeliveryIcon from "../icons/milk_delivery_icons/why_konstant/secure-architecture.svg";
import supportAndMaintenanceMilkDeliveryIcon from "../icons/milk_delivery_icons/why_konstant/support-and-maintenance.svg";
import timelyDeliveryMilkDeliveryIcon from "../icons/milk_delivery_icons/why_konstant/timely-delivery.svg";

//Grocery Delivery ICONS

import betterCustomerServiceGroceryDeliveryIcons from "../icons/grocery_app_icons/benefits/better-customer-service.svg";
import boostSalesGroceryDeliveryIcons from "../icons/grocery_app_icons/benefits/boost-sales.svg";
import competitiveEdgeGroceryDeliveryIcons from "../icons/grocery_app_icons/benefits/competitive-edge.svg";
import customerLoyaltyGroceryDeliveryIcons from "../icons/grocery_app_icons/benefits/customer-loyalty.svg";
import multiplePaymentOptionsGroceryDeliveryIcons from "../icons/grocery_app_icons/benefits/multiple-payment-options.svg";
import seamlessInventoryManagementGroceryDeliveryIcons from "../icons/grocery_app_icons/benefits/seamless-inventory-management.svg";

import groceryInventoryManagementAppsGroceryDeliveryIcons from "../icons/grocery_app_icons/solutions/grocery-inventory-management-apps.svg";
import groceryLoyaltyAppsGroceryDeliveryIcons from "../icons/grocery_app_icons/solutions/grocery-loyalty-apps.svg";
import groceryRecipeAppsGroceryDeliveryIcons from "../icons/grocery_app_icons/solutions/grocery-recipe-apps.svg";
import grocerySubscriptionAppsGroceryDeliveryIcons from "../icons/grocery_app_icons/solutions/grocery-subscription-apps.svg";
import onDemandGroceryDeliveryAppsGroceryDeliveryIcons from "../icons/grocery_app_icons/solutions/on-demand-grocery-delivery-apps.svg";
import onlineGroceryStoreAppsGroceryDeliveryIcons from "../icons/grocery_app_icons/solutions/online-grocery-store-apps.svg";

import agileDevelopmentProcessGroceryDeliveryIcons from "../icons/grocery_app_icons/why_konstant/agile-development-process.svg";
import dedicatedSupportGroceryDeliveryIcons from "../icons/grocery_app_icons/why_konstant/dedicated-support.svg";
import fasterLaunchGroceryDeliveryIcons from "../icons/grocery_app_icons/why_konstant/faster-launch.svg";
import flexibleEngagementModelsGroceryDeliveryIcons from "../icons/grocery_app_icons/why_konstant/flexible-engagement-models.svg";
import growthReadySolutionsGroceryDeliveryIcons from "../icons/grocery_app_icons/why_konstant/growth-ready-solutions.svg";
import userFocusedDesignsGroceryDeliveryIcons from "../icons/grocery_app_icons/why_konstant/user-focused-designs.svg";

import crossPlatformInsuranceApp from "../icons/insurance_mobile_app_development_icons/services/cross-platform-insurance-app.svg";
import customInsuranceApplication from "../icons/insurance_mobile_app_development_icons/services/custom-insurance-application.svg";
import insuranceAppConsultation from "../icons/insurance_mobile_app_development_icons/services/insurance-app-consultation.svg";
import insuranceAppModernization from "../icons/insurance_mobile_app_development_icons/services/insurance-app-modernization.svg";
import insuranceAppSupport from "../icons/insurance_mobile_app_development_icons/services/insurance-app-support.svg";
import insuranceAppUiUxDesign from "../icons/insurance_mobile_app_development_icons/services/insurance-app-ui-ux-design.svg";

import insurance24x7Availability from "../icons/insurance_mobile_app_development_icons/why_konstant/24x7-availability.svg";
import insuranceClientCentricApproach from "../icons/insurance_mobile_app_development_icons/why_konstant/client-centric-approach.svg";
import insuranceCustomization from "../icons/insurance_mobile_app_development_icons/why_konstant/customization.svg";
import insuranceDomainExpertise from "../icons/insurance_mobile_app_development_icons/why_konstant/domain-expertise.svg";
import insuranceExperiencedDevelopers from "../icons/insurance_mobile_app_development_icons/why_konstant/experienced-developers.svg";
import insuranceOnTimeDelivery from "../icons/insurance_mobile_app_development_icons/why_konstant/on-time-delivery.svg";

import dataInsights from "../icons/fantasy_sports_app_development_icons/benefits/data-insights.svg";
import marketEdge from "../icons/fantasy_sports_app_development_icons/benefits/market-edge.svg";
import marketGrowth from "../icons/fantasy_sports_app_development_icons/benefits/market-growth.svg";
import revenueOptions from "../icons/fantasy_sports_app_development_icons/benefits/revenue-options.svg";
import sportFlexibility from "../icons/fantasy_sports_app_development_icons/benefits/sport-flexibility.svg";
import fantasyUserEngagement from "../icons/fantasy_sports_app_development_icons/benefits/user-engagement.svg";

import fantasyBaseballAppDevelopmentя from "../icons/fantasy_sports_app_development_icons/solutions/fantasy-baseball-app-development.svg";
import fantasyBasketballAppDevelopment from "../icons/fantasy_sports_app_development_icons/solutions/fantasy-basketball-app-developmentя.svg";
import fantasyCricketAppDevelopment from "../icons/fantasy_sports_app_development_icons/solutions/fantasy-cricket-app-development.svg";
import fantasyFootballAppDevelopment from "../icons/fantasy_sports_app_development_icons/solutions/fantasy-football-app-development.svg";
import fantasyHockeyAppDevelopment from "../icons/fantasy_sports_app_development_icons/solutions/fantasy-hockey-app-development.svg";
import fantasyKabaddiAppDevelopment from "../icons/fantasy_sports_app_development_icons/solutions/fantasy-kabaddi-app-development.svg";

import fantasyCustomSolutions from "../icons/fantasy_sports_app_development_icons/why_konstant/custom-solutions.svg";
import fullCycleDevelopment from "../icons/fantasy_sports_app_development_icons/why_konstant/full-cycle-development.svg";
import fantasyProvenExpertise from "../icons/fantasy_sports_app_development_icons/why_konstant/proven-expertise.svg";
import fantasyProvenSuccess from "../icons/fantasy_sports_app_development_icons/why_konstant/proven-success.svg";
import fantasySecurity from "../icons/fantasy_sports_app_development_icons/why_konstant/security.svg";
import userCentricApproach from "../icons/fantasy_sports_app_development_icons/why_konstant/user-centric-approach.svg";

import electricEnhancedSecurity from "../icons/electric_vehicle_app_development_icons/benefits/enhanced-security.svg";
import evDriverExperience from "../icons/electric_vehicle_app_development_icons/benefits/ev-driver-experience.svg";
import increasedEvAdoption from "../icons/electric_vehicle_app_development_icons/benefits/increased-ev-adoption.svg";
import reliableConnectivity from "../icons/electric_vehicle_app_development_icons/benefits/reliable-connectivity.svg";
import seamlessPayment from "../icons/electric_vehicle_app_development_icons/benefits/seamless-payment.svg";
import smartRoutePlanning from "../icons/electric_vehicle_app_development_icons/benefits/smart-route-planning.svg";

import evBatteryManagementSystem from "../icons/electric_vehicle_app_development_icons/solutions/ev-battery-management-system.svg";
import evChargingMarketplace from "../icons/electric_vehicle_app_development_icons/solutions/ev-charging-marketplace.svg";
import evChargingStationFinderApp from "../icons/electric_vehicle_app_development_icons/solutions/ev-charging-station-finder-app.svg";
import evCrmManagement from "../icons/electric_vehicle_app_development_icons/solutions/ev-crm-management.svg";
import evFleetManagement from "../icons/electric_vehicle_app_development_icons/solutions/ev-fleet-management.svg";
import slowFastEvChargingStation from "../icons/electric_vehicle_app_development_icons/solutions/slow-fast-ev-charging-station.svg";

import electric24x7Support from "../icons/electric_vehicle_app_development_icons/why_konstant/24-7-support.svg";
import electricAgileMethodologies from "../icons/electric_vehicle_app_development_icons/why_konstant/agile-methodologies.svg";
import electricExpertEvDevelopers from "../icons/electric_vehicle_app_development_icons/why_konstant/expert-ev-developers.svg";
import electricModernTechnologies from "../icons/electric_vehicle_app_development_icons/why_konstant/modern-technologies.svg";
import electricSecurity from "../icons/electric_vehicle_app_development_icons/why_konstant/security.svg";
import electricTransparentProcess from "../icons/electric_vehicle_app_development_icons/why_konstant/transparent-process.svg";

import boostUserExperience from "../icons/ev_charging_app_development_icons/benefits/boost-user-experience.svg";
import evCompetitiveEdge from "../icons/ev_charging_app_development_icons/benefits/competitive-edge.svg";
import enhancedMarketing from "../icons/ev_charging_app_development_icons/benefits/enhanced-marketing.svg";
import expandReach from "../icons/ev_charging_app_development_icons/benefits/expand-reach.svg";
import increaseDigitalPresence from "../icons/ev_charging_app_development_icons/benefits/increase-digital-presence.svg";
import smartGridsIntegration from "../icons/ev_charging_app_development_icons/benefits/smart-grids-integration.svg";

import customEVehicleApp from "../icons/ev_charging_app_development_icons/solutions/custom-e-vehicle-app.svg";
import customEvChargingApp from "../icons/ev_charging_app_development_icons/solutions/custom-ev-charging-app.svg";
import eCarsBikesChargingApps from "../icons/ev_charging_app_development_icons/solutions/e-cars-bikes-charging-apps.svg";
import eChargingStationFinderApp from "../icons/ev_charging_app_development_icons/solutions/ev-charging-station-finder-app.svg";
import evChargingStationManagementApp from "../icons/ev_charging_app_development_icons/solutions/ev-charging-station-management-app.svg";
import evFleetManagementApp from "../icons/ev_charging_app_development_icons/solutions/ev-fleet-management-app.svg";

import evAgileMethodology from "../icons/ev_charging_app_development_icons/why_konstant/agile-methodology.svg";
import evCustomSolutions from "../icons/ev_charging_app_development_icons/why_konstant/custom-solutions.svg";
import evDomainExperience from "../icons/ev_charging_app_development_icons/why_konstant/domain-experience.svg";
import evPostDevelopmentSupport from "../icons/ev_charging_app_development_icons/why_konstant/post-development-support.svg";
import evSecurity from "../icons/ev_charging_app_development_icons/why_konstant/security.svg";
import evUserCentricSolution from "../icons/ev_charging_app_development_icons/why_konstant/user-centric-solution.svg";

// Medicine Delivery Icons
import costSavings from "../icons/medicine_delivery_icons/benefits/cost-savings.svg";
import customerLoyalty from "../icons/medicine_delivery_icons/benefits/customer-loyalty.svg";
import enhancedCustomerRetention from "../icons/medicine_delivery_icons/benefits/enhanced-customer-retention.svg";
import increasedBusinessReach from "../icons/medicine_delivery_icons/benefits/increased-business-reach.svg";
import optimizedEfficiency from "../icons/medicine_delivery_icons/benefits/optimized-efficiency.svg";
import revenueGeneration from "../icons/medicine_delivery_icons/benefits/revenue-generation.svg";

import b2bMedicineDeliveryApp from "../icons/medicine_delivery_icons/solutions/b2b-medicine-delivery-app.svg";
import onDemandDeliveryApp from "../icons/medicine_delivery_icons/solutions/on-demand-delivery-app.svg";
import pharmacyAggregatorApp from "../icons/medicine_delivery_icons/solutions/pharmacy-aggregator-app.svg";
import specialtyMedicineDeliveryApp from "../icons/medicine_delivery_icons/solutions/specialty-medicine-delivery-app.svg";
import subscriptionBasedApp from "../icons/medicine_delivery_icons/solutions/subscription-based-app.svg";
import telemedicineIntegratedApp from "../icons/medicine_delivery_icons/solutions/telemedicine-integrated-app.svg";

import support247MedicineDelivery from "../icons/medicine_delivery_icons/why_konstant/24-7-support.svg";
import agileDevelopmentApproachMedicineDelivery from "../icons/medicine_delivery_icons/why_konstant/agile-development-approach.svg";
import costEffectiveSolutionsMedicineDelivery from "../icons/medicine_delivery_icons/why_konstant/cost-effective-solutions.svg";
import resultDrivenApproachMedicineDelivery from "../icons/medicine_delivery_icons/why_konstant/result-driven-approach.svg";
import strongExperienceMedicineDelivery from "../icons/medicine_delivery_icons/why_konstant/strong-experience.svg";
import transparencyMedicineDelivery from "../icons/medicine_delivery_icons/why_konstant/transparency.svg";

//Courier Icons
import advancedAnalytics from "../icons/courier_delivery_icons/benefits/advanced-analytics.svg";
import effectiveFleetManagement from "../icons/courier_delivery_icons/benefits/effective-fleet-management.svg";
import enhanceCustomerExperience from "../icons/courier_delivery_icons/benefits/enhance-customer-experience.svg";
import improvedScalability from "../icons/courier_delivery_icons/benefits/improved-scalability.svg";
import multipleRevenueStreams from "../icons/courier_delivery_icons/benefits/multiple-revenue-streams.svg";
import streamlinedOperationsCourier from "../icons/courier_delivery_icons/benefits/streamlined-operations.svg";

import courierAppForCarrier from "../icons/courier_delivery_icons/solutions/courier-app-for-carrier.svg";
import courierDeliveryChainSolutions from "../icons/courier_delivery_icons/solutions/courier-delivery-chain-solutions.svg";
import freightForwardingSolutions from "../icons/courier_delivery_icons/solutions/freight-forwarding-solutions.svg";
import haulageCourierSolutions from "../icons/courier_delivery_icons/solutions/haulage-courier-solutions.svg";
import individualBusinessCourierSolutions from "../icons/courier_delivery_icons/solutions/individual-business-courier-solutions.svg";
import onlineCourierMarketplaceSolutions from "../icons/courier_delivery_icons/solutions/online-courier-marketplace-solutions.svg";

import continuousSupportCourier from "../icons/courier_delivery_icons/why_konstant/continuous-support.svg";
import customizationCourier from "../icons/courier_delivery_icons/why_konstant/customization.svg";
import endToEndDevelopmentCourier from "../icons/courier_delivery_icons/why_konstant/end-to-end-development.svg";
import provenTrackRecordCourier from "../icons/courier_delivery_icons/why_konstant/proven-track-record.svg";
import scalableSolutionsCourier from "../icons/courier_delivery_icons/why_konstant/scalable-solutions.svg";
import userCentricDesignCourier from "../icons/courier_delivery_icons/why_konstant/user-centric-design.svg";

import analyticsAndInsights from "../icons/magazine_and_newspaper_app_development_icons/benefits/analytics-and-insights.svg";
import expandedReach from "../icons/magazine_and_newspaper_app_development_icons/benefits/expanded-reach.svg";
import increasedEngagement from "../icons/magazine_and_newspaper_app_development_icons/benefits/increased-engagement.svg";
import magazineMonetizationOpportunities from "../icons/magazine_and_newspaper_app_development_icons/benefits/monetization-opportunities.svg";
import offlineAccess from "../icons/magazine_and_newspaper_app_development_icons/benefits/offline-access.svg";
import realTimeUpdates from "../icons/magazine_and_newspaper_app_development_icons/benefits/real-time-updates.svg";

import businessMagazineApps from "../icons/magazine_and_newspaper_app_development_icons/solutions/business-magazine-apps.svg";
import digitalMagazinesNewspapers from "../icons/magazine_and_newspaper_app_development_icons/solutions/digital-magazines-newspapers.svg";
import educationalMagazineApps from "../icons/magazine_and_newspaper_app_development_icons/solutions/educational-magazine-apps.svg";
import entertainmentMagazineApps from "../icons/magazine_and_newspaper_app_development_icons/solutions/entertainment-magazine-apps.svg";
import healthMagazineApps from "../icons/magazine_and_newspaper_app_development_icons/solutions/health-magazine-apps.svg";
import techMagazineApps from "../icons/magazine_and_newspaper_app_development_icons/solutions/tech-magazine-apps.svg";

import magazineFlexibleEngagementModels from "../icons/magazine_and_newspaper_app_development_icons/why_konstant/flexible-engagement-models.svg";
import industryKnowledge from "../icons/magazine_and_newspaper_app_development_icons/why_konstant/industry-knowledge.svg";
import mediaDomainExpertise from "../icons/magazine_and_newspaper_app_development_icons/why_konstant/media-domain-expertise.svg";
import monetizationFocused from "../icons/magazine_and_newspaper_app_development_icons/why_konstant/monetization-focused.svg";
import qualityFirstApproach from "../icons/magazine_and_newspaper_app_development_icons/why_konstant/quality-first-approach.svg";
import magazineUserCentricDesign from "../icons/magazine_and_newspaper_app_development_icons/why_konstant/user-centric-design.svg";

import stockAccessibility from "../icons/stock_trading_app_development_icons/benefits/accessibility.svg";
import stockAccuracy from "../icons/stock_trading_app_development_icons/benefits/accuracy.svg";
import stockCompatibility from "../icons/stock_trading_app_development_icons/benefits/compatibility.svg";
import easeOfOperations from "../icons/stock_trading_app_development_icons/benefits/ease-of-operations.svg";
import feasibility from "../icons/stock_trading_app_development_icons/benefits/feasibility.svg";
import stockFlexibility from "../icons/stock_trading_app_development_icons/benefits/flexibility.svg";

import commoditiesTradingApp from "../icons/stock_trading_app_development_icons/solutions/commodities-trading-app.svg";
import currencyExchangeApp from "../icons/stock_trading_app_development_icons/solutions/currency-exchange-app.svg";
import futuresTradingApp from "../icons/stock_trading_app_development_icons/solutions/futures-trading-app.svg";
import liquidityManagementPlatform from "../icons/stock_trading_app_development_icons/solutions/liquidity-management-platform.svg";
import otcTradingPlatform from "../icons/stock_trading_app_development_icons/solutions/otc-trading-platform.svg";
import stockEquityTrading from "../icons/stock_trading_app_development_icons/solutions/stock-equity-trading.svg";

import customizableSolutions from "../icons/stock_trading_app_development_icons/why_konstant/customizable-solutions.svg";
import stockDedicatedSupport from "../icons/stock_trading_app_development_icons/why_konstant/dedicated-support.svg";
import stockEndToEndDevelopment from "../icons/stock_trading_app_development_icons/why_konstant/end-to-end-development.svg";
import stockTimelyDelivery from "../icons/stock_trading_app_development_icons/why_konstant/timely-delivery.svg";
import stockTransparency from "../icons/stock_trading_app_development_icons/why_konstant/transparency.svg";
import stockUserCentricDesign from "../icons/stock_trading_app_development_icons/why_konstant/user-centric-design.svg";

import commissionManagement from "../icons/car_rental_app_development_icons/benefits/commission-management.svg";
import costEffectiveOperations from "../icons/car_rental_app_development_icons/benefits/cost-effective-operations.svg";
import enhancedCustomerExperience from "../icons/car_rental_app_development_icons/benefits/enhanced-customer-experience.svg";
import futureReadiness from "../icons/car_rental_app_development_icons/benefits/future-readiness.svg";
import multiVehicleManagement from "../icons/car_rental_app_development_icons/benefits/multi-vehicle-management.svg";
import securePaymentIntegrations from "../icons/car_rental_app_development_icons/benefits/secure-payment-integrations.svg";

import airportCarRentalApps from "../icons/car_rental_app_development_icons/solutions/airport-car-rental-apps.svg";
import chauffeurDrivenRentalApps from "../icons/car_rental_app_development_icons/solutions/chauffeur-driven-rental-apps.svg";
import corporateCarRentalApps from "../icons/car_rental_app_development_icons/solutions/corporate-car-rental-apps.svg";
import luxuryCarRentalApps from "../icons/car_rental_app_development_icons/solutions/luxury-car-rental-apps.svg";
import onDemandCarRentalApps from "../icons/car_rental_app_development_icons/solutions/on-demand-car-rental-apps.svg";
import peerToPeerRentalApps from "../icons/car_rental_app_development_icons/solutions/peer-to-Peer-rental-apps.svg";

import carRentalContinuousSupport from "../icons/car_rental_app_development_icons/why_konstant/continuous-support.svg";
import carRentalCostEffectiveSolutions from "../icons/car_rental_app_development_icons/why_konstant/cost-effective-solutions.svg";
import carRentalExpertise from "../icons/car_rental_app_development_icons/why_konstant/expertise.svg";
import carRentalProvenTrackRecord from "../icons/car_rental_app_development_icons/why_konstant/proven-track-record.svg";
import carRentalTailoredSolutions from "../icons/car_rental_app_development_icons/why_konstant/tailored-solutions.svg";
import userExperienceFocused from "../icons/car_rental_app_development_icons/why_konstant/user-experience-focused.svg";

export const Icons = {
  carRentalBenefits: {
    commissionManagement,
    costEffectiveOperations,
    enhancedCustomerExperience,
    futureReadiness,
    multiVehicleManagement,
    securePaymentIntegrations,
  },

  carRentalSolutions: {
    airportCarRentalApps,
    chauffeurDrivenRentalApps,
    corporateCarRentalApps,
    luxuryCarRentalApps,
    onDemandCarRentalApps,
    peerToPeerRentalApps,
  },

  carRentalWhyKonstant: {
    carRentalContinuousSupport,
    carRentalCostEffectiveSolutions,
    carRentalExpertise,
    carRentalProvenTrackRecord,
    carRentalTailoredSolutions,
    userExperienceFocused,
  },

  stockBenefits: {
    stockAccessibility,
    stockAccuracy,
    stockCompatibility,
    easeOfOperations,
    feasibility,
    stockFlexibility,
  },

  stockSolutions: {
    commoditiesTradingApp,
    currencyExchangeApp,
    futuresTradingApp,
    liquidityManagementPlatform,
    otcTradingPlatform,
    stockEquityTrading,
  },

  stockWhyKonstant: {
    customizableSolutions,
    stockDedicatedSupport,
    stockEndToEndDevelopment,
    stockTimelyDelivery,
    stockTransparency,
    stockUserCentricDesign,
  },

  magazineBenefits: {
    analyticsAndInsights,
    expandedReach,
    increasedEngagement,
    magazineMonetizationOpportunities,
    offlineAccess,
    realTimeUpdates,
  },

  magazineSolutions: {
    businessMagazineApps,
    digitalMagazinesNewspapers,
    educationalMagazineApps,
    entertainmentMagazineApps,
    healthMagazineApps,
    techMagazineApps,
  },

  magazineWhyKonstant: {
    magazineFlexibleEngagementModels,
    industryKnowledge,
    mediaDomainExpertise,
    monetizationFocused,
    qualityFirstApproach,
    magazineUserCentricDesign,
  },

  courierDeliveryIcons: {
    benefits: {
      advancedAnalytics,
      effectiveFleetManagement,
      enhanceCustomerExperience,
      improvedScalability,
      multipleRevenueStreams,
      streamlinedOperationsCourier,
    },

    solutions: {
      courierAppForCarrier,
      courierDeliveryChainSolutions,
      freightForwardingSolutions,
      haulageCourierSolutions,
      individualBusinessCourierSolutions,
      onlineCourierMarketplaceSolutions,
    },

    why_konstant: {
      continuousSupportCourier,
      customizationCourier,
      endToEndDevelopmentCourier,
      provenTrackRecordCourier,
      scalableSolutionsCourier,
      userCentricDesignCourier,
    },
  },

  medicineDeliveryIcons: {
    benefits: {
      costSavings,
      customerLoyalty,
      enhancedCustomerRetention,
      increasedBusinessReach,
      optimizedEfficiency,
      revenueGeneration,
    },

    solutions: {
      b2bMedicineDeliveryApp,
      onDemandDeliveryApp,
      pharmacyAggregatorApp,
      specialtyMedicineDeliveryApp,
      subscriptionBasedApp,
      telemedicineIntegratedApp,
    },

    why_konstant: {
      support247MedicineDelivery,
      agileDevelopmentApproachMedicineDelivery,
      costEffectiveSolutionsMedicineDelivery,
      resultDrivenApproachMedicineDelivery,
      strongExperienceMedicineDelivery,
      transparencyMedicineDelivery,
    },
  },

  evBenefits: {
    boostUserExperience,
    evCompetitiveEdge,
    enhancedMarketing,
    expandReach,
    increaseDigitalPresence,
    smartGridsIntegration,
  },

  evSolutions: {
    customEVehicleApp,
    customEvChargingApp,
    eCarsBikesChargingApps,
    eChargingStationFinderApp,
    evChargingStationManagementApp,
    evFleetManagementApp,
  },

  evWhyKonstant: {
    evAgileMethodology,
    evCustomSolutions,
    evDomainExperience,
    evPostDevelopmentSupport,
    evSecurity,
    evUserCentricSolution,
  },

  electricBenefits: {
    electricEnhancedSecurity,
    evDriverExperience,
    increasedEvAdoption,
    reliableConnectivity,
    seamlessPayment,
    smartRoutePlanning,
  },

  electricSolutions: {
    evBatteryManagementSystem,
    evChargingMarketplace,
    evChargingStationFinderApp,
    evCrmManagement,
    evFleetManagement,
    slowFastEvChargingStation,
  },

  electricWhyKonstant: {
    electric24x7Support,
    electricAgileMethodologies,
    electricExpertEvDevelopers,
    electricModernTechnologies,
    electricSecurity,
    electricTransparentProcess,
  },

  fantasyBenefits: {
    dataInsights,
    marketEdge,
    marketGrowth,
    revenueOptions,
    sportFlexibility,
    fantasyUserEngagement,
  },

  fantasySolutions: {
    fantasyBaseballAppDevelopmentя,
    fantasyBasketballAppDevelopment,
    fantasyCricketAppDevelopment,
    fantasyFootballAppDevelopment,
    fantasyHockeyAppDevelopment,
    fantasyKabaddiAppDevelopment,
  },

  fantasyWhyKonstant: {
    fantasyCustomSolutions,
    fullCycleDevelopment,
    fantasyProvenExpertise,
    fantasyProvenSuccess,
    fantasySecurity,
    userCentricApproach,
  },

  insuranceServices: {
    crossPlatformInsuranceApp,
    customInsuranceApplication,
    insuranceAppConsultation,
    insuranceAppModernization,
    insuranceAppSupport,
    insuranceAppUiUxDesign,
  },

  insuranceWhyKonstant: {
    insurance24x7Availability,
    insuranceClientCentricApproach,
    insuranceCustomization,
    insuranceDomainExpertise,
    insuranceExperiencedDevelopers,
    insuranceOnTimeDelivery,
  },

  groceryAppIcons: {
    benefits: {
      betterCustomerServiceGroceryDeliveryIcons,
      boostSalesGroceryDeliveryIcons,
      competitiveEdgeGroceryDeliveryIcons,
      customerLoyaltyGroceryDeliveryIcons,
      multiplePaymentOptionsGroceryDeliveryIcons,
      seamlessInventoryManagementGroceryDeliveryIcons,
    },

    solutions: {
      groceryInventoryManagementAppsGroceryDeliveryIcons,
      groceryLoyaltyAppsGroceryDeliveryIcons,
      groceryRecipeAppsGroceryDeliveryIcons,
      grocerySubscriptionAppsGroceryDeliveryIcons,
      onDemandGroceryDeliveryAppsGroceryDeliveryIcons,
      onlineGroceryStoreAppsGroceryDeliveryIcons,
    },

    why_konstant: {
      agileDevelopmentProcessGroceryDeliveryIcons,
      dedicatedSupportGroceryDeliveryIcons,
      fasterLaunchGroceryDeliveryIcons,
      flexibleEngagementModelsGroceryDeliveryIcons,
      growthReadySolutionsGroceryDeliveryIcons,
      userFocusedDesignsGroceryDeliveryIcons,
    },
  },

  milkDeliveryIcons: {
    benefits: {
      automatedDelivery,
      customizableSubscription,
      easyScheduling,
      enhancedCustomerService,
      enhancedOperationalEfficiency,
      realTimeMonitoring,
    },

    solutions: {
      b2bDairyDistributors,
      dairyMarketplaces,
      dairyRetailers,
      dairyStartups,
      farmToConsumerDairies,
      organicDairyBrands,
    },

    why_konstant: {
      affordableEngagementModelsMilkDeliveryIcon,
      agileMethodologyMilkDeliveryIcon,
      expertAppDevelopersMilkDeliveryIcon,
      secureArchitectureMilkDeliveryIcon,
      supportAndMaintenanceMilkDeliveryIcon,
      timelyDeliveryMilkDeliveryIcon,
    },
  },

  flowerDeliveryIcons: {
    benefits: {
      betterOperationalEfficiencyFlowerIcons,
      boostedProfitsFlowerIcons,
      improvedLoyaltyFlowerIcons,
      increasedUserEngagementFlowerIcons,
      strongerBrandIdentityFlowerIcons,
      valuableInsightsFlowerIcons,
    },

    solutions: {
      charityFlowerDeliveryApps,
      eventBasedFlowerDeliveryApps,
      flowerAndBouquetChainApps,
      luxuryFlowerDeliveryApps,
      onDemandFlowerDeliveryApps,
      sameDayFlowerDeliveryApps,
    },

    why_konstant: {
      agileDevelopmentFlowerIcons,
      comprehensiveSupportFlowerIcons,
      customizedSolutionsFlowerIcons,
      expertiseFlowerIcons,
      robustSecurityFlowerIcons,
      skilledDevelopmentFlowerIcons,
    },
  },
  sportsServices: {
    androidSportsAppDevelopment,
    crossPlatformAppDevelopment,
    customSportsAppDevelopment,
    iosSportsAppDevelopment,
    sportsAppDesignServices,
    sportsAppMaintenance,
  },

  sportsWhyKonstant: {
    sportsAgileMethodology,
    sportsClientCentricApproach,
    sportsCostEffective,
    sportsSeamlessCommunication,
    sportsSkilledDevelopers,
    sportsTimelyDelivery,
  },

  agricultureServices: {
    agricultureAppConsulting,
    agricultureAppDesigning,
    agricultureAppModernization,
    agricultureAppTesting,
    agricultureWebAppDevelopment,
    customAgricultureApp,
  },

  agricultureWhyKonstant: {
    dataDrivenApproach,
    deepExpertise,
    agricultureModernTechnologies,
    solidSecurity,
    agricultureSupport,
    transparentWorkflows,
  },

  autoMotiveServices: {
    automotiveAppConsulting,
    automotiveAppCustomization,
    automotiveAppDesign,
    automotiveAppIntegration,
    automotiveAppMaintenance,
    automotiveAppModernization,
  },

  autoMotiveWhyKonstant: {
    support24_7,
    automotiveAdvancedTechnology,
    automotiveExperiencedTeam,
    automotiveOnTimeDelivery,
    automotiveQuality,
    resultDrivenApproach,
  },

  oilAndGasServices: {
    customOilAndGasApp,
    oilAndGasAppConsulting,
    oilAndGasAppMaintenance,
    oilAndGasAppUiUx,
    oilAndGasSoftwareDevelopment,
    oilAndGasWebDevelopment,
  },

  oilAndGasWhyKonstant: {
    oilAndGasCompetitivePricing,
    oilAndGasFlexibleEngagementModels,
    oilAndGasQualityAssurance,
    oilAndGasTechnicalSupport,
    oilAndGasTimelyDelivery,
    oilAndGasTransparency,
  },

  videoStreamingIcons: {
    benefits: {
      brandAuthority,
      competitiveEdge,
      dataDrivenInsightsVideoStreamIcons,
      improvedUserEngagement,
      newRevenueStreams,
      widerAudienceReach,
    },

    solutions: {
      educationVideoStreamingApp,
      eventStreamingAppDevelopment,
      ottAppDevelopmentVideoStreamIcons,
      socialVideoAppDevelopment,
      sportsStreamingAppDevelopment,
      videoOnDemandAppDevelopment,
    },

    why_konstant: {
      advancedTechnicalSkills,
      customization,
      maintenanceSupport,
      nonDisclosureAgreement,
      provenExpertiseVideoStreamIcons,
      timelyDeliveryVideoStreamIcons,
    },
  },

  laundryAppIcons: {
    benefits: {
      dataDrivenInsights,
      enhancedConvenience,
      improvedBrandLoyalty,
      increasedRevenue,
      securePayments,
      streamlinedOperations,
    },
    solutions: {
      garmentCareApp,
      laundryInventoryApp,
      laundryLockerApp,
      laundryProductMarketplace,
      laundrySubscriptionApp,
      onDemandLaundryApp,
    },

    why_konstant: {
      costEffectiveSolutionsLaundryIcons,
      deadlineCommitmentLaundryIcons,
      dedicatedTeamLaundryIcons,
      flexibleEngagementModelsLaundryIcons,
      onTimeDeliveryLaundryIcons,
      qualityAssuranceLaundryIcons,
    },
  },

  ottIcons: {
    benefits: {
      adPodding,
      betterConsumerOutreach,
      betterMonetization,
      consumerBehaviorAnalysis,
      enhancedUserExperience,
      measurableOutcomes,
    },

    solutions: {
      corporateOttApps,
      educationOttApps,
      liveTvStreamingApps,
      musicStreamingApps,
      smartTvAppDevelopment,
      videoStreamingApps,
    },

    why_konstant: {
      completeTransparency,
      customerCentricApproach,
      customizedSolutionsOtt,
      endToEndDevelopmentOtt,
      latestTechnologyStack,
      supportAndMaintenance,
    },
  },

  smartTvIcons: {
    benefits: {
      audienceReach,
      crossPlatformIntegration,
      enhancedUserEngagement,
      futureProofingSolutions,
      marketplaceExposure,
      monetizationOpportunitiesSmartTv,
    },

    solutions: {
      androidTvApp,
      appleTvApp,
      audioStreamingApp,
      liveStreamingApp,
      ottAppDevelopment,
      vodAppDevelopment,
    },

    why_konstant: {
      codeOwnership,
      customSolutionsSmartTv,
      dedicatedTeam,
      greatExperience,
      onBudget,
      platformAlignedDevelopment,
    },
  },
  edtechIcons: {
    benefits: {
      costEfficiency,
      flexibleLearning,
      immersiveLearning,
      improvedPerformance,
      instantAccess,
      revenueOpportunities,
    },

    solutions: {
      corporateTrainingApps,
      gamifiedLearningApps,
      learningManagementSystem,
      onDemandELearningApps,
      selfLearningApps,
      virtualClassroomApps,
    },

    why_konstant: {
      customizedSolutionsEdtech,
      onTimeDeliveryEdtech,
      postDeliverySupport,
      provenTrackRecordEdtech,
      skilledDevelopers,
      userFocusedDesign,
    },
  },

  carWashIcons: {
    benefits: {
      customSolutionsCarWash,
      customerAcquisition,
      improvedManagement,
      onTimeDeliveryCarWash,
      reduceExpenses,
      seamlessMarketing,
    },

    solutions: {
      aggregatorCarWashApp,
      fleetManagementApp,
      hybridCarWashApp,
      selfServiceCarWashApp,
      standaloneBusinessApp,
      subscriptionBasedCarWashApp,
    },

    why_konstant: {
      agileMethodologyCarWash,
      customizedSolutionsCarWash,
      dedicatedSupport,
      experiencedDevelopersCarWash,
      provenTrackRecordCarWash,
      transparentCommunicationCarWash,
    },
  },

  handyManIcons: {
    benefits: {
      boostRevenue,
      onDemandService,
      reachWiderAudience,
      realTimeTracking,
      streamlinedProcess,
      userFriendly,
    },

    solutions: {
      emergencyHandymanApp,
      enterpriseHandymanManagementApp,
      handymanMarketplaceApp,
      multiServiceHandymanApp,
      onDemandHandymanApp,
      subscriptionBasedHandymanApp,
    },

    why_konstant: {
      support247,
      experiencedDedicatedTeam,
      flexibleEngagementModelsHandMan,
      qualityFirst,
      timelyProjectDelivery,
      transparency,
    },
  },

  taxiPageBundledIcons: {
    benefits: {
      availability247: taxiPageIconBenefit247Availability,
      costSavings: taxiPageIconBenefitCostSavings,
      enhancedUserExperience: taxiPageIconBenefitEnhancedUserExperience,
      efficiency: taxiPageIconBenefitEfficiency,
      increasedRevenue: taxiPageIconBenefitIncreasedRevenue,
      realTimeAnalytics: taxiPageIconBenefitRealTimeAnalytics,
    },
    solutions: {
      carRentalStartups: taxiPageIconSolutionCarRentalStartups,
      carpoolingAppDevelopment: taxiPageIconSolutionCarpoolingAppDevelopment,
      corporateTaxiApps: taxiPageIconSolutionCorporateTaxiApps,
      deliveryAndLogisticsApps: taxiPageIconSolutionDeliveryAndLogisticsApps,
      onDemandBikeApp: taxiPageIconSolutionOnDemandBikeApp,
      privateTaxiBusiness: taxiPageIconSolutionPrivateTaxiBusiness,
    },
    whyKonstant: {
      agileMethodology: taxiPageIconWhyAgileMethodology,
      comprehensiveSupport: taxiPageIconWhyComprehensiveSupport,
      highQualitySolutions: taxiPageIconWhyHighQualitySolutions,
      seamlessCommunication: taxiPageIconWhySeamlessCommunication,
      timelyDelivery: taxiPageIconWhyTimelyDelivery,
      userFocusedDesign: taxiPageIconWhyUserFocusedDesign,
    },
  },

  logisticsServices: {
    customLogisticsAppDevelopment,
    logisticsAnalyticsSolutions,
    logisticsAppIntegration,
    logisticsAppSupport,
    logisticsWebApplicationDevelopment,
    onDemandLogisticsApplications,
  },

  logisticsWhyKonstant: {
    experiencedDevelopers,
    logisticsFlexibleEngagementModels,
    logisticsSupportAndMaintenance,
    timelyDelivery,
    logisticsTransparentCommunication,
    logisticsUserCentricDesign,
  },

  rubyServices: {
    customRubyOnRailsDevelopment,
    rubyOnRailsAppMigration,
    rubyOnRailsAppUiUxDesign,
    rubyOnRailsConsulting,
    rubyOnRailsSupportMaintenance,
    rubyOnRailsWebDevelopment,
  },

  rubyWhyKonstant: {
    certifiedExperts,
    rubyClientCentricApproach,
    codeQuality,
    rubyOnTimeDelivery,
    proactiveSupport,
    rubyProvenTrackRecord,
  },

  whyRubyOnRailsDevelopment: {
    budgetSavings,
    commendableQuality,
    fasterTimeToMarket,
    reducedRisks,
    rubyScalability,
    rubySecurity,
  },

  becomeAPartnerIcons: {
    competitivePricing,
    dedicatedAccountManager,
    futureReadySolutions,
    industryLeadingTechnologies,
    internationallyRecognized,
    loyalClientele,
    richDiversePortfolio,
    strongFoundation,
  },

  datingBenefits: {
    globalReach,
    marketPotential,
    monetizationOpportunities,
    scalability,
    tailorMadeFeatures,
    uniqueSellingPoint,
  },

  datingSolutions: {
    hookUpApps,
    matchMakingDatingApp,
    professionBasedDatingApps,
    religiousBasedDatingApps,
    seniorDatingApps,
  },

  datingWhyKonstant: {
    datingCustomSolutions,
    endToEndDevelopment,
    experience,
    provenTrackRecord,
    qualityAssurance,
    userCentricDesign,
  },

  transportService: {
    serviceCustomGood,
    serviceHireTransport,
    serviceOnDemand,
    serviceTransportAppConsulting,
    serviceTransportAppSupport,
    serviceTransportAppUxUi,
  },
  transportWhyKonstant: {
    whyCostEfficiency,
    whyCustomizedSlutions,
    whyCuttingEdgeTech,
    whyExcellence,
    whyKonsIndustryExpertise,
    whySeamlessIntegration,
  },
  eventServices: {
    customEventAppDevelopment,
    eventAppConsultation,
    eventAppDesign,
    eventAppMaintenanceSupport,
    eventTicketAppDevelopment,
    hireEventAppDevelopers,
  },

  eventWhyKonstant: {
    Support,
    agileMethodology,
    crossPlatformCompatibility,
    customizedSolutions,
    provenExpertise,
    realTimeAnalytics,
  },

  gameService: {
    service2D3D,
    serviceAndroidGame,
    serviceCrossPlatform,
    serviceFullCycle,
    serviceIosGame,
    serviceWebGame,
  },

  whyKonstant: {
    whyAdvanceMone,
    whyCoDevelopment,
    whyCuttingEdge,
    whyDynamicRetention,
    whyHighQualit,
    whyIndustryExpertise,
  },

  directoryBenefit: {
    betterCustomerConnections,
    efficientBusinessManagement,
    improvedDiscovery,
    multiplePlatformsAccess,
    scalableRevenue,
    strongerCustomerEngagement,
  },

  directorySolutions: {
    businessListingDirectory,
    enterpriseDirectoryApplications,
    locationBasedDirectories,
    membershipDirectoriesApplications,
    mobilePhoneDirectory,
    restaurantDirectoryApplications,
  },

  directoryWhyKonstant: {
    customSolutions,
    extensiveSupport,
    directoryHighQuality,
    infrastructuralSecurity,
    modernTechnologies,
    multichannelApproach,
  },

  chatBenefit: {
    betterGrowth,
    competitiveAdvantage,
    greatBusinessOpportunity,
    increasedUserEngagement,
    loyalUserBase,
    stayUpdated,
  },

  chatSolutions: {
    businessMessagingApps,
    datingMessagingApps,
    personalMessagingApps,
    socialMediaMessagingApps,
    teamCollaborationApps,
  },

  chatWhyKonstant: {
    chatCustomizedSolutions,
    cuttingEdgeTechnology,
    endToEndService,
    chatExpertise,
    chatProvenTrackRecord,
    chatUserCentricDesign,
  },

  awsServices: {
    awsCloudApplicationServices,
    awsCloudConsulting,
    awsCloudMigration,
    awsCostOptimization,
    awsDataAnalyticsServices,
    awsManagedServices,
    awsSolutionDevelopment,
  },
  whyAws: {
    advancedTechnologies,
    costEffectiveSolutions,
    enhancedSecurity,
    globalAvailability,
    industryLeadingPerformance,
    sustainabilityInitiatives,
  },

  awsWhyKonstant: {
    continuousSupport,
    highSecurity,
    holisticEngagement,
    seamlessMigration,
    successFocused,
    tailoredCertifiedProfessionals,
  },

  odooServices: {
    odooAppDevelopment,
    odooAppUiUxDesign,
    odooCustomizationIntegration,
    odooModuleDevelopment,
    odooStoreDevelopment,
    odooThemeDevelopment,
    odooWebsiteDevelopment,
  },

  odooWhyKonstant: {
    betterBusinessOutput,
    odooCostAffordability,
    odooOpenSourcePlatform,
    odooPreExistedScalability,
    odooRobustArchitecture,
    odooUpdatedTechnology,
  },

  whyOdoo: {
    odooCostEffective,
    deliveryDeadline,
    easyCustomization,
    longTermSupport,
    odooExperts,
    personalizedConsulting,
  },

  industriesIcons: {
    agriculture,
    education,
    eventTickets,
    fitness,
    gameDevelopment,
    healthcare,
    hospitalityTravel,
    insurance,
    logistics,
    mediaEntertainment,
    oilAndGas,
    socialNetworking,
    sports,
    transportationAutomotive,
  },

  gcpServiceIcons: {
    cloudNativeSolutionDevelopmentIcon,
    cloudSecurityServicesIcon,
    gcpDataAndAnalyticsIcon,
    googleCloudMigrationServicesIcon,
    googleCloudStrategyIcon,
    infrastructureManagementIcon,
  },

  googleCloudPlatformServicesWhyGCPIcons: {
    automaticBackupsIcon,
    communitySupportIcon,
    costEffectiveGCPIcon,
    flexibleIcon,
    improvedPerformanceIcon,
    secureIcon,
  },

  googleCloudPlatformServicesWhyKonstantIcons: {
    agileApproachIcon,
    complianceAndSecurityGCPIcon,
    costEfficientSupportIcon,
    endToEndConsultingIcon,
    industryExpertiseIcon,
    proactiveSupportIcon,
  },

  musicStreamingBenefits: {
    brandLoyalty,
    collaborations,
    crossPromotionSynergies,
    dataMonetization,
    universalReach,
    userRetention,
  },

  musicStreamingSolutions: {
    audiobookApps,
    karaokeApps,
    liveMusicStreamingApps,
    podcastApps,
    radioStationApps,
    socialMusicApps,
  },

  musicStreamingWhyKonstant: {
    domainExpertise,
    flexibleEngagementModels,
    fluentCommunication,
    globalClientele,
    signNda,
    updatedWithLatestTrends,
  },

  telemedicineBenefits: {
    collaborativeCare,
    confidentiality,
    reducedHealthcareCosts,
    timeManagement,
    widespreadReach,
    workOptimization,
  },

  telemedicineSolutions: {
    dermatologyTelemedicine,
    neurologyTelemedicine,
    pediatricsTelemedicine,
    primaryCareTelemedicine,
    storeAndForwardSystems,
    teleicuSystems,
  },

  telemedicineWhyKonstant: {
    agileDevelopmentApproach,
    dedicatedDevelopers,
    domainKnowledge,
    innovativeSolutions,
    regulatoryCompliance,
    securityFirstApproach,
  },

  socialServices: {
    crossPlatformSocialMediaApp,
    customSocialMediaApp,
    socialMediaAppMaintenance,
    socialMediaAppTesting,
    socialMediaAppUiUxDesign,
    socialMediaAppUpgradation,
  },

  socialWhyKonstant: {
    clientCentricApproach,
    creativity,
    crossPlatformExpertise,
    cuttingEdgeTechnologies,
    supportMonitoring,
    transparentCommunication,
  },

  fitnessServices: {
    customFitnessAppDevelopment,
    fitnessAppConsulting,
    fitnessAppModernization,
    fitnessAppTesting,
    fitnessAppUiUxDesign,
    fitnessWebsiteDevelopment,
  },

  fitnessWhyKonstant: {
    advancedTechnology,
    costEffective,
    endToEndSupport,
    expertise,
    onTimeDelivery,
    scalableSolutions,
  },

  doctorsOnDemandIcons: {
    complianceAndSecurityIcon,
    costTimeSavingsIcon,
    highPatientEngagementIcon,
    improvesEfficiencyIcon,
    increasedRevenueIcon,
    increasedSatisfactionIcon,

    liveVideoConsultationAppsIcon,
    medicationManagementAppsIcon,
    mentalHealthAppsIcon,
    remotePatientMonitoringAppsIcon,
    specialtyAppsIcon,
    symptomCheckerAppsIcon,

    dataSecurityAndComplianceIcon,
    experiencedTeamIcon,
    scalableFeaturesIcon,
    supportAndMaintenanceIcon,
    thirdPartyIntegrationsIcon,
    userFriendlyExperienceIcon,
  },

  fuelDeliveryIcons: {
    convenienceIcon,
    costEfficiencyIcon,
    ecoFriendlyIcon,
    highQualityFuelIcon,
    lowMaintenanceIcon,
    supportDuringEmergenciesIcon,

    carRefuelingAppIcon,
    emergencyFuelDeliveryAppIcon,
    fuelDeliveryAggregatorsIcon,
    fuelPriceComparisonAppIcon,
    fuelStationOwnersIcon,
    oilAndGasCompaniesIcon,

    support24x7TechnicalIcon,
    advancedTechnologyIcon,
    postLaunchSupportIcon,
    qualityDevelopmentIcon,
    scalableSolutionsFuelDeliveryIcon,
    transparentCommunicationFuelDeliveryIcon,
  },

  liquorPageIcons: {
    brandLoyaltyIcon,
    enhancedShoppingExperienceIcon,
    highDemhighDemandandIcon,
    improvedSupportIcon,
    stayingCompetitiveIcon,
    targetedPromotionsIcon,

    barsPubsIcon,
    breweryDistilleryIcon,
    liquorAggregatorPlatformsIcon,
    liquorChainIcon,
    liquorDeliveryServicesIcon,
    wineShopsIcon,

    comprehensiveFeaturesLiquorIcon,
    customizedSolutionsLiquorIcon,
    endToEndSupportIcon,
    provenExpertiseLiquorIcon,
    scalabilityLiquorIcon,
    transparencyLiquorIcon,
  },
  computerVisionIcons: {
    automatingRoutineTasksIcon,
    costReductionIcon,
    enhancedCustomerExperiencesComputerVisionIcon,
    increasedEfficiencyIcon,
    qualityControlIcon,
    riskMitigationComputerVisionIcon,

    bankingAndFinanceComputerVisionIcon,
    ecommerceComputerVisionIcon,
    educationComputerVisionIcon,
    foodRestaurantComputerVisionIcon,
    healthFitnessComputerVisionIcon,
    hospitalityTravelComputerVisionIcon,
    mediaEntertainmentComputerVisionIcon,
    onDemandServicesComputerVisionIcon,
    realEstateComputerVisionIcon,
    socialNetworkingComputerVisionIcon,

    aiBasedImageRecognitionIcon,
    computerVisionConsultingServicesIcon,
    computerVisionDataServicesIcon,
    computerVisionSystemIntegrationIcon,
    customComputerVisionDevelopmentIcon,
    facialRecognitionIcon,
    modelDesignAndOptimizationIcon,

    customizedDevelopmentIcon,
    flexibleEngagementModelsIcon,
    industrySpecificSolutionsIcon,
    provenExpertiseComputerVisionIcon,
    technicalExcellenceIcon,
    transparentCommunicationComputerVisionIcon,
  },

  aiChatBotBenefits: {
    consistentServiceQualityAIChatbotIcon,
    costEfficiencyAIChatbotIcon,
    humanLikePersonalizationAIChatbotIcon,
    realTimeResponsesAIChatbotIcon,
    roundTheClockAvailabilityAIChatbotIcon,
    workflowAutomationAIChatbotIcon,
  },

  aiChatBotIndustries: {
    bankingAndFinanceAIChatbotIcon,
    ecommerceAIChatbotIcon,
    educationAIChatbotIcon,
    foodRestaurantAIChatbotIcon,
    genericIndustryAIChatbotIcon,
    hospitalityTravelAIChatbotIcon,
    mediaEntertainmentAIChatbotIcon,
    onDemandServicesAIChatbotIcon,
    realEstateAIChatbotIcon,
    socialNetworkingAIChatbotIcon,
  },

  aiChatBotServices: {
    aiChatbotConsultingAIChatbotIcon,
    aiChatbotDesignAIChatbotIcon,
    aiChatbotMaintenanceSupportAIChatbotIcon,
    aiChatbotTestingAIChatbotIcon,
    aiChatbotUpgradeAIChatbotIcon,
    customAiChatbotDevelopmentAIChatbotIcon,
    securityAIChatbotIcon,
  },

  aiChatBotWhyKonstant: {
    businessFirstApproachAIChatbotIcon,
    flexibleEngagementModelsAIChatbotIcon,
    dynamicCustomizationAIChatbotIcon,
    scalabilityAIChatbotIcon,
    skilledCertifiedDevelopersAIChatbotIcon,
    security,
  },

  aiAgentBenefits: {
    availability247AIAgentIcon,
    enhancedDecisionMakingAIAgentIcon,
    automateRepetitiveTasksAIAgentIcon,
    tailoredUserExperienceAIAgentIcon,
    scalabilityAIAgentIcon,
    costEfficiencyAIAgentIcon,
  },

  aiAgentIndustries: {
    bankingAndFinanceAIAgentIcon,
    healthFitnessAIAgentIcon,
    hospitalityTravelAIAgentIcon,
    mediaEntertainmentAIAgentIcon,
    onDemandServicesAIAgentIcon,
    realEstateAIAgentIcon,
    socialNetworkingAIAgentIcon,
    foodRestaurantAIAgentIcon,
    educationAIAgentIcon,
    ecommerceAIAgentIcon,
  },

  aiAgentServices: {
    agentBehavioralModellingAIAgentIcon,
    aiAgentDeploymentAndScalabilityAIAgentIcon,
    aiAgentIntegrationServicesAIAgentIcon,
    aiAgentOptimizationAIAgentIcon,
    aiAgentStrategyConsultingAIAgentIcon,
    customAiAgentDevelopmentAIAgentIcon,
  },

  aiAgentWhyKonstant: {
    agenticAiExpertiseAIAgentIcon,
    businessOutcomeFocusAIAgentIcon,
    endToEndSolutionsAIAgentIcon,
    fullyCustomAgentsAIAgentIcon,
    futureProofStrategyAIAgentIcon,
    scalableSolutionsAIAgentIcon,
  },

  MLBenefits: {
    advancedPersonalizationIcon,
    boostedOperationalEfficiencyIcon,
    predictiveMaintenanceIcon,
    smarterFinancialAnalysisIcon,
    enhancedCustomerSatisfactionIcon,
    improvedForecastIcon,
  },

  MLIndustries: {
    bankingAndFinanceMLIcon,
    ecommerceMLIcon,
    healthFitnessMLIcon,
    mediaEntertainmentMLIcon,
    realEstateMLIcon,
    socialNetworkingMLIcon,
    hospitalityTraveMLlIcon,
    onDemandServicesMLIcon,
    foodRestaurantMLIcon,
    educationMLIcon,
  },

  whyKonstantML: {
    businessFirstApproachMLIcon,
    onTimeDeliveryMLIcon,
    sophisticatedTechnologyMLIcon,
    transparencyMLIcon,
    trustworthyPartnerMLIcon,
    vettedProfessionalsMLIcon,
  },

  MLServices: {
    machineLearningAsAServiceIcon,
    machineLearningConsultingIcon,
    mlModelDevelopmentIcon,
    machineLearningDevelopmentIcon,
    modelTrainingAndFineTuningIcon,
    mlopsServicesIcon,
  },

  whyKonstantAR: {
    builtInScalabilityARIcon,
    clientCentricApproachARIcon,
    provenTrackRecordARIcon,
    onTimeDeliveryARIcon,
    experiencedTeamARIcon,
    domainExpertiseARIcon,
  },

  ARServices: {
    arAppConsultationARIcon,
    arAppSupportAndMaintenanceARIcon,
    arGameAppDevelopmentARIcon,
    arUiUxDesignARIcon,
    customArAppSolutionsARIcon,
  },

  ARIndustries: {
    realEstateARIcon,
    socialNetworkingARIcon,
    onDemandServicesARIcon,
    mediaEntertainmentARIcon,
    healthFitnessARIcon,
    bankingAndFinanceARIcon,
    hospitalityTraveARlIcon,
    educationARIcon,
    foodRestaurantARIcon,
    ecommerceARIcon,
  },

  ARBenefits: {
    contentFlexibilityIcon,
    enhancedBrandAwarenessIcon,
    seamlessConnectivityIcon,
    reducingLanguageBarriersIcon,
    immersiveUserExperienceIcon,
    fastAdaptationIcon,
  },

  VRBenefits: {
    costSavingsIcon,
    enhancedUserEngagementIcon,
    immersiveExperiencesIcon,
    innovativeDifferentiationIcon,
    innovativeTrainingIcon,
    marketingEdgeIcon,
  },

  whyKonstantVR: {
    competitiveRatesIconVR,
    vastExperienceIconVR,
    supportAndMaintenanceIconVR,
    quickTurnaroundIconVR,
    strongTeamIconVR,
    agileMethodologyIconVR,
  },

  VRServices: {
    customVrAppDevelopmentIconVR,
    vrConsultationIconVR,
    vrGameDevelopmentServicesIconVR,
    vrHeadsetAppDevelopmentIconVR,
    vrSupportAndMaintenanceIconVR,
    vrWebAppDevelopmentIconVR,
  },

  vrIndustriesIcons: {
    healthFitnessIconVR,
    realEstateIconVR,
    onDemandServicesIconVR,
    bankingAndFinanceIconVR,
    ecommerceIconVR,
    educationIconVR,
    foodRestaurantIconVR,
    hospitalityTravelIconVR,
    mediaEntertainmentIconVR,
    socialNetworkingIconVR,
  },

  whyAiChatBot: {
    securityIconAIChatBot,
    dynamicCustomizationIconAIChatBot,
    skilledCertifiedDevelopersIconAIChatBot,
    scalabilityIconAIChatBot,
    flexibleEngagementModelsIconAIChatBot,
    businessFirstApproachIconAIChatBot,
  },

  aiChatBotBenifits: {
    consistentServiceQualityAIChatbotIcon,
    costEfficiencyIconAIChatBot,
    humanLikePersonalizationIconAIChatBot,
    realTimeResponsesIconAIChatBot,
    roundTheClockAvailabilityIconAIChatBot,
    workflowAutomationIconAIChatBot,
  },

  whyChooseGenerativeAI: {
    competitiveSolutionsIconGenerativeAI,
    transparentCommunicationIconGenerativeAI,
    strategicConversationIconGenerativeAI,
    domainSpecificCustomizationIconGenerativeAI,
    provenTrackRecordIconGenerativeAI,
    fullStackExpertiseIconGenerativeAI,
  },

  generativeAIBenifitsArray: {
    generativeAiAppDevelopmentIconGenerativeAI,
    generativeAiConsultingIconGenerativeAI,
    generativeAiIntegrationIconGenerativeAI,
    generativeAiModelDevelopmentIconGenerativeAI,
    generativeAiModelFineTuningIconGenerativeAI,
    generativeAiModelReplicationIconGenerativeAI,
  },

  generativeAIIndustryIcons: {
    bankingAndFinanceIconGenerativeAI,
    ecommerceIconGenerativeAI,
    educationIconGenerativeAI,
    foodRestaurantIconGenerativeAI,
    healthFitnessIconGenerativeAI,
    mediaEntertainmentIconGenerativeAI,
    onDemandServicesIconGenerativeAI,
    realEstateIconGenerativeAI,
    socialNetworkingIconGenerativeAI,
    hospitalityTravelIconGenerativeAI,
  },

  generativeAIBenifits: {
    boostProfitabilityIconGenerativeAI,
    dataDrivenInsightsIconGenerativeAI,
    efficiencyAndAutomationIconGenerativeAI,
    personalizedExperiencesIconGenerativeAI,
    smartWorkflowOptimizationIconGenerativeAI,
    smootherOperationsIconGenerativeAI,
  },

  whyAiConsulting: {
    businessFirstApproachIcon,
    focusOnSuccessIcon,
    tailoredSolutionsIconAiConsulting,
    provenExpertiseIconAiConsulting,
    responsibleAiPracticesIcon,
    ongoingSupportIcon,
  },

  aiConsultingServiceIcons: {
    aiRapidPrototypingIcon,
    aiStrategyAndValueIdentificationIcon,
    aiTechnologyConsultingIcon,
    dataReadinessConsultingIcon,
    generativeAiConsultingIcon,
    enterpriseAiConsultingIcon,
  },

  aiConsultingIndustries: {
    bankingAndFinanceIconAiCp,
    ecommerceIconAiConsulting,
    educationIconAiConsulting,
    foodRestaurantIconAiConsulting,
    healthFitnessIconAiConsulting,
    mediaEntertainmentIconAiConsulting,
    hospitalityTravelIconAiConsulting,
    onDemandServicesIconAiConsulting,
    realEstateIconAiConsulting,
    socialNetworkingIconAiConsulting,
  },

  aiConsultingBenefits: {
    efficientProblemSolvingIcon,
    enhancedCustomerExperiencesIcon,
    facilitatedRecruitmentIcon,
    improvedCybersecurityIcon,
    increasedEmployeeProductivityIcon,
    newRevenueStreamsIcon,
  },

  aiIntegratedBenifitsSection: {
    automatingRepetitiveTasksIcon,
    dataDrivenInsightsIcon,
    personalizedCustomerExperiencesIconAIIntegrated,
    processOptimizationIcon,
    riskMitigationIcon,
    seamlessSystemIntegrationIcon,
  },

  aiIntegratedIndustry: {
    bankingAndFinanceIconAIIntegrated,
    ecommerceIconAIIntegrated,
    educationIconAIIntegrated,
    foodRestaurantIconAIIntegrated,
    healthFitnessIconAIIntegrated,
    hospitalityTravelIconAIIntegrated,
    mediaEntertainmentIconAIIntegratedAIIntegrated,
    onDemandServicesIconAIIntegrated,
    realEstateIconAIIntegrated,
    socialNetworkingIconAIIntegrated,
  },

  aiIntegratedBenifits: {
    adaptiveAiIntegrationIcon,
    aiAndMlModelsIntegrationIcon,
    aiIntegrationConsultingIcon,
    chatgptIntegrationServicesIcon,
    openAiIcon,
    dataIntegrationAndAnalyticsIcon,
    generativeAiIntegrationIcon,
  },

  aiIntegreatedChooseIcons: {
    aiExpertiseIconAIIntegrated,
    commitmentToInnovationIcon,
    dedicatedSupportIcon,
    endToEndImplementationIcon,
    provenSuccessIcon,
    seamlessIntegrationIcon,
    tailoredSolutionsIconAIIntegrated,
  },

  aiPoweredBenifitsSection: {
    sustainableGrowthIcon,
    marketAdaptabilityIcon,
    operationalExcellenceIcon,
    customerCentricityIcon,
    continuousInnovationIcon,
    dataBackedStrategyIcon,
  },

  aiPoweredIndustrySection: {
    bankingAndFinanceIconAIPowered,
    ecommerceIconAIPowered,
    educationIconAIPowered,
    foodRestaurantIconAIPowered,
    healthFitnessIconAIPowered,
    hospitalityTravelIconAIPowered,
    mediaEntertainmentIconAIPowered,
    onDemandServicesIconAIPowered,
    realEstateIconAIPowered,
    socialNetworkingIconAIPowered,
  },

  aIPoweredTechnology: {
    aiAdoptionStrategyIcon,
    aiAndCustomerExperienceIcon,
    aiForOperationalEfficiencyIcon,
    aiGovernanceAndEthicsIcon,
    aiInBusinessProcessAutomationIcon,
    customAiBusinessTransformationIcon,
  },
  whyChooseAIPowered: {
    aiExpertiseIcon,
    customerFocusedStrategyIcon,
    establishedPerformanceIcon,
    innovationIcon,
    scalabilityIconAIPowered,
    modernSolutionsIcon,
  },

  metaVerseServices: {
    space3dDevelopmentIcon,
    metaverseAvatarDevelopmentIcon,
    metaverseAppDevelopmentServicesIcon,
    metaverseEnterpriseIntegrationIcon,
    metaverseGameDevelopmentServicesIcon,
    metaverseNftMarketplaceDevelopmentIcon,
  },

  whyChooseMetaVerse: {
    customizedSolutionsIcon,
    enhancedSecurityIcon,
    metaverseExpertiseIcon,
    qualityAssuranceIconMetaVerse,
    seamlessCollaborationIcon,
    uncompromisedTransparencyIcon,
  },

  metVerseIndustryIcons: {
    bankingAndFinanceIconMetaVerse,
    ecommerceIconMetaVerse,
    educationIconMetaVerse,
    foodRestaurantIconMetaVerse,
    healthFitnessIconMetaVerse,
    hospitalityTravelIconMetaVerse,
    mediaEntertainmentIconMetaVerse,
    onDemandServicesIconMetaVerse,
    realEstateIconMetaVerse,
    socialNetworkingIconMetaVerse,
  },

  metaVerseBenifits: {
    futureReadyStrategyIcon,
    globalReachIcon,
    improvedCollaborationIcon,
    innovativeExperiencesIcon,
    newRevenueOpportunitiesIcon,
    personalizedCustomerExperiencesIcon,
    strongerUserEngagementIcon,
  },

  saasBenifitsStep: {
    icons1: costEffectiveIcon,
    icons2: scalabilityIcon,
    icons3: easyToUseIcon,
    icons4: dataSecurityIcon,
    icons5: advancedSolutionsIcon,
    icons6: fastDeploymentIcon,
  },

  saasWhyChooseIcons: {
    Icons1: saasExpertiseIcon,
    Icons2: experienceDrivenIcon,
    Icons3: transparencyIcon,
    Icons4: strongCapabilitiesIcon,
    Icons5: tailoredSolutionsIconSaas,
    Icons6: reliableSupportIcon,
  },

  saasTechIcons: {
    Icon1: saasAppUiUxDesignIcon,
    Icon2: saasProductDevelopmentIcon,
    Icon3: saasMobileAppDevelopmentIcon,
    Icon4: saasModernizationAndSupportIcon,
    Icon5: saasAppSupportAndMaintenanceIcon,
  },

  saasIcons: {
    Icon1: realEstateIcon,
    Icon2: onDemandServicesIcon,
    Icon3: socialNetworkingIcon,
    Icon4: foodRestaurantIcon,
    Icon5: bankingAndFinanceIcon,
    Icon6: educationIcon,
    Icon7: ecommerceIcon,
    Icon8: hospitalityTravelIcon,
    Icon9: mediaEntertainmentIcon,
    Icon10: healthFitnessIcon,
  },

  stripWhyStrip: {
    reason1: developerFriendlyApiIcon,
    reason2: flexibleBillingModelsIcon,
    reason3: realTimeWebhooksIcon,
    reason4: comprehensiveFeaturesIcon,
    reason5: builtInSecurityIcon,
    reason6: globalPaymentSupportIcon,
  },

  stripWhyKonstant: {
    reason1: shopifyStripeIntegrationWhyIcon,
    reason2: certifiedExpertsIcon,
    reason3: tailoredSolutionsIcon,
    reason4: budgetFriendlyIcon,
    reason5: improvedPaymentExperienceIcon,
    reason6: resultFocusedApproachIcon,
  },

  stripService: {
    service1: customStripeIntegrationServicesIcon,
    service2: stripeMobileAppIntegrationIcon,
    service3: stripeDashboardSolutionsIcon,
    service4: hubspotStripeIntegrationIcon,
    service5: stripeSalesforceIntegrationIcon,
    service6: shopifyStripeIntegrationIcon,
  },

  backendService: {
    service1: backendConsultingIcon,
    service2: backendAppDevelopmentIcon,
    service3: backendWebDevelopmentServicesIcon,
    service4: cloudBackendSolutionsIcon,
    service5: backendCodeRefactoringIcon,
    service6: backendMaintenanceAndSupportIcon,
  },

  whyChooseBackend: {
    reason1: productOrientedApproachIcon,
    reason2: prioritizingSecurityIcon,
    reason3: provenExpertiseIcon,
    reason4: strongProjectManagementIcon,
    reason5: complianceAdherenceIcon,
    reason6: qualityAssuranceIcon,
  },

  whyBackend: {
    benefit1: excellentFunctionalityIcon,
    benefit2: applicationLogicIcon,
    benefit3: smoothOperationIcon,
    benefit4: outstandingUserExperienceIcon,
    benefit5: greatVarietyIcon,
    benefit6: highSecurityIcon,
  },

  frontendWhyChooseIcon: {
    reason1: onTimeDeliveryIcon,
    reason2: agileDevelopmentIcon,
    reason3: collaborativeApproachIcon,
    reason4: transparentCommunicationIcon,
    reason5: supportContinuityIcon,
    reason6: scalableSolutionsIcon,
  },

  whyFrontend: {
    benefit1: increasedConversionRatesIcon,
    benefit2: powerfulFunctionalityIcon,
    benefit3: improvedNavigationIcon,
    benefit4: crossDeviceCompatibilityIcon,
    benefit5: optimalPerformanceIcon,
    benefit6: goodFirstImpressionIcon,
  },

  frontendServices: {
    service1: frontendDesignAndArchitectureIcon,
    service2: customFrontendDevelopmentIcon,
    service3: progressiveWebAppDevelopmentIcon,
    service4: microFrontendDevelopmentIcon,
    service5: singlePageApplicationsIcon,
    service6: responsiveWebDesignIcon,
  },

  technologyIcon: {
    mvpDevelopment: mvpDevelopment,
    rapidPrototyping: rapidPrototyping,
    costOptimizedArchitecture: costOptimizedArchitecture,
    scaleReadyDesign: scaleReadyDesign,
    IterativeReleases: IterativeReleases,
    fastApiIcon: fastApiIcon,
    spacyIcon: spacyIcon,
    amazonLexIcon: amazonLexIcon,
    angularIcon: angularIcon,
    awsIcon: awsIcon,
    azureIcon: azureIcon,
    djangoIcon: djangoIcon,
    flaskIcon: flaskIcon,
    gcpIcon: gcpIcon,
    googleDialogflowIcon: googleDialogflowIcon,
    hallucinationControlIcon: hallucinationControlIcon,
    ibmWatsonAssistantIcon: ibmWatsonAssistantIcon,
    llmsIcon: llmsIcon,
    microsoftBotFrameworkIcon: microsoftBotFrameworkIcon,
    microsoftCognitiveToolkitIcon: microsoftCognitiveToolkitIcon,
    multiChannelBotsIcon: multiChannelBotsIcon,
    nodeJsIcon: nodeJsIcon,
    promptEngineeringIcon: promptEngineeringIcon,
    pythonIcon: pythonIcon,
    pytorchIcon: pytorchIcon,
    ragIcon: ragIcon,
    reactIcon: reactIcon,
    rubyIcon: rubyIcon,
    tensorflowIcon: tensorflowIcon,
    vectorDatabasesIcon: vectorDatabasesIcon,
    vuejsIcon: vuejsIcon,
    aFrameIcon: aFrameIcon,
    babylonjsIcon: babylonjsIcon,
    cPlusPlusIcon: cPlusPlusIcon,
    cSharpIcon: cSharpIcon,
    firebaseIcon: firebaseIcon,
    godotIcon: godotIcon,
    javascriptIcon: javascriptIcon,
    metaQuestDkIcon: metaQuestDkIcon,
    openxrIcon: openxrIcon,
    react360Icon: react360Icon,
    steamvrIcon: steamvrIcon,
    threeJsIcon: threeJsIcon,
    unityIcon: unityIcon,
    unrealEngineIcon: unrealEngineIcon,

    arcoreIcon: arcoreIcon,
    arkitIcon: arkitIcon,
    artoolkitIcon: artoolkitIcon,
    googleCloudIcon: googleCloudIcon,
    kotlinIcon: kotlinIcon,
    maxstIcon: maxstIcon,
    swiftIcon: swiftIcon,
    vueJsIcon: vueJsIcon,
    vuforiaIcon: vuforiaIcon,
    webarIcon: webarIcon,
    wikitudeIcon: wikitudeIcon,

    agentWorkflowsIcon: agentWorkflowsIcon,
    claudeIcon: claudeIcon,
    dockerIcon: dockerIcon,
    faissIcon: faissIcon,
    geminiIcon: geminiIcon,
    gpt45Gpt4oIcon: gpt45Gpt4oIcon,
    kerasIcon: kerasIcon,
    langChainIcon: langChainIcon,
    langChainTechIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/lang-chain-tech.svg`,
    awsS3Icon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/aws-s3-icon.svg`,
    cdnAssetIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/cdn-asset-icon.svg`,
    restApiIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/rest-api-icon.svg`,
    kafkaIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/kafka-icon.svg`,
    ebayApiIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ebay-api-icon.svg`,
    amazonPrdouctIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/amazon-product-api.svg`,
    secureTokenIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/secure-token-icon.svg`,
    backgroundJobIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/background-job-icon.svg`,
    deepSeekIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/deep-seek-icon.svg`,
    recruitWorkflowIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/recruit-workflow-icon.svg`,
    aiCandidateIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-candidate-icon.svg`,
    semanticSearchIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/semantic-search-icon.svg`,
    convIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/conv-ai-icon.svg`,
    stripeIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/stripe-icon.svg`,
    ciCdIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ci-cd-icon.svg`,
    twilioIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/twilio-icon.svg`,
    rocketReachIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/rocket-reach-icon.svg`,
    mariaDbIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/maria-db-icon.svg`,
    otpAuthIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/otp-auth-icon.svg`,
    apiSecurityIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/api-security-icon.svg`,
    roleBasedIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/role-based-icon.svg`,
    awsEc2Icon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/aws-ec2-icon.svg`,
    awsRdsIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/aws-rds-icon.svg`,
    awsCloudFrontIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/aws-cloudfront-icon.svg`,
    aiSeoIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/ai-seo-icon.svg`,
    promptIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/prompt-icon.svg`,
    automatedInsightIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/automated-insight-icon.svg`,
    pandasIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/pandas-icon.svg`,
    whatsappBusinessIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/whatsapp-business-icon.svg`,
    typescriptIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/typescript-icon.svg`,
    rechartsIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/recharts-icon.svg`,
    grokIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/grok-icon.svg`,
    openAiImageIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/open-ai-image-icon.svg`,
    stabilityAiIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/stability-ai-icon.svg`,
    semanticVectorIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/semantic-vector-icon.svg`,
    ragTechIcon: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/rag-icon.svg`,
    llamaIndexIcon: llamaIndexIcon,
    llamaIcon: llamaIcon,
    memoryReasoningChainsIcon: memoryReasoningChainsIcon,
    mistralIcon: mistralIcon,
    opensearchIcon: opensearchIcon,
    pineconeIcon: pineconeIcon,
    qdrantIcon: qdrantIcon,
    toolCallingIcon: toolCallingIcon,
    weaviateIcon: weaviateIcon,

    earlyUserFeedbackLoopsIcon: earlyUserFeedbackLoopsIcon,
    expressJsIcon: expressJsIcon,
    featurePrioritizationIcon: featurePrioritizationIcon,
    flutterIcon: flutterIcon,
    githubIcon: githubIcon,
    iterativeReleasesIcon: iterativeReleasesIcon, // No Update With CDN Server File Name ISSSUE
    mongodbIcon: mongodbIcon,
    mvpDeliveryIcon: mvpDeliveryIcon,
    nestjsIcon: nestjsIcon,
    nextJsIcon: nextJsIcon,
    postgresqlIcon: postgresqlIcon,
    rapidPrototypingIcon: rapidPrototypingIcon,
    rasaIcon: rasaIcon,
    reactJsIcon: reactJsIcon,
    reactNativeIcon: reactNativeIcon,
    dotNetCoreIcon: dotNetCoreIcon,
    erpCrmIntegrationIcon: erpCrmIntegrationIcon,
    javaIcon: javaIcon,
    kubernetesIcon: kubernetesIcon,
    legacySystemConnectivityIcon: legacySystemConnectivityIcon,
    mysqlIcon: mysqlIcon,
    restApisIcon: restApisIcon,
    thirdPartySystemIntegrationIcon: thirdPartySystemIntegrationIcon,

    ApiIntegrationStrategy: `${ICON_BASE_URL}/assets/icons/consulting_services/api-integration-strategy.svg`,
    ArchitectureReviewRecommendations: `${ICON_BASE_URL}/assets/icons/consulting_services/architecture-review-recommendations.svg`,
    Aws: `${ICON_BASE_URL}/assets/icons/Cloud/aws.svg`,
    Azure: `${ICON_BASE_URL}/assets/icons/consulting_services/azure.svg`,
    CloudMigrationPlanning: `${ICON_BASE_URL}/assets/icons/consulting_services/cloud-migration-planning.svg`,
    CloudReadinessAssessment: `${ICON_BASE_URL}/assets/icons/consulting_services/cloud-readiness-assessment.svg`,
    CostOptimizationStrategy: `${ICON_BASE_URL}/assets/icons/consulting_services/cost-optimization-strategy.svg`,
    Docker: `${ICON_BASE_URL}/assets/icons/Cloud/docker.svg`,
    GoogleCloud: `${ICON_BASE_URL}/assets/icons/consulting_services/google-cloud.svg`,
    Kubernetes: `${ICON_BASE_URL}/assets/icons/Cloud/kubernetes.svg`,
    LegacySystemModernization: `${ICON_BASE_URL}/assets/icons/consulting_services/legacy-system-modernization.svg`,
    Magento: `${ICON_BASE_URL}/assets/icons/consulting_services/magento.svg`,
    MonolithToMicroservicesStrategy: `${ICON_BASE_URL}/assets/icons/consulting_services/monolith-to-microservices-strategy.svg`,
    MultiTenantSaasArchitecture: `${ICON_BASE_URL}/assets/icons/consulting_services/multi-tenant-saas-architecture.svg`,
    OngoingCtoArchitectSupport: `${ICON_BASE_URL}/assets/icons/consulting_services/ongoing-cto-architect-support.svg`,
    ScalabilityPerformancePlanning: `${ICON_BASE_URL}/assets/icons/consulting_services/scalability-performance-planning.svg`,
    SecurityComplianceAdvisory: `${ICON_BASE_URL}/assets/icons/consulting_services/security-compliance-advisory.svg`,
    Shopify: `${ICON_BASE_URL}/assets/icons/consulting_services/shopify.svg`,
    ShortTermAdvisoryWeeks: `${ICON_BASE_URL}/assets/icons/consulting_services/short-term-advisory-weeks.svg`,
    SolutionArchitectureSystemDesign: `${ICON_BASE_URL}/assets/icons/consulting_services/solution-architecture-system-design.svg`,
    TechnicalDueDiligence: `${ICON_BASE_URL}/assets/icons/consulting_services/technical-due-diligence.svg`,
    TechnologyStackSelection: `${ICON_BASE_URL}/assets/icons/consulting_services/technology-stack-selection.svg`,
    Woocommerce: `${ICON_BASE_URL}/assets/icons/consulting_services/woocommerce.svg`,

    DotNetCore: `${ICON_BASE_URL}/assets/icons/Cloud/.net-core.svg`,
    Angular: `${ICON_BASE_URL}/assets/icons/NFT/angular.svg`,
    CiCdPipelines: `${ICON_BASE_URL}/assets/icons/Cloud/ci-cd-pipelines.svg`,
    GitBasedWorkflows: `${ICON_BASE_URL}/assets/icons/Cloud/git-based-workflows.svg`,
    GoogleCloudPlatform: `${ICON_BASE_URL}/assets/icons/Cloud/google-cloud-platform.svg`,
    Iaas: `${ICON_BASE_URL}/assets/icons/Cloud/iaas.svg`,
    Java: `${ICON_BASE_URL}/assets/icons/wearable_app/java.svg`,
    MicrosoftAzure: `${ICON_BASE_URL}/assets/icons/Cloud/microsoft-azure.svg`,
    Mongodb: `${ICON_BASE_URL}/assets/icons/progressive_web/mongodb.svg`,
    MonitoringLogging: `${ICON_BASE_URL}/assets/icons/Cloud/monitoring-logging.svg`,
    Mysql: `${ICON_BASE_URL}/assets/icons/progressive_web/mysql.svg`,
    Nodejs: `${ICON_BASE_URL}/assets/icons/NFT/nodejs.svg`,
    Paas: `${ICON_BASE_URL}/assets/icons/Cloud/paas.svg`,
    Postgresql: `${ICON_BASE_URL}/assets/icons/progressive_web/postgresql.svg`,
    Python: `${ICON_BASE_URL}/assets/icons/NFT/python.svg`,
    Reactjs: `${ICON_BASE_URL}/assets/icons/NFT/reactjs.svg`,
    Saas: `${ICON_BASE_URL}/assets/icons/Cloud/saas.svg`,
    Vuejs: `${ICON_BASE_URL}/assets/icons/NFT/vuejs.svg`,

    FiveGLte: `${ICON_BASE_URL}/assets/icons/IOT/5g-lte.svg`,
    Amqp: `${ICON_BASE_URL}/assets/icons/IOT/amqp.svg`,
    AwsIotCore: `${ICON_BASE_URL}/assets/icons/IOT/aws-iot-core.svg`,
    Ble: `${ICON_BASE_URL}/assets/icons/IOT/ble.svg`,
    Bluetooth: `${ICON_BASE_URL}/assets/icons/wearable_app/bluetooth.svg`,
    CloudSync: `${ICON_BASE_URL}/assets/icons/IOT/cloud-sync.svg`,
    Coap: `${ICON_BASE_URL}/assets/icons/IOT/coap.svg`,
    CustomGcpBasedIotArchitectures: `${ICON_BASE_URL}/assets/icons/IOT/custom-gcp-based-iot-architectures.svg`,
    Ethernet: `${ICON_BASE_URL}/assets/icons/IOT/ethernet.svg`,
    Flutter: `${ICON_BASE_URL}/assets/icons/technology_icon/Flutter.svg`,
    Golang: `${ICON_BASE_URL}/assets/icons/NFT/golang.svg`,
    GsmNetwork: `${ICON_BASE_URL}/assets/icons/IOT/gsm-network.svg`,
    Influxdb: `${ICON_BASE_URL}/assets/icons/IOT/influxdb.svg`,
    Kotlin: `${ICON_BASE_URL}/assets/icons/wearable_app/kotlin.svg`,
    MicrosoftAzureIotHub: `${ICON_BASE_URL}/assets/icons/IOT/microsoft-azure-iot-hub.svg`,
    Mqtt: `${ICON_BASE_URL}/assets/icons/wearable_app/mqtt.svg`,
    NodeJs: `${ICON_BASE_URL}/assets/icons/progressive_web/node-js.svg`,
    ReactNative: `${ICON_BASE_URL}/assets/icons/wearable_app/react-native.svg`,
    React: `${ICON_BASE_URL}/assets/icons/IOT/react.svg`,
    Sensors: `${ICON_BASE_URL}/assets/icons/IOT/sensors.svg`,
    Swift: `${ICON_BASE_URL}/assets/icons/wearable_app/swift.svg`,
    Timescaledb: `${ICON_BASE_URL}/assets/icons/IOT/timescaledb.svg`,
    Wireless: `${ICON_BASE_URL}/assets/icons/IOT/wireless.svg`,
    Xmpp: `${ICON_BASE_URL}/assets/icons/IOT/xmpp.svg`,

    AspNet: `${ICON_BASE_URL}/assets/icons/progressive_web/asp-net.svg`,
    Cassandra: `${ICON_BASE_URL}/assets/icons/progressive_web/cassandra.svg`,
    Mssql: `${ICON_BASE_URL}/assets/icons/progressive_web/mssql.svg`,
    Php: `${ICON_BASE_URL}/assets/icons/progressive_web/php.svg`,
    ReactJs: `${ICON_BASE_URL}/assets/icons/progressive_web/react-js.svg`,
    Svelte: `${ICON_BASE_URL}/assets/icons/progressive_web/svelte.svg`,

    AccessibilityInsights: `${ICON_BASE_URL}/assets/icons/web_design/accessibility-insights.svg`,
    AdobeIllustrator: `${ICON_BASE_URL}/assets/icons/web_design/adobe-illustrator.svg`,
    AdobePhotoshop: `${ICON_BASE_URL}/assets/icons/web_design/adobe-photoshop.svg`,
    AdobeXd: `${ICON_BASE_URL}/assets/icons/web_design/adobe-xd.svg`,
    Aeplin: `${ICON_BASE_URL}/assets/icons/web_design/aeplin.svg`,
    AfterEffect: `${ICON_BASE_URL}/assets/icons/web_design/after-effect.svg`,
    Avocode: `${ICON_BASE_URL}/assets/icons/web_design/avocode.svg`,
    AxeDevtools: `${ICON_BASE_URL}/assets/icons/web_design/axe-devtools.svg`,
    AxureRp: `${ICON_BASE_URL}/assets/icons/web_design/axure-rp.svg`,
    Balsamiq: `${ICON_BASE_URL}/assets/icons/web_design/balsamiq.svg`,
    CrazyEgg: `${ICON_BASE_URL}/assets/icons/web_design/crazy-egg.svg`,
    Figjam: `${ICON_BASE_URL}/assets/icons/web_design/figjam.svg`,
    FigmaDevMod: `${ICON_BASE_URL}/assets/icons/web_design/figma-dev-mod.svg`,
    Figma: `${ICON_BASE_URL}/assets/icons/figma.svg`,
    Framer: `${ICON_BASE_URL}/assets/icons/web_design/framer.svg`,
    GoogleLighthouse: `${ICON_BASE_URL}/assets/icons/web_design/google-lighthouse.svg`,
    Hotjar: `${ICON_BASE_URL}/assets/icons/web_design/hotjar.svg`,
    Invision: `${ICON_BASE_URL}/assets/icons/web_design/invision.svg`,
    Lookback: `${ICON_BASE_URL}/assets/icons/web_design/lookback.svg`,
    Marvel: `${ICON_BASE_URL}/assets/icons/web_design/marvel.svg`,
    Maze: `${ICON_BASE_URL}/assets/icons/web_design/maze.svg`,
    Miro: `${ICON_BASE_URL}/assets/icons/web_design/miro.svg`,
    OptimalWorkshop: `${ICON_BASE_URL}/assets/icons/web_design/optimal-workshop.svg`,
    Sketch: `${ICON_BASE_URL}/assets/icons/web_design/sketch.svg`,
    Stark: `${ICON_BASE_URL}/assets/icons/web_design/stark.svg`,
    Ucidchart: `${ICON_BASE_URL}/assets/icons/web_design/ucidchart.svg`,
    Usabilityhub: `${ICON_BASE_URL}/assets/icons/web_design/usabilityhub.svg`,
    Usertesting: `${ICON_BASE_URL}/assets/icons/web_design/usertesting.svg`,
    Wave: `${ICON_BASE_URL}/assets/icons/web_design/wave.svg`,
    Whimsical: `${ICON_BASE_URL}/assets/icons/web_design/whimsical.svg`,

    Ethereum: `${ICON_BASE_URL}/assets/icons/NFT/ethereum.svg`,
    Expressjs: `${ICON_BASE_URL}/assets/icons/NFT/expressjs.svg`,
    Nestjs: `${ICON_BASE_URL}/assets/icons/NFT/nestjs.svg`,
    Nextjs: `${ICON_BASE_URL}/assets/icons/NFT/nextjs.svg`,
    Rust: `${ICON_BASE_URL}/assets/icons/NFT/rust.svg`,
    Solidity: `${ICON_BASE_URL}/assets/icons/NFT/solidity.svg`,
    Vyper: `${ICON_BASE_URL}/assets/icons/NFT/vyper.svg`,
    Web3js: `${ICON_BASE_URL}/assets/icons/NFT/web3js.svg`,

    AppleHealthkit: `${ICON_BASE_URL}/assets/icons/wearable_app/apple-healthkit.svg`,
    AppleMapkit: `${ICON_BASE_URL}/assets/icons/wearable_app/apple-mapkit.svg`,
    AppleWatch: `${ICON_BASE_URL}/assets/icons/wearable_app/apple-watch.svg`,
    Cpp: `${ICON_BASE_URL}/assets/icons/wearable_app/c++.svg`,
    Fitbit: `${ICON_BASE_URL}/assets/icons/wearable_app/fitbit.svg`,
    Garmin: `${ICON_BASE_URL}/assets/icons/wearable_app/garmin.svg`,
    GoogleFitApi: `${ICON_BASE_URL}/assets/icons/wearable_app/google-fit-api.svg`,
    GoogleMapsPlatform: `${ICON_BASE_URL}/assets/icons/wearable_app/google-maps-platform.svg`,
    Nfc: `${ICON_BASE_URL}/assets/icons/wearable_app/nfc.svg`,
    ObjectiveC: `${ICON_BASE_URL}/assets/icons/wearable_app/objective-c.svg`,
    SamsungGalaxyWatch: `${ICON_BASE_URL}/assets/icons/wearable_app/samsung-galaxy-watch.svg`,
    SamsungHealthSdk: `${ICON_BASE_URL}/assets/icons/wearable_app/samsung-health-sdk.svg`,
    Watchkit: `${ICON_BASE_URL}/assets/icons/wearable_app/watchkit.svg`,
    WearOs: `${ICON_BASE_URL}/assets/icons/wearable_app/wear-os.svg`,

    ApacheJmeter: `${ICON_BASE_URL}/assets/icons/quality_assurance/apache-jmeter.svg`,
    Postman: `${ICON_BASE_URL}/assets/icons/quality_assurance/postman.svg`,
    RestAssured: `${ICON_BASE_URL}/assets/icons/quality_assurance/rest-assured.svg`,
    SeleniumWebdriver: `${ICON_BASE_URL}/assets/icons/quality_assurance/selenium-webdriver.svg`,
    AI: `${ICON_BASE_URL}/assets/icons/technology_icon/AI.svg`,
    android: `${ICON_BASE_URL}/assets/icons/technology_icon/Android.svg`,
    Apple_Watch: `${ICON_BASE_URL}/assets/icons/technology_icon/Apple_Watch.svg`,
    BLE_Device_Integration: `${ICON_BASE_URL}/assets/icons/technology_icon/BLE_Device_Integration.svg`,
    Bootstrap: `${ICON_BASE_URL}/assets/icons/technology_icon/Bootstrap.svg`,
    Cakephp: `${ICON_BASE_URL}/assets/icons/technology_icon/Cakephp.svg`,
    codeigniter: `${ICON_BASE_URL}/assets/icons/technology_icon/Codeigniter.svg`,
    cross_Platform_App_Development_white: `${ICON_BASE_URL}/assets/icons/technology_icon/Cross_Platform_App_Development_white.svg`,
    crossPlatform: `${ICON_BASE_URL}/assets/icons/technology_icon/cross_Platform.svg`,
    Dagger: `${ICON_BASE_URL}/assets/icons/technology_icon/Dagger.svg`,
    Django: `${ICON_BASE_URL}/assets/icons/technology_icon/Django.svg`,
    DotNet: `${ICON_BASE_URL}/assets/icons/technology_icon/dot-net.svg`,
    ExpressJS: `${ICON_BASE_URL}/assets/icons/technology_icon/ExpressJS.svg`,
    Firebase: `${ICON_BASE_URL}/assets/icons/technology_icon/Firebase.svg`,
    Flask: `${ICON_BASE_URL}/assets/icons/technology_icon/Flask.svg`,
    flutter: `${ICON_BASE_URL}/assets/icons/technology_icon/Flutter.svg`,
    flutterWhite: `${ICON_BASE_URL}/assets/icons/technology_icon/flutter_White.svg`,
    Full_Stack: `${ICON_BASE_URL}/assets/icons/technology_icon/Full_Stack.svg`,
    Glide: `${ICON_BASE_URL}/assets/icons/technology_icon/Glide.svg`,
    IOS: `${ICON_BASE_URL}/assets/icons/technology_icon/IOS.svg`,
    JAVA: `${ICON_BASE_URL}/assets/icons/technology_icon/Java.svg`,
    Joomla: `${ICON_BASE_URL}/assets/icons/technology_icon/Joomla.svg`,
    Laravel: `${ICON_BASE_URL}/assets/icons/technology_icon/Laravel.svg`,
    Lottie: `${ICON_BASE_URL}/assets/icons/technology_icon/Lottie.svg`,
    magento: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento.svg`,
    mariadb: `${ICON_BASE_URL}/assets/icons/technology_icon/mariadb.svg`,
    MeanStack: `${ICON_BASE_URL}/assets/icons/technology_icon/MeanStack.svg`,
    MernStack: `${ICON_BASE_URL}/assets/icons/technology_icon/MernStack.svg`,
    microsoftsqlserver: `${ICON_BASE_URL}/assets/icons/technology_icon/microsoftsqlserver.svg`,
    ML: `${ICON_BASE_URL}/assets/icons/technology_icon/ML.svg`,
    MongoDB: `${ICON_BASE_URL}/assets/icons/technology_icon/MongoDB.svg`,
    MySql: `${ICON_BASE_URL}/assets/icons/technology_icon/MySql.svg`,
    NextJs: `${ICON_BASE_URL}/assets/icons/technology_icon/NextJs.svg`,
    php: `${ICON_BASE_URL}/assets/icons/ai_case_study_icons/php-tech.svg`,
    Photoshop: `${ICON_BASE_URL}/assets/icons/technology_icon/Photoshop.svg`,
    PostgreSql: `${ICON_BASE_URL}/assets/icons/technology_icon/PostSql.svg`,
    Realm: `${ICON_BASE_URL}/assets/icons/technology_icon/Realm.svg`,
    Redis: `${ICON_BASE_URL}/assets/icons/technology_icon/redis.svg`,
    Retrofit: `${ICON_BASE_URL}/assets/icons/technology_icon/Retrofit.svg`,
    Ruby: `${ICON_BASE_URL}/assets/icons/technology_icon/Ruby.svg`,
    Scalability: `${ICON_BASE_URL}/assets/icons/technology_icon/Scalability.svg`,
    Spring_Boot: `${ICON_BASE_URL}/assets/icons/technology_icon/Spring_Boot.svg`,
    SQLite: `${ICON_BASE_URL}/assets/icons/technology_icon/SQLite.svg`,
    Stetho: `${ICON_BASE_URL}/assets/icons/technology_icon/Stetho.svg`,
    Strapi: `${ICON_BASE_URL}/assets/icons/technology_icon/Strapi.svg`,
    Symfony: `${ICON_BASE_URL}/assets/icons/technology_icon/Symfony.svg`,
    Threejs: `${ICON_BASE_URL}/assets/icons/technology_icon/threejs.svg`,
    VueJS: `${ICON_BASE_URL}/assets/icons/technology_icon/Vue_JS.svg`,
    WearOS: `${ICON_BASE_URL}/assets/icons/technology_icon/WearOS.svg`,
    WebRTC: `${ICON_BASE_URL}/assets/icons/technology_icon/WebRTC.svg`,
    WooCommerce: `${ICON_BASE_URL}/assets/icons/technology_icon/WooCommerce.svg`,
    WordPress: `${ICON_BASE_URL}/assets/icons/technology_icon/WordPress.svg`,
    Yii: `${ICON_BASE_URL}/assets/icons/technology_icon/Yii.svg`,
    Zend: `${ICON_BASE_URL}/assets/icons/technology_icon/Zend.svg`,
    Zxing: `${ICON_BASE_URL}/assets/icons/technology_icon/Zxing.svg`,
    Ionic: `${ICON_BASE_URL}/assets/icons/technology_icon/ionic.svg`,
    TensorFlow: `${ICON_BASE_URL}/assets/icons/technology_icon/TensorFlow.svg`,
    CPLUS: `${ICON_BASE_URL}/assets/icons/technology_icon/CPLUS.svg`,
    NodeJS_2: `${ICON_BASE_URL}/assets/icons/technology_icon/NodeJS_2.svg`,
    Django_2: `${ICON_BASE_URL}/assets/icons/technology_icon/Django_2.svg`,
    RASA: `${ICON_BASE_URL}/assets/icons/technology_icon/RASA.svg`,
    Flask_2: `${ICON_BASE_URL}/assets/icons/technology_icon/Flask_2.svg`,
    PyTorch: `${ICON_BASE_URL}/assets/icons/technology_icon/PyTorch.svg`,
    Microsoft_Azure: `${ICON_BASE_URL}/assets/icons/technology_icon/Microsoft_Azure.svg`,

    Corda: `${ICON_BASE_URL}/assets/icons/technology_icon/Corda.svg`,
    EOSIO: `${ICON_BASE_URL}/assets/icons/technology_icon/EOSIO.svg`,
    Hyperledger_Sawtooth: `${ICON_BASE_URL}/assets/icons/technology_icon/Hyperledger_Sawtooth.svg`,
    Hyperlegder_Fabric: `${ICON_BASE_URL}/assets/icons/technology_icon/Hyperlegder_Fabric.svg`,
    Quorum: `${ICON_BASE_URL}/assets/icons/technology_icon/Quorum.svg`,

    Commerce_Order_Management_Magento: `${ICON_BASE_URL}/assets/icons/technology_icon/Commerce_Order_Management_Magento.svg`,
    CRM_ERP_PIM_Integration: `${ICON_BASE_URL}/assets/icons/technology_icon/CRM_ERP_PIM_Integration.svg`,
    Magento_1_to_2: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento_1_to_2.svg`,
    Magento_Enterprise: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento_Enterprise.svg`,
    Magento_Plugin_Customization: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento_Plugin_Customization.svg`,
    Magento_Responsive_Design: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento_Responsive_Design.svg`,
    Magento_Theme_Integration: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento_Theme_Integration.svg`,
    Magento2: `${ICON_BASE_URL}/assets/icons/technology_icon/Magento2.svg`,
    Migration_to_Magento: `${ICON_BASE_URL}/assets/icons/technology_icon/Migration_to_Magento.svg`,
    Module_Customization: `${ICON_BASE_URL}/assets/icons/technology_icon/Module_Customization.svg`,
    PSD_to_Magento_Customization: `${ICON_BASE_URL}/assets/icons/technology_icon/PSD_to_Magento_Customization.svg`,
    API_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/API_Development.svg`,
    CMS_Solution_Integration: `${ICON_BASE_URL}/assets/icons/technology_icon/CMS_Solution_Integration.svg`,
    Conversion_Optimization: `${ICON_BASE_URL}/assets/icons/technology_icon/Conversion_Optimization.svg`,
    Custom_Page_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/Custom_Page_Development.svg`,
    Migration_to_Shopify: `${ICON_BASE_URL}/assets/icons/technology_icon/Migration_to_Shopify.svg`,
    Mobile_Commerce: `${ICON_BASE_URL}/assets/icons/technology_icon/Mobile_Commerce.svg`,
    Multi_lingual_Setup: `${ICON_BASE_URL}/assets/icons/technology_icon/Multi_lingual_Setup.svg`,
    Online_Shopping_Cart_Management: `${ICON_BASE_URL}/assets/icons/technology_icon/Online_Shopping_Cart_Management.svg`,
    Payment_Gateway_ntegration: `${ICON_BASE_URL}/assets/icons/technology_icon/Payment_Gateway_ntegration.svg`,
    Shopify_Point_of_Sale: `${ICON_BASE_URL}/assets/icons/technology_icon/Shopify_Point_of_Sale.svg`,
    Theme_Customization: `${ICON_BASE_URL}/assets/icons/technology_icon/Theme_Customization.svg`,
    shopify_icon: `${ICON_BASE_URL}/assets/icons/technology_icon/shopify_icon.svg`,
    WooCommerce_Plugin_Customization: `${ICON_BASE_URL}/assets/icons/technology_icon/WooCommerce_Plugin_Customization.svg`,
    Complete_WooCommerce_WordPress_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/Complete_WooCommerce_WordPress_Development.svg`,
    Omni_channel_Planning: `${ICON_BASE_URL}/assets/icons/technology_icon/Omni_channel_Planning.svg`,
    WooCommerce_Theme_Customization: `${ICON_BASE_URL}/assets/icons/technology_icon/WooCommerce_Theme_Customization.svg`,
    Comprehensive_Order_Management: `${ICON_BASE_URL}/assets/icons/technology_icon/Comprehensive_Order_Management.svg`,
    Customized_eCommerce_Site_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/Customized_eCommerce_Site_Development.svg`,
    Desired_Payment_Gateway_Options: `${ICON_BASE_URL}/assets/icons/technology_icon/Desired_Payment_Gateway_Options.svg`,
    Third_Party_Integrations: `${ICON_BASE_URL}/assets/icons/technology_icon/Third_Party_Integrations.svg`,
    Personalized_Storefront: `${ICON_BASE_URL}/assets/icons/technology_icon/Personalized_Storefront.svg`,
    Scalable_Application: `${ICON_BASE_URL}/assets/icons/technology_icon/Scalable_Application.svg`,
    Mobile_Commerce_2: `${ICON_BASE_URL}/assets/icons/technology_icon/Mobile_Commerce_2.svg`,
    Conversion_Optimization_new: `${ICON_BASE_URL}/assets/icons/technology_icon/Conversion_Optimization_new.svg`,

    //Open Source Page Images
    Open_Source_Sof_ware_Consulting: `${ICON_BASE_URL}/assets/icons/technology_icon/Open_Source_Sof_ware_Consulting.svg`,
    Open_Source_CRM_ntegrations: `${ICON_BASE_URL}/assets/icons/technology_icon/Open_Source_CRM_ntegrations.svg`,
    Custom_Open_Source_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/Custom_Open_Source_Development.svg`,
    Open_Source_Database_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/Open_Source_Database_Development.svg`,
    Open_Source_ERP_Solutions: `${ICON_BASE_URL}/assets/icons/technology_icon/Open_Source_ERP_Solutions.svg`,
    Open_Source_eCommerce_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/Open_Source_eCommerce_Development.svg`,
    Open_Source_CRM_Solutions: `${ICON_BASE_URL}/assets/icons/technology_icon/Open_Source_CRM_Solutions.svg`,
    Cost_Efficiency: `${ICON_BASE_URL}/assets/icons/technology_icon/Cost_Efficiency.svg`,
    Community_Support: `${ICON_BASE_URL}/assets/icons/technology_icon/Community_Support.svg`,
    Enhanced_Transparency: `${ICON_BASE_URL}/assets/icons/technology_icon/Enhanced_Transparency.svg`,
    Avoiding_Vendor_Lock: `${ICON_BASE_URL}/assets/icons/technology_icon/Avoiding_Vendor_Lock.svg`,
    Competitive_Advantage: `${ICON_BASE_URL}/assets/icons/technology_icon/Competitive_Advantage.svg`,
    Expert_Developers: `${ICON_BASE_URL}/assets/icons/technology_icon/Expert_Developers.svg`,
    Flexible_Systems: `${ICON_BASE_URL}/assets/icons/technology_icon/Flexible_Systems.svg`,
    High_Quality_Development: `${ICON_BASE_URL}/assets/icons/technology_icon/High_Quality_Development.svg`,
    Seamless_Integration: `${ICON_BASE_URL}/assets/icons/technology_icon/Seamless_Integration.svg`,
    Security_Reliability_Focus: `${ICON_BASE_URL}/assets/icons/technology_icon/Security_Reliability_Focus.svg`,
    Tailored_Solutions: `${ICON_BASE_URL}/assets/icons/technology_icon/Tailored_Solutions.svg`,
  },

  clutch: `${ICON_BASE_URL}/assets/icons/clutch.webp`,
  food: `${ICON_BASE_URL}/assets/icons/food-and-resturant.svg`,
  healthcare: `${ICON_BASE_URL}/assets/icons/health-care.svg`,
  transportation: `${ICON_BASE_URL}/assets/icons/transportation.svg`,
  dot: `${ICON_BASE_URL}/assets/icons/dot.webp`,
  timer1: `${ICON_BASE_URL}/assets/icons/timer1.svg`,
  stopwatch1: `${ICON_BASE_URL}/assets/icons/stopwatch1.svg`,
  runtime1: `${ICON_BASE_URL}/assets/icons/runtime1.svg`,
  fixedprice1: `${ICON_BASE_URL}/assets/icons/fixedprice1.svg`,
  clock1: `${ICON_BASE_URL}/assets/icons/clock1.svg`,
  framework: `${ICON_BASE_URL}/assets/icons/framework.svg`,
  database: `${ICON_BASE_URL}/assets/icons/database.svg`,
  aiButton: `${ICON_BASE_URL}/assets/icons/Ai_Button.svg`,
  arrowLeft: `${ICON_BASE_URL}/assets/icons/arrow-left.svg`,
  arrowUp: `${ICON_BASE_URL}/assets/icons/arrow-up.svg`,
  chevron: `${ICON_BASE_URL}/assets/icons/chevron.svg`,
  chevronBlue: `${ICON_BASE_URL}/assets/icons/chevron-blue.svg`,
  chevronDown: `${ICON_BASE_URL}/assets/icons/chevron-down.svg`,
  chevronDownDark: `${ICON_BASE_URL}/assets/icons/chevron-down-dark.svg`,
  chevronWhiteLeft: `${ICON_BASE_URL}/assets/icons/chevron-white-left.svg`,
  dropdownIcon: `${ICON_BASE_URL}/assets/icons/dropdown-icon.svg`,
  menu: `${ICON_BASE_URL}/assets/icons/menu.svg`,
  quote: `${ICON_BASE_URL}/assets/icons/quote.svg`,
  industryArrow: `${ICON_BASE_URL}/assets/icons/industry-arrow.svg`,
  slideLeft: `${ICON_BASE_URL}/assets/icons/slide-left.svg`,
  slideRight: `${ICON_BASE_URL}/assets/icons/slide-right.svg`,
  slideLeftWhite: `${ICON_BASE_URL}/assets/icons/slide-left-white.svg`,
  slideRightWhite: `${ICON_BASE_URL}/assets/icons/slide-right-white.svg`,
  cursorDrag: `${ICON_BASE_URL}/assets/icons/cursor-drag.webp`,
  mailIcon: `${ICON_BASE_URL}/assets/icons/mail.svg`,
  skypeIcon: `${ICON_BASE_URL}/assets/icons/skype-icon.svg`,
  teams: `${ICON_BASE_URL}/assets/icons/teams.svg`,
  navMenuArrow: `${ICON_BASE_URL}/assets/icons/nav-menu-arrow.svg`,
  hire_developer: `${ICON_BASE_URL}/assets/icons/hire-developer.svg`,
  fixed: `${ICON_BASE_URL}/assets/icons/fixed.svg`,
  time: `${ICON_BASE_URL}/assets/icons/time.svg`,
  predictive_modeling: `${ICON_BASE_URL}/assets/icons/predictive-modeling.svg`,
  ai_solution: `${ICON_BASE_URL}/assets/icons/ai-solution.svg`,
  ai_as_a_service: `${ICON_BASE_URL}/assets/icons/ai-as-a-service.svg`,
  aiops: `${ICON_BASE_URL}/assets/icons/aiops.svg`,
  engines: `${ICON_BASE_URL}/assets/icons/engines.svg`,
  automation: `${ICON_BASE_URL}/assets/icons/automation.svg`,
  smart_ai: `${ICON_BASE_URL}/assets/icons/smart-ai.svg`,
  generative: `${ICON_BASE_URL}/assets/icons/generative.svg`,
  security: `${ICON_BASE_URL}/assets/icons/security.svg`,
  facebook: `${ICON_BASE_URL}/assets/icons/facebook.svg`,
  linkedin: `${ICON_BASE_URL}/assets/icons/linkedin.svg`,
  dribbble: `${ICON_BASE_URL}/assets/icons/dribbble.svg`,
  behance: `${ICON_BASE_URL}/assets/icons/behance.svg`,
  instagram: `${ICON_BASE_URL}/assets/icons/instagram.svg`,
  x: `${ICON_BASE_URL}/assets/icons/x.svg`,
  checkboxBlank: `${ICON_BASE_URL}/assets/icons/checkbox-blank.svg`,
  checkboxFill: `${ICON_BASE_URL}/assets/icons/checkbox-fill.svg`,
  serviceDark: `${ICON_BASE_URL}/assets/icons/service-dark.svg`,
  serviceLight: `${ICON_BASE_URL}/assets/icons/service-light.svg`,
  contactMail: `${ICON_BASE_URL}/assets/icons/contact-mail.svg`,
  navArrowMenuDark: `${ICON_BASE_URL}/assets/icons/nav-arrow-menu-dark.svg`,
  in: `${ICON_BASE_URL}/assets/icons/in.svg`,
  chevronselect: `${ICON_BASE_URL}/assets/icons/chevron-select.svg`,
  uploadPlus: `${ICON_BASE_URL}/assets/icons/upload_plus.svg`,
  recommender_system: `${ICON_BASE_URL}/assets/icons/recommender-system.svg`,
  natural_language: `${ICON_BASE_URL}/assets/icons/AI_services/Natural_Language_Processing.svg`,
  active_learning: `${ICON_BASE_URL}/assets/icons/active-learning.svg`,
  chat_gpt_integration: `${ICON_BASE_URL}/assets/icons/chat-gpt-integration.svg`,
  report_generation: `${ICON_BASE_URL}/assets/icons/report-generation.svg`,
  lenguge: `${ICON_BASE_URL}/assets/icons/lenguge.svg`,
  data_engineering: `${ICON_BASE_URL}/assets/icons/database_2.svg`,
  bi_visualization: `${ICON_BASE_URL}/assets/icons/bi_visualization.svg`,
  frameworks: `${ICON_BASE_URL}/assets/icons/frameworks.svg`,
  AWS: `${ICON_BASE_URL}/assets/icons/technology_icon/aws.svg`,
  Android: `${ICON_BASE_URL}/assets/icons/technology_icon/Android.svg`,
  AngularJS: `${ICON_BASE_URL}/assets/icons/technology_icon/AngularJS.svg`,
  Apache: `${ICON_BASE_URL}/assets/icons/technology_icon/Apache.svg`,
  Azure: `${ICON_BASE_URL}/assets/icons/technology_icon/Azure.svg`,
  Docker: `${ICON_BASE_URL}/assets/icons/technology_icon/Docker.svg`,
  DotNet: `${ICON_BASE_URL}/assets/icons/technology_icon/dot-net.svg`,
  ExpressJS: `${ICON_BASE_URL}/assets/icons/technology_icon/ExpressJS.svg`,
  Flutter: `${ICON_BASE_URL}/assets/icons/technology_icon/Flutter.svg`,
  GoogleCloud: `${ICON_BASE_URL}/assets/icons/technology_icon/google_cloud.svg`,
  IOS: `${ICON_BASE_URL}/assets/icons/technology_icon/IOS.svg`,
  Javascript: `${ICON_BASE_URL}/assets/icons/technology_icon/Javascript.svg`,
  Jira: `${ICON_BASE_URL}/assets/icons/technology_icon/Jirra.svg`,
  Katalon: `${ICON_BASE_URL}/assets/icons/technology_icon/Katalon.svg`,
  Kubernetes: `${ICON_BASE_URL}/assets/icons/technology_icon/Kubernetes.svg`,
  MongoDB: `${ICON_BASE_URL}/assets/icons/technology_icon/MongoDB.svg`,
  MySql: `${ICON_BASE_URL}/assets/icons/technology_icon/MySql.svg`,
  NodeJS: `${ICON_BASE_URL}/assets/icons/technology_icon/Node_JS.svg`,
  Oracle: `${ICON_BASE_URL}/assets/icons/technology_icon/Oracel.svg`,
  PHP: `${ICON_BASE_URL}/assets/icons/technology_icon/PHP.svg`,
  Postman: `${ICON_BASE_URL}/assets/icons/technology_icon/Postman.svg`,
  PostgreSql: `${ICON_BASE_URL}/assets/icons/technology_icon/PostSql.svg`,
  Python: `${ICON_BASE_URL}/assets/icons/technology_icon/Python.svg`,
  ReactJS: `${ICON_BASE_URL}/assets/icons/technology_icon/React_JS.svg`,
  ReactNative: `${ICON_BASE_URL}/assets/icons/technology_icon/React_Native.svg`,
  Ruby: `${ICON_BASE_URL}/assets/icons/technology_icon/Ruby.svg`,
  Selenium: `${ICON_BASE_URL}/assets/icons/technology_icon/Selenium.svg`,
  VueJS: `${ICON_BASE_URL}/assets/icons/technology_icon/Vue_JS.svg`,
  Xamarin: `${ICON_BASE_URL}/assets/icons/technology_icon/Xamarin.svg`,
  visualStudio: `${ICON_BASE_URL}/assets/icons/visual-studioe.svg`,
  androidStudio: `${ICON_BASE_URL}/assets/icons/Android_Studio.svg`,
  xCode: `${ICON_BASE_URL}/assets/icons/xCode.svg`,
  figma: `${ICON_BASE_URL}/assets/icons/figma.svg`,
  adobeXD: `${ICON_BASE_URL}/assets/icons/xd.svg`,
  sketchIcon: `${ICON_BASE_URL}/assets/icons/sketch.svg`,
  SQLite: `${ICON_BASE_URL}/assets/icons/technology_icon/SQLite.svg`,
  Extended_Development_Team: `${ICON_BASE_URL}/assets/icons/Extended_Development_Team.svg`,
  Dedicated_Development_Team: `${ICON_BASE_URL}/assets/icons/Dedicated_Development_Team.svg`,
  Onsite_Dedicated_Team: `${ICON_BASE_URL}/assets/icons/Onsite_Dedicated_Team.svg`,

  taxiIcons: {
    taxiBroaderClientele: `${ICON_BASE_URL}/assets/icons/taxi_app/broader-clientele.svg`,
    taxiCrossPlatformDevelopment: `${ICON_BASE_URL}/assets/icons/taxi_app/cross-platform-development.svg`,
    taxiCrossPlatformIntegration: `${ICON_BASE_URL}/assets/icons/taxi_app/cross-platform-integration.svg`,
    taxiCustomBuiltSolutions: `${ICON_BASE_URL}/assets/icons/taxi_app/custom-built-solutions.svg`,
    taxiDataDrivenInsightsDecisions: `${ICON_BASE_URL}/assets/icons/taxi_app/data-driven-insights-and-decisions.svg`,
    taxiExpertOnDemandAppDevelopment: `${ICON_BASE_URL}/assets/icons/taxi_app/expert-on-demand-app-development.svg`,
    taxiImprovedCustomerExperience: `${ICON_BASE_URL}/assets/icons/taxi_app/improved-customer-experience.svg`,
    taxiIncreasedSafetyAccountability: `${ICON_BASE_URL}/assets/icons/taxi_app/increased-safety-and-accountability.svg`,
    taxiIntegratedEfficiencyTools: `${ICON_BASE_URL}/assets/icons/taxi_app/integrated-efficiency-tools.svg`,
    taxiMarketingOpportunities: `${ICON_BASE_URL}/assets/icons/taxi_app/marketing-opportunities.svg`,
    taxiOptimumResourceUtilization: `${ICON_BASE_URL}/assets/icons/taxi_app/optimum-resource-utilization.svg`,
    taxiRapidlyDeployedCustomizableSoftware: `${ICON_BASE_URL}/assets/icons/taxi_app/rapidly-deployed-customizable-software.svg`,
    taxiTrustedByDiverseClients: `${ICON_BASE_URL}/assets/icons/taxi_app/trusted-by-diverse-clients.svg`,
  },

  aboutUS: {
    AI_Driven_Agility: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/aboutus/AI_Driven_Agility.svg`,
    Adaptive_Partnership: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/aboutus/Adaptive_Partnership.svg`,
    Continuous_Growth: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/aboutus/Continuous_Growth.svg`,
    Involved_Leadership: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/aboutus/Involved_Leadership.svg`,
    Openness: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/aboutus/Openness.svg`,
    Taking_Responsibility: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/aboutus/Taking_Responsibility.svg`,
  },

  foodDelivery: {
    customerSupport24x7: `${ICON_BASE_URL}/assets/icons/food_delivery/24x7-customer-support.svg`,
    amplifiedVisibility: `${ICON_BASE_URL}/assets/icons/food_delivery/amplified-visibility.svg`,
    cloudKitchenAppDevelopment: `${ICON_BASE_URL}/assets/icons/food_delivery/cloud-kitchen-app-development.svg`,
    customApiIntegrations: `${ICON_BASE_URL}/assets/icons/food_delivery/custom-api-integrations.svg`,
    dataDrivenInsights: `${ICON_BASE_URL}/assets/icons/food_delivery/data-driven-insights.svg`,
    foodOrderingSolutions: `${ICON_BASE_URL}/assets/icons/food_delivery/food-ordering-solutions.svg`,
    increasedEfficiency: `${ICON_BASE_URL}/assets/icons/food_delivery/increased-efficiency.svg`,
    inventoryManagementSolutions: `${ICON_BASE_URL}/assets/icons/food_delivery/inventory-management-solutions.svg`,
    latestTechStack: `${ICON_BASE_URL}/assets/icons/food_delivery/latest-tech-stack.svg`,
    onTimeDelivery_food: `${ICON_BASE_URL}/assets/icons/food_delivery/on-time-delivery.svg`,
    optimizedEngagement: `${ICON_BASE_URL}/assets/icons/food_delivery/optimized-engagement.svg`,
    orderManagementSolutions: `${ICON_BASE_URL}/assets/icons/food_delivery/order-management-solutions.svg`,
    realTimeTracking: `${ICON_BASE_URL}/assets/icons/food_delivery/real-time-tracking.svg`,
    restaurantMobileApp: `${ICON_BASE_URL}/assets/icons/food_delivery/restaurant-mobile-app.svg`,
    restaurantSearchPortals: `${ICON_BASE_URL}/assets/icons/food_delivery/restaurant-search-portals.svg`,
    savesTime: `${ICON_BASE_URL}/assets/icons/food_delivery/saves-time.svg`,
    supportAndMaintenance: `${ICON_BASE_URL}/assets/icons/food_delivery/support-and-maintenance.svg`,
    transparentCommunication: `${ICON_BASE_URL}/assets/icons/food_delivery/transparent-communication.svg`,
    advanceTechnology: advanceTechnology,
    talentedTeamofExperts: talentedTeamofExperts,
    uiUX: uiUX,
    agilemethology: agilemethology,
    multiplatformCompatiablity: multiplatformCompatiablity,
    budgetFriendly: budgetFriendly,
  },

  ecommerceicons: {
    agileMethodology: `${ICON_BASE_URL}/assets/icons/ecommerce_icons/agile-methodology.svg`,
    customEcommerceAppDevelopment: `${ICON_BASE_URL}/assets/icons/ecommerce_icons/custom-ecommerce-app-development.svg`,
    ecommerceAppConsulting: `${ICON_BASE_URL}/assets/icons/ecommerce_icons/ecommerce-app-consulting.svg`,
    ecommerceAppMaintenanceSupport: `${ICON_BASE_URL}/assets/icons/ecommerce_icons/ecommerce-app-maintenance-support.svg`,
    ecommerceAppModernization: `${ICON_BASE_URL}/assets/icons/ecommerce_icons/ecommerce-app-modernization.svg`,
    ecommerceUiUxDesign: `${ICON_BASE_URL}/assets/icons/ecommerce_icons/ecommerce-ui-ux-design.svg`,
    ecommerceWebDevelopmentServices: `${ICON_BASE_URL}/assets/icons/ecommerce_icons/ecommerce-web-development-services.svg`,
    fullCycleExpertise: `${ICON_BASE_URL}/assets/icons/ecommerce_icons/full-cycle-expertise.svg`,
    provenExperience: `${ICON_BASE_URL}/assets/icons/ecommerce_icons/proven-experience.svg`,
  },

  eventIcons: {
    custom_mobile_app_development_event: `${ICON_BASE_URL}/assets/icons/event_icons/custom-mobile-app-development.svg`,
    event_app_consultation: `${ICON_BASE_URL}/assets/icons/event_icons/event-app-consultation.svg`,
    event_app_ux_design: `${ICON_BASE_URL}/assets/icons/event_icons/event-app-ux-design.svg`,
    white_label_event_app: `${ICON_BASE_URL}/assets/icons/event_icons/white-label-event-app.svg`,

    attendee_engagement_interaction: `${ICON_BASE_URL}/assets/icons/event_icons/attendee-engagement-interaction.svg`,
    budget_friendly_services: `${ICON_BASE_URL}/assets/icons/event_icons/budget-friendly-services.svg`,
    customized_solutions: `${ICON_BASE_URL}/assets/icons/event_icons/customized-solutions.svg`,
    security_scalability: `${ICON_BASE_URL}/assets/icons/event_icons/security-scalability.svg`,
  },

  entertainment_media: {
    completeTransparency: `${ICON_BASE_URL}/assets/icons/media_entertainment_icons/complete-transparency.svg`,
    entertainmentAppModernization: `${ICON_BASE_URL}/assets/icons/media_entertainment_icons/entertainment-app-modernization.svg`,
    flexibleEngagementModels: `${ICON_BASE_URL}/assets/icons/media_entertainment_icons/flexible-engagement-models.svg`,
    highlySecure: `${ICON_BASE_URL}/assets/icons/media_entertainment_icons/highly-secure.svg`,
    industryExpertise: `${ICON_BASE_URL}/assets/icons/media_entertainment_icons/industry-expertise.svg`,
    mediaAndEntertainmentWebDevelopment: `${ICON_BASE_URL}/assets/icons/media_entertainment_icons/media-and-entertainment-web-development.svg`,
    mediaEntertainmentAppConsulting: `${ICON_BASE_URL}/assets/icons/media_entertainment_icons/media-entertainment-app-consulting.svg`,
    mediaEntertainmentAppDesign: `${ICON_BASE_URL}/assets/icons/media_entertainment_icons/media-entertainment-app-design.svg`,
    mediaEntertainmentAppDevelopment: `${ICON_BASE_URL}/assets/icons/media_entertainment_icons/media-entertainment-app-development.svg`,
    mediaEntertainmentAppTesting: `${ICON_BASE_URL}/assets/icons/media_entertainment_icons/media-entertainment-app-testing.svg`,
    onTimeDelivery: `${ICON_BASE_URL}/assets/icons/media_entertainment_icons/on-time-delivery.svg`,
    scalableSolutions: `${ICON_BASE_URL}/assets/icons/media_entertainment_icons/scalable-solutions.svg`,
  },

  game_development_icons: {
    buildTheHype: `${ICON_BASE_URL}/assets/icons/game_development_images/buildthe-hype.svg`,
    guaranteedOriginality: `${ICON_BASE_URL}/assets/icons/game_development_images/guaranteed-originality.svg`,
    multiLingualSupport: `${ICON_BASE_URL}/assets/icons/game_development_images/multi-lingual-support.svg`,
    platformAnarchyCompatibility: `${ICON_BASE_URL}/assets/icons/game_development_images/platform-anarchy-compatibility.svg`,
    unobtaniumGradeSecurity: `${ICON_BASE_URL}/assets/icons/game_development_images/unobtanium-grade-security.svg`,
    userCentricDesign: `${ICON_BASE_URL}/assets/icons/game_development_images/user-centric-design.svg`,
    youAskWeDeliverCustomization: `${ICON_BASE_URL}/assets/icons/game_development_images/you-ask-we-deliver-customization.svg`,
  },

  projectCommunicationStrategy: {
    Project_Initiation: `${ICON_BASE_URL}/assets/icons/project_communication/Project_Initiation.svg`,
    Structured_Kick_off_Meeting: `${ICON_BASE_URL}/assets/icons/project_communication/Structured_Kick-off_Meeting.svg`,
    Dedicated_Accountable_Lead: `${ICON_BASE_URL}/assets/icons/project_communication/Dedicated_Accountable_Lead.svg`,
    Clear_Communication_Channels: `${ICON_BASE_URL}/assets/icons/project_communication/Clear_Communication_Channels.svg`,
    Centralized_Project_Management: `${ICON_BASE_URL}/assets/icons/project_communication/Centralized_Project_Management.svg`,
    Comprehensive_Project_Documentation: `${ICON_BASE_URL}/assets/icons/project_communication/Comprehensive_Project_Documentation.svg`,
    Requirements_Clarification_and_Validation: `${ICON_BASE_URL}/assets/icons/project_communication/Requirements_Clarification_and_Validation.svg`,
    Transparen_Progress_Updates: `${ICON_BASE_URL}/assets/icons/project_communication/Transparent Progress Updates.svg`,
    Consistent_Meeting_Agendas: `${ICON_BASE_URL}/assets/icons/project_communication/Consistent_Meeting_Agendas.svg`,
    Proactive_Issue: `${ICON_BASE_URL}/assets/icons/project_communication/Proactive_Issue-Identification.svg`,
    Risk_and_Change_Management: `${ICON_BASE_URL}/assets/icons/project_communication/Risk_and_Change_Management.svg`,
    Knowledge_Sharing_and_Engagement: `${ICON_BASE_URL}/assets/icons/project_communication/Knowledge_Sharing_and_Engagement.svg`,
    Continuous_Improvement_and_Feedback: `${ICON_BASE_URL}/assets/icons/project_communication/Continuous_Improvement_and_Feedback.svg`,
  },

  eLearning: {
    custom_elearning_app_development: `${ICON_BASE_URL}/assets/icons/eLearning/custom-elearning-app-development.svg`,
    education_software_consultation: `${ICON_BASE_URL}/assets/icons/eLearning/education-software-consultation.svg`,
    elearning_api_integration: `${ICON_BASE_URL}/assets/icons/eLearning/elearning-api-integration.svg`,
    elearning_app_modernization: `${ICON_BASE_URL}/assets/icons/eLearning/elearning-app-modernization.svg`,
    on_demand_elearning_apps: `${ICON_BASE_URL}/assets/icons/eLearning/on-demand-elearning-apps.svg`,
    smart_chatbot_development: `${ICON_BASE_URL}/assets/icons/eLearning/smart-chatbot-development.svg`,
    support_and_maintenance_eLearning: `${ICON_BASE_URL}/assets/icons/eLearning/support-and-maintenance.svg`,
    ux_design_eLearning: `${ICON_BASE_URL}/assets/icons/eLearning/ux-design.svg`,
  },

  resturant_icons: {
    api_integration: `${ICON_BASE_URL}/assets/icons/resturant_page/api-integration.svg`,
    custom_mobile_app_development: `${ICON_BASE_URL}/assets/icons/resturant_page/custom-mobile-app-development.svg`,
    quality_assurance: `${ICON_BASE_URL}/assets/icons/resturant_page/quality-assurance.svg`,
    restaurant_app_consultation: `${ICON_BASE_URL}/assets/icons/resturant_page/restaurant-app-consultation.svg`,
    ux_design_support: `${ICON_BASE_URL}/assets/icons/resturant_page/ux-design-support.svg`,
    web_app_development: `${ICON_BASE_URL}/assets/icons/resturant_page/web-app-development.svg`,
    white_label_restaurant_app_restruant: `${ICON_BASE_URL}/assets/icons/resturant_page/white-label-restaurant-app.svg`,
    deployment_resturant: `${ICON_BASE_URL}/assets/icons/resturant_page/deployment.svg`,
    support_and_maintenance_restuarnt: `${ICON_BASE_URL}/assets/icons/resturant_page/support-and-maintenance.svg`,
  },
  transportationIcons: {
    runs_everywhere: `${ICON_BASE_URL}/assets/icons/transportation/runs-everywhere.svg`,
    your_rules_our_app: `${ICON_BASE_URL}/assets/icons/transportation/your-rules-our-app.svg`,
    we_speak_trucker: `${ICON_BASE_URL}/assets/icons/transportation/we-speak-trucker.svg`,
    on_schedule_project_delivery: `${ICON_BASE_URL}/assets/icons/transportation/on-schedule-project-delivery.svg`,
    fort_knox_security: `${ICON_BASE_URL}/assets/icons/transportation/fort-knox-security.svg`,
    fleet_management_solutions: `${ICON_BASE_URL}/assets/icons/transportation/fleet-management-solutions.svg`,
    features_from_the_future: `${ICON_BASE_URL}/assets/icons/transportation/features-from-the-future.svg`,
    driver_workflow_management_apps: `${ICON_BASE_URL}/assets/icons/transportation/driver-workflow-management-apps.svg`,
    custom_route_optimization_booking_apps: `${ICON_BASE_URL}/assets/icons/transportation/custom-route-optimization-booking-apps.svg`,
    cargo_logistics_management_solutions: `${ICON_BASE_URL}/assets/icons/transportation/cargo-logistics-management-solutions.svg`,
  },

  careerIcon: {
    Career_Growth: `${ICON_BASE_URL}/assets/icons/career_icons/Career_Growth.svg`,
    Continuous_Learning: `${ICON_BASE_URL}/assets/icons/career_icons/Continuous_Learning.svg`,
    Employee_Health_Benefits: `${ICON_BASE_URL}/assets/icons/career_icons/Employee_Health_Benefits.svg`,
    Impactful_Projects: `${ICON_BASE_URL}/assets/icons/career_icons/Impactful_Projects.svg`,
    Team_Building_Activities: `${ICON_BASE_URL}/assets/icons/career_icons/Team_Building_Activities.svg`,
    Wellness_Programs: `${ICON_BASE_URL}/assets/icons/career_icons/Wellness_Programs.svg`,
  },

  becomePatner: {
    Associate_Partnership: `${ICON_BASE_URL}/assets/icons/become_partner/Associate_Partnership.svg`,
    Referral_Partnership: `${ICON_BASE_URL}/assets/icons/become_partner/Referral_Partnership.svg`,
    Strategic_Partnership: `${ICON_BASE_URL}/assets/icons/become_partner/Strategic_Partnership.svg`,
    Competitive_Pricing: `${ICON_BASE_URL}/assets/icons/become_partner/Competitive_Pricing.svg`,
    Dedicated_Account_Manager: `${ICON_BASE_URL}/assets/icons/become_partner/Dedicated_Account_Manager.svg`,
    Future_Ready_Solutions: `${ICON_BASE_URL}/assets/icons/become_partner/Future_Ready_Solutions.svg`,
    Industry_leading_Technologies: `${ICON_BASE_URL}/assets/icons/become_partner/Industry_leading_Technologies.svg`,
    Internationally_Recognized: `${ICON_BASE_URL}/assets/icons/become_partner/Internationally_Recognized.svg`,
    Loyal_Clientele: `${ICON_BASE_URL}/assets/icons/become_partner/Loyal_Clientele.svg`,
    Outer_Lines: `${ICON_BASE_URL}/assets/icons/become_partner/Outer_Lines.svg`,
    Strong_Foundation: `${ICON_BASE_URL}/assets/icons/become_partner/Strong_Foundation.svg`,
    Rich_Diverse_Portfolio: `${ICON_BASE_URL}/assets/icons/become_partner/Rich_Diverse_Portfolio.svg`,
  },
  // platform15: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/blockchain-development/platforms/tron.webp`,

  ourServicesIcons: {
    AI_Development_Implementation: `${ICON_BASE_URL}/assets/icons/our_services_icons/AI_Development_mplementation.svg`,

    Cloud_DevOps_Solutions: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_DevOps_Solutions.svg`,
    AI_Agent_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/AI Agent Development.svg`,
    Mobile_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Mobile_App_Development.svg`,
    Web_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Web_App_Development.svg`,
    Project_Strategy_Consultation: `${ICON_BASE_URL}/assets/icons/our_services_icons/Project_Strategy_Consultation.svg`,
    Custom_App_Design_and_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_App_Design_and_Development.svg`,
    Responsive_Web_Applications: `${ICON_BASE_URL}/assets/icons/our_services_icons/Responsive_Web_Applications.svg`,
    Cross_Platform_App_Migration: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cross-Platform_App_Migration.svg`,
    Hire_Cross_Platform_Development_Staff: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Cross_Platform_Development_Staff.svg`,
    Cross_Platform_MVP_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cross_Platform_MVP_App_Development.svg`,
    App_Modernization: `${ICON_BASE_URL}/assets/icons/our_services_icons/App_Modernization.svg`,
    Cross_Platform_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cross_Platform_App_Development.svg`,
    Enhanced_Brand_Visibility: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enhanced_Brand_Visibility.svg`,
    Single_Codebase: `${ICON_BASE_URL}/assets/icons/our_services_icons/Single_Codebase.svg`,
    Efficient_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Efficient_Development.svg`,
    Faster_Time_market: `${ICON_BASE_URL}/assets/icons/our_services_icons/Faster_Time_market.svg`,
    Easy_Maintenance: `${ICON_BASE_URL}/assets/icons/our_services_icons/Easy_Maintenance.svg`,
    Easy_Integration: `${ICON_BASE_URL}/assets/icons/our_services_icons/Easy_Integration.svg`,
    Reduced_Development_Cost: `${ICON_BASE_URL}/assets/icons/our_services_icons/Reduced_Development_Cost.svg`,
    Cloud_Integration: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Integration.svg`,
    Increased_ROI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Increased_ROI.svg`,
    Website_Redesign: `${ICON_BASE_URL}/assets/icons/our_services_icons/Website_Redesign.svg`,
    Landing_Pages: `${ICON_BASE_URL}/assets/icons/our_services_icons/Landing_Pages.svg`,
    eCommerce_Website_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/eCommerce_Website_Design.svg`,
    WordPress_Website_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/WordPress_Website_Design.svg`,
    Static_Website_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/Static_Website_Design.svg`,
    CMS_Web_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/CMS_Web_Design.svg`,
    Web_UIUX_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/Web_UIUX_Design.svg`,
    Web_Portal_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/Web_Portal_Design.svg`,
    Tailored_User_Experience: `${ICON_BASE_URL}/assets/icons/our_services_icons/Tailored_User_Experience.svg`,
    Availability: `${ICON_BASE_URL}/assets/icons/our_services_icons/Availability.svg`,
    Better_Security: `${ICON_BASE_URL}/assets/icons/our_services_icons/Better_Security.svg`,
    Snappy_Load_Times: `${ICON_BASE_URL}/assets/icons/our_services_icons/Snappy_Load_Times.svg`,
    Enhanced_Website_Protection: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enhanced_Website_Protection.svg`,
    Improved_Ranking: `${ICON_BASE_URL}/assets/icons/our_services_icons/Improved_Ranking.svg`,
    eCommerce_UIUX_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/eCommerce_UIUX_Design.svg`,
    B2B_eCommerce_Website_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/B2B_eCommerce_Website_Development.svg`,
    Headless_Commerce_Solutions: `${ICON_BASE_URL}/assets/icons/our_services_icons/Headless_Commerce_Solutions .svg`,
    Shopify_eCommerce_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Shopify_eCommerce_Development.svg`,
    eCommerce_Platform_Migration: `${ICON_BASE_URL}/assets/icons/our_services_icons/eCommerce_Platform_Migration.svg`,
    eCommerce_Marketplace_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/eCommerce_Marketplace_Development.svg`,
    API_Integration_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/API_Integration_Services.svg`,
    Web3_eCommerce_Website_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Web3_eCommerce_Website_Development.svg`,
    eCommerce_Portal_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/eCommerce_Portal_Development.svg`,
    Custom_Plugin_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_Plugin_Development.svg`,
    Product_Recommendations: `${ICON_BASE_URL}/assets/icons/our_services_icons/Product_Recommendations.svg`,
    Digital_Assets_Creation: `${ICON_BASE_URL}/assets/icons/our_services_icons/Digital_Assets_Creation.svg`,
    Customer_Service_Chatbots: `${ICON_BASE_URL}/assets/icons/our_services_icons/Customer_Service_Chatbots.svg`,
    Agentic_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Agentic_AI.svg`,
    Smart_Search: `${ICON_BASE_URL}/assets/icons/our_services_icons/Smart_Search.svg`,
    Accelerated_Business_Growth: `${ICON_BASE_URL}/assets/icons/our_services_icons/Accelerated_Business_Growth.svg`,
    API_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/API_Testing.svg`,
    Assessment_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/Assessment_Consulting.svg`,
    Automated_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Automated_Testing.svg`,
    Cloud_Based_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Based_Testing.svg`,
    Cost_Effectiveness: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cost_Effectiveness.svg`,
    Database_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Database_Testing.svg`,
    Enhanced_Application_Security: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enhanced_Application_Security.svg`,
    Improved_Production_Efficiency: `${ICON_BASE_URL}/assets/icons/our_services_icons/Improved_Production_Efficiency.svg`,
    Manual_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Manual_Testing.svg`,
    Performance_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Performance_Testing.svg`,
    Protection_Sensitive_Data: `${ICON_BASE_URL}/assets/icons/our_services_icons/Protection_Sensitive_Data.svg`,
    Seamless_Scalability: `${ICON_BASE_URL}/assets/icons/our_services_icons/Seamless_Scalability.svg`,
    Security_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Security_Testing.svg`,
    Simplification: `${ICON_BASE_URL}/assets/icons/our_services_icons/Simplification.svg`,
    Usability_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Usability_Testing.svg`,
    Responsive_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Responsive_Testing.svg`,
    Penetration_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Penetration_Testing.svg`,

    NFT_Exchange_Platform_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Exchange_Platform_Development.svg`,
    NFT_Fashion_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Fashion_Development.svg`,
    NFT_Game_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Game_Development.svg`,
    NFT_Integration_Exchange_Platform: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Integration_Exchange_Platform.svg`,
    NFT_Lending_Platform_Develop: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Lending_Platform_Develop.svg`,
    NFT_Smart_Contract_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Smart_Contract_Development.svg`,
    NFT_Wallet_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Wallet_Development.svg`,
    Metaverse_NFT_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Metaverse_NFT_Development.svg`,
    NFT_Music_Marketplace_Development: NFT_Music_Marketplace_Development,
    NFT_Marketplace_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Marketplace_Development.svg`,

    Market_Sales_Royalties: `${ICON_BASE_URL}/assets/icons/our_services_icons/Market_Sales_Royalties.svg`,
    Faster_Market_Entry: `${ICON_BASE_URL}/assets/icons/our_services_icons/Faster_Market_Entry.svg`,
    Profit_Potential: `${ICON_BASE_URL}/assets/icons/our_services_icons/Profit_Potential.svg`,
    Niche_Market_Opportunities: `${ICON_BASE_URL}/assets/icons/our_services_icons/Niche_Market_Opportunities.svg`,
    Verifiable_Authenticity: `${ICON_BASE_URL}/assets/icons/our_services_icons/Verifiable_Authenticity.svg`,
    Access_Growing_Market: `${ICON_BASE_URL}/assets/icons/our_services_icons/Access-Growing_Market.svg`,

    Blockchain_Game_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Blockchain_Game-Development_Services.svg`,
    Blockchain_Development_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/Blockchain_Development_Consulting.svg`,
    Blockchain_Integration_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Blockchain_Integration_Services.svg`,
    Custom_Blockchain_AppDevelopment: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_Blockchain_Ap-Development.svg`,
    Decentralization: `${ICON_BASE_URL}/assets/icons/our_services_icons/Decentralization.svg`,
    DefiDevelopment: `${ICON_BASE_URL}/assets/icons/our_services_icons/Defi_Development.svg`,
    Efficiency_And_CostSaving: `${ICON_BASE_URL}/assets/icons/our_services_icons/Efficiency_and_Cost_Saving.svg`,
    Enterprise_Blockchain_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enterprise_Blockchain_Development.svg`,
    Hyperledger_Blockchain_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hyperledger_Blockchain_Development_Services.svg`,
    ICODevelopment: `${ICON_BASE_URL}/assets/icons/our_services_icons/ICO_Development.svg`,
    Privacy: `${ICON_BASE_URL}/assets/icons/our_services_icons/Privacy.svg`,
    Smart_Contract_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Smart_Contract_Development.svg`,
    NFT_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/NFT_Development.svg`,
    Crypto_Wallet_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Crypto_Wallet_Development.svg`,
    Dapps_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Dapps_Development.svg`,
    STO_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/STO_Development.svg`,
    Ton_Blockchain_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/TON-Blockchain_Development.svg`,
    Traceability: `${ICON_BASE_URL}/assets/icons/our_services_icons/Traceability.svg`,
    Transparency: `${ICON_BASE_URL}/assets/icons/our_services_icons/Transparency.svg`,
    Web3_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Web3_Development_Services.svg`,

    Hire_PHP_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_PHP_Developers.svg`,
    Hire_Cross_Platform_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Cross_Platform_Developers.svg`,
    Hire_Java_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Java_Developers.svg`,
    Hire_Android_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Android_Developers.svg`,
    Hire_WordPress_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_WordPress_Developers.svg`,
    Hire_Kotlin_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Kotlin_Developers.svg`,
    Hire_Front_End_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Front_End_Developers.svg`,
    Hire_dot_Net_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_dot_Net_Developers.svg`,
    Hire_Web_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Web_Developers.svg`,
    Hire_Full_Stack_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Full_Stack_Developers.svg`,
    Hire_Offshore_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Offshore_Developers.svg`,
    Hire_MEAN_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_MEAN_Developers.svg`,
    Hire_iOS_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_iOS_Developers.svg`,
    Hire_AI_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_AI_Developers.svg`,
    Hire_Mobile_App_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Mobile_App_Developers.svg`,
    Hire_Dedicated_Shopify_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Dedicated_Shopify_Developers.svg`,
    Hire_Django_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Django_Developers.svg`,
    Hire_React_Native_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_React_Native_Developers.svg`,
    Hire_Flutter_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Flutter_Developers.svg`,
    Hire_React_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_React_Developers.svg`,
    Hire_MERN_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_MERN_Developers.svg`,
    Hire_Python_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Python_Developers.svg`,
    Hire_NodeJS_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_NodeJS_Developers.svg`,
    Hire_Golang_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_Golang_Developers.svg`,
    Hire_eCommerce_Developers: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hire_eCommerce_Developers.svg`,

    Android_Wear_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Android_Wear_App_Development.svg`,
    Apple_Watch_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Apple_Watch_App_Development.svg`,
    AR_VR_Wearable_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/AR_VR_Wearable_App_Development.svg`,
    Enterprise_Wearable_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enterprise_Wearable_App_Development.svg`,
    Google_Glass_Apps: `${ICON_BASE_URL}/assets/icons/our_services_icons/Google_Glass_Apps.svg`,
    IoT_Wearable_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Wearable_App_Development.svg`,
    Smart_Band_Apps: `${ICON_BASE_URL}/assets/icons/our_services_icons/Smart_Band_Apps.svg`,
    Wearable_App_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/Wearable_App_Design.svg`,
    Wearable_Payment_Apps: `${ICON_BASE_URL}/assets/icons/our_services_icons/Wearable_Payment_Apps.svg`,
    Fitness_Tracking_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Fitness_Tracking_App_Development.svg`,
    Wearable_App_Consultation: `${ICON_BASE_URL}/assets/icons/our_services_icons/Wearable_App_Consultation.svg`,
    Gamification: `${ICON_BASE_URL}/assets/icons/our_services_icons/Gamification.svg`,
    Hands_Free_Operability: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hands_Free_Operability.svg`,
    Personalized_Recommendations: `${ICON_BASE_URL}/assets/icons/our_services_icons/Personalized_Recommendations.svg`,
    Real_Time_Accessibility: `${ICON_BASE_URL}/assets/icons/our_services_icons/Real_Time_Accessibility.svg`,
    Robust_Security: `${ICON_BASE_URL}/assets/icons/our_services_icons/Robust_Security.svg`,
    Remote_Tracking: `${ICON_BASE_URL}/assets/icons/our_services_icons/Remote_Tracking.svg`,

    Custom_PWA_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_PWA_Development.svg`,
    Progressive_App_Shell_Architecture: `${ICON_BASE_URL}/assets/icons/our_services_icons/Progressive_App_Shell_Architecture.svg`,
    Quality_Assurance_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/Quality_Assurance_Testing.svg`,
    PWA_Maintenance_and_Support: `${ICON_BASE_URL}/assets/icons/our_services_icons/PWA_Maintenance_and_Support.svg`,
    PWA_Performance_Optimization: `${ICON_BASE_URL}/assets/icons/our_services_icons/PWA_Performance_Optimization.svg`,
    PWA_Migration: `${ICON_BASE_URL}/assets/icons/our_services_icons/PWA_Migration.svg`,
    Progressive_Plugin_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Progressive_Plugin_Development.svg`,
    Progressive_Web_App_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/Progressive_Web_App_Design.svg`,

    Re_Engaging: `${ICON_BASE_URL}/assets/icons/our_services_icons/Re_Engaging.svg`,
    App_Like_Experience: `${ICON_BASE_URL}/assets/icons/our_services_icons/App_Like_Experience.svg`,
    Connectivity_Independent: `${ICON_BASE_URL}/assets/icons/our_services_icons/Connectivity_Independent.svg`,
    Responsive: `${ICON_BASE_URL}/assets/icons/our_services_icons/Responsive.svg`,
    User_Friendly: `${ICON_BASE_URL}/assets/icons/our_services_icons/User_Friendly.svg`,
    Wider_Reach_and_Accessibility: `${ICON_BASE_URL}/assets/icons/our_services_icons/Wider_Reach_and_Accessibility.svg`,

    Custom_IoT_Solutions_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_IoT_Solutions_Development.svg`,
    Digital_Twin_System_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Digital_Twin_System_Development.svg`,
    Hyperledger_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Hyperledger_Development_Services.svg`,
    IoT_App_Maintenance_and_Support_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_App_Maintenance_and_Support_Services.svg`,
    IoT_Consulting_and_Strategy: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Consulting_and_Strategy.svg`,
    IoT_Data_Analysis_isualization: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Data_Analysis_isualization.svg`,
    IoT_Firmware_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Firmware_Development.svg`,
    IoT_Implementation: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Implementation.svg`,
    IoT_Product_QA_and_Testing: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Product_QA_and_Testing.svg`,
    IoT_Security_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/IoT_Security_Services.svg`,

    Centralized_Processes: `${ICON_BASE_URL}/assets/icons/our_services_icons/Centralized_Processes.svg`,
    Connected_Ecosystems: `${ICON_BASE_URL}/assets/icons/our_services_icons/Connected_Ecosystems.svg`,
    Lower_Testing_Costs: `${ICON_BASE_URL}/assets/icons/our_services_icons/Lower_Testing_Costs.svg`,
    Simplified_Integration: `${ICON_BASE_URL}/assets/icons/our_services_icons/Simplified_Integration.svg`,
    Smart_User_Experience: `${ICON_BASE_URL}/assets/icons/our_services_icons/Smart_User_Experience.svg`,
    Unified_Operations: `${ICON_BASE_URL}/assets/icons/our_services_icons/Unified_Operations.svg`,

    Cloud_Application_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Application_Development.svg`,
    Cloud_Application_Integration: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Application_Integration.svg`,
    Cloud_Consulting_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Consulting_Services.svg`,
    Cloud_Data_Platform_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Data_Platform_Development.svg`,
    Cloud_Deployment: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Deployment.svg`,
    Cloud_Infrastructure_Management: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Infrastructure_Management.svg`,
    Cloud_Native_Application_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Native_Application_Development.svg`,
    DevOps_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/DevOps_Services.svg`,
    Legacy_Application_Modernization: `${ICON_BASE_URL}/assets/icons/our_services_icons/Legacy_Application_Modernization.svg`,
    Managed_SRE_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Managed_SRE_Services.svg`,
    SaaS_Application_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/SaaS_Application_Development.svg`,

    Data_Friendly_Framework: `${ICON_BASE_URL}/assets/icons/our_services_icons/Data_Friendly_Framework.svg`,
    Easy_Management: `${ICON_BASE_URL}/assets/icons/our_services_icons/Easy_Management.svg`,
    Operational_Savings: `${ICON_BASE_URL}/assets/icons/our_services_icons/Operational_Savings.svg`,
    Reliable_Solutions: `${ICON_BASE_URL}/assets/icons/our_services_icons/Reliable_Solutions.svg`,
    Scalable_Solutions: `${ICON_BASE_URL}/assets/icons/our_services_icons/Scalable_Solutions.svg`,
    Secure_Data_Storage: `${ICON_BASE_URL}/assets/icons/our_services_icons/Secure_Data_Storage.svg`,

    AI_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/AI_Consulting.svg`,
    Architecture_Assessment_and_Refactoring: `${ICON_BASE_URL}/assets/icons/our_services_icons/Architecture_Assessment_and_Refactoring.svg`,
    Business_Process_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/Business_Process_Consulting.svg`,
    Cloud_Migration_and_Optimization: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cloud_Migration_and_Optimization.svg`,
    Cybersecurity_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cybersecurity_Consulting.svg`,
    IT_and_Business_Transformation: `${ICON_BASE_URL}/assets/icons/our_services_icons/IT_and_Business_Transformation.svg`,
    IT_Budgeting: `${ICON_BASE_URL}/assets/icons/our_services_icons/IT_Budgeting.svg`,
    IT_Infrastructure_Management: `${ICON_BASE_URL}/assets/icons/our_services_icons/IT_Infrastructure_Management.svg`,
    IT_Risk_Assessment_and_Compliance: `${ICON_BASE_URL}/assets/icons/our_services_icons/IT_Risk_Assessment_and_Compliance.svg`,
    Technology_Advisory_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Technology_Advisory_Services.svg`,

    Expertise: `${ICON_BASE_URL}/assets/icons/our_services_icons/Expertise.svg`,
    Faster_Project_Completion: `${ICON_BASE_URL}/assets/icons/our_services_icons/Faster_Project_Completion.svg`,
    Improved_Processes: `${ICON_BASE_URL}/assets/icons/our_services_icons/Improved_Processes.svg`,
    Increased_Productivity: `${ICON_BASE_URL}/assets/icons/our_services_icons/Increased_Productivity.svg`,
    Potential_Cost_Savings: `${ICON_BASE_URL}/assets/icons/our_services_icons/Potential_Cost_Savings.svg`,
    Reduced_Security_Risk: `${ICON_BASE_URL}/assets/icons/our_services_icons/Reduced_Security_Risk.svg`,

    Infrastructure_and_DevOps_Support: `${ICON_BASE_URL}/assets/icons/our_services_icons/Infrastructure_and_DevOps_Support.svg`,
    Data_Backup_and_Recovery: `${ICON_BASE_URL}/assets/icons/our_services_icons/Data_Backup_and_Recovery.svg`,
    Help_Desk_and_Support: `${ICON_BASE_URL}/assets/icons/our_services_icons/Help_Desk_and_Support.svg`,
    Codebase_Refactoring_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Codebase_Refactoring_Services.svg`,
    Enhanced_Reliability: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enhanced_Reliability.svg`,
    Cost_Savings: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cost_Savings.svg`,
    Server_Monitoring: `${ICON_BASE_URL}/assets/icons/our_services_icons/Server_Monitoring.svg`,
    Module_and_Plugin_Updates: `${ICON_BASE_URL}/assets/icons/our_services_icons/Module_and_Plugin_Updates.svg`,
    Bug_Fixing_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Bug_Fixing_Services.svg`,
    Monitoring_and_Issue_Tracking: `${ICON_BASE_URL}/assets/icons/our_services_icons/Monitoring_and_Issue_Tracking.svg`,
    Ongoing_Technical_Support: `${ICON_BASE_URL}/assets/icons/our_services_icons/Ongoing_Technical_Support.svg`,
    Reconfiguration_and_Modification: `${ICON_BASE_URL}/assets/icons/our_services_icons/Reconfiguration_and_Modification.svg`,
    Managed_IT_Support_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Managed_IT_Support_Services.svg`,
    Integration_and_Automation: `${ICON_BASE_URL}/assets/icons/our_services_icons/Integration_and_Automation.svg`,
    Website_Maintenance_and_Support_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Website_Maintenance_and_Support_Services.svg`,
    Secure_and_Stable_App: `${ICON_BASE_URL}/assets/icons/our_services_icons/Secure_and_Stable_App.svg`,
    High_Performance: `${ICON_BASE_URL}/assets/icons/our_services_icons/High_Performance.svg`,
    Minimal: `${ICON_BASE_URL}/assets/icons/our_services_icons/Minimal.svg`,
    Extended_Software_Lifespan: `${ICON_BASE_URL}/assets/icons/our_services_icons/Extended_Software_Lifespan.svg`,

    Cost_effective: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cost_effective.svg`,
    Cross_platform: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cross_platform.svg`,
    Custom_Startup_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_Startup_App_Development.svg`,
    Customer_engagement: `${ICON_BASE_URL}/assets/icons/our_services_icons/Customer_engagement.svg`,
    Faster_Time_to_Market: `${ICON_BASE_URL}/assets/icons/our_services_icons/Faster_Time_to_Market.svg`,
    Full_Cycle_Product_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Full_Cycle_Product_Development.svg`,
    hugeicons_security_lock: `${ICON_BASE_URL}/assets/icons/our_services_icons/hugeicons_security_lock.svg`,
    Managed_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Managed_Services.svg`,
    MVP_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/MVP_App_Development.svg`,
    Product_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/Product_Consulting.svg`,
    Product_Discovery_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Product_Discovery_Services.svg`,
    Scalability_Startup: `${ICON_BASE_URL}/assets/icons/our_services_icons/Scalability.svg`,
    Startup_App_UXUI_Design: `${ICON_BASE_URL}/assets/icons/our_services_icons/Startup_App_UXUI_Design.svg`,
    Web_Application_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Web_Application_Development.svg`,
    Security_Startup: `${ICON_BASE_URL}/assets/icons/our_services_icons/Security_Startup.svg`,

    API_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/API_Development_Services.svg`,
    Cross_Platform_App_Development_EP: `${ICON_BASE_URL}/assets/icons/our_services_icons/Cross_Platform_App_Development.svg`,
    Enterprise_Software_Consulting: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enterprise_Software_Consulting.svg`,
    Enterprise_Software_Digital_Transformation: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enterprise_Software_Digital_Transformation.svg`,
    Enterprise_Web_App_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enterprise_Web_App_Development.svg`,
    MVP_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/MVP_Development_Services.svg`,
    Legacy_App_Modernization: `${ICON_BASE_URL}/assets/icons/our_services_icons/Legacy_App_Modernization.svg`,
    Software_Integration_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/Software_Integration_Services.svg`,

    Budget_friendly_Solutions: `${ICON_BASE_URL}/assets/icons/our_services_icons/Budget_friendly_Solutions.svg`,
    Clear_Communication: `${ICON_BASE_URL}/assets/icons/our_services_icons/Clear_Communication.svg`,
    Enhanced_Productivity: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enhanced_Productivity.svg`,
    Higher_Customer_Satisfaction: `${ICON_BASE_URL}/assets/icons/our_services_icons/Higher_Customer_Satisfaction.svg`,
    Improved_Security: `${ICON_BASE_URL}/assets/icons/our_services_icons/Improved_Security.svg`,
    Real_Time_Data_Analysis: `${ICON_BASE_URL}/assets/icons/our_services_icons/Real_Time_Data_Analysis.svg`,
    Simplified_Operations: `${ICON_BASE_URL}/assets/icons/our_services_icons/Simplified_Operations.svg`,
    Strategic_Planning_and_Execution: `${ICON_BASE_URL}/assets/icons/our_services_icons/Strategic_Planning_and_Execution.svg`,

    Custom_Mobile_App: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_Mobile_App.svg`,
    Custom_Web_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Custom_Web_Development.svg`,
    Fully_MVP_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Fully_MVP_Development.svg`,
    MVP_Consulting_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/MVP_Consulting_Services.svg`,
    MVP_Software_Development_Services: `${ICON_BASE_URL}/assets/icons/our_services_icons/MVP_Software_Development_Services.svg`,
    Startup_MVP_Development: `${ICON_BASE_URL}/assets/icons/our_services_icons/Startup_MVP_Development.svg`,
    UX_Design_and_Prototyping: `${ICON_BASE_URL}/assets/icons/our_services_icons/UX_Design_and_Prototyping.svg`,

    Adequate_Team_Distribution: `${ICON_BASE_URL}/assets/icons/our_services_icons/Adequate_Team_Distribution.svg`,
    Better_Informed_Decisions: `${ICON_BASE_URL}/assets/icons/our_services_icons/Better_Informed_Decisions.svg`,
    Fulfill_Market_Demands_Early: `${ICON_BASE_URL}/assets/icons/our_services_icons/Fulfill_Market_Demands_Early.svg`,
    Gather_Investor_Confidence: `${ICON_BASE_URL}/assets/icons/our_services_icons/Gather_Investor_Confidence.svg`,
    Minimize_Business_Risks: `${ICON_BASE_URL}/assets/icons/our_services_icons/Minimize_Business_Risks.svg`,
    Save_Cost_and_Resources: `${ICON_BASE_URL}/assets/icons/our_services_icons/Save_Cost_and_Resources.svg`,
    Scalable_Solutions_MVP: `${ICON_BASE_URL}/assets/icons/our_services_icons/Scalable_Solutions_MVP.svg`,
    Fast_Product_Launch_MVP: `${ICON_BASE_URL}/assets/icons/our_services_icons/Fast_Product_Launch_MVP.svg`,

    Enhanced_Customer_Experiences_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Enhanced_Customer_Experiences_AI.svg`,
    Faster_Innovation_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Faster_Innovation_AI.svg`,
    Process_Automation_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Process_Automation_AI.svg`,
    Real_Time_Intelligence_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Real_Time_Intelligence_AI.svg`,
    Risk_Reduction_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Risk_Reduction_AI.svg`,
    Scalability_AI: `${ICON_BASE_URL}/assets/icons/our_services_icons/Scalability_AI.svg`,
  },

  industryIcons: {
    AgTech: `${ICON_BASE_URL}/assets/icons/industry_icons/AgTech.svg`,
    Automotive: automotive,
    Banking_Finance: `${ICON_BASE_URL}/assets/icons/industry_icons/Banking_Finance.svg`,
    eCommerce: `${ICON_BASE_URL}/assets/icons/industry_icons/eCommerce.svg`,
    Education: `${ICON_BASE_URL}/assets/icons/industry_icons/Education.svg`,
    Entertainment: `${ICON_BASE_URL}/assets/icons/industry_icons/Entertainment.svg`,
    Finance: `${ICON_BASE_URL}/assets/icons/industry_icons/Finance.svg`,
    Fitness: industryFitness,
    Gaming: `${ICON_BASE_URL}/assets/icons/industry_icons/Gaming.svg`,
    Healthcare: `${ICON_BASE_URL}/assets/icons/industry_icons/Healthcare.svg`,
    Insurance: `${ICON_BASE_URL}/assets/icons/industry_icons/Insurance.svg`,
    Logistics: `${ICON_BASE_URL}/assets/icons/industry_icons/Logistics.svg`,
    Manufacturing: `${ICON_BASE_URL}/assets/icons/industry_icons/Manufacturing.svg`,
    Oil_Gas: `${ICON_BASE_URL}/assets/icons/industry_icons/Oil_Gas.svg`,
    On_Demand: `${ICON_BASE_URL}/assets/icons/industry_icons/On-Demand.svg`,
    Real_Estate: `${ICON_BASE_URL}/assets/icons/industry_icons/Real_Estate.svg`,
    Restaurant: `${ICON_BASE_URL}/assets/icons/industry_icons/Restaurant.svg`,
    Social_Networking: `${ICON_BASE_URL}/assets/icons/industry_icons/Social_Networking.svg`,
    Transportation_Logistics: `${ICON_BASE_URL}/assets/icons/industry_icons/Transportation_Logistics.svg`,
    Travel: `${ICON_BASE_URL}/assets/icons/industry_icons/Travel.svg`,
    Events_Tickets: `${ICON_BASE_URL}/assets/icons/industry_icons/Events_Tickets.svg`,
    Dating: `${ICON_BASE_URL}/assets/icons/industry_icons/Dating.svg`,
    sports: industrySports,

    White_Label_Restaurant_App: `${ICON_BASE_URL}/assets/icons/industry_icons/White_Label_Restaurant_App.svg`,
    Restaurant_App_Consultation: `${ICON_BASE_URL}/assets/icons/industry_icons/Restaurant_App_Consultation.svg`,
    Restaurant_App_UIUX_Design: `${ICON_BASE_URL}/assets/icons/industry_icons/Restaurant_App_UIUX_Design.svg`,
    Custom_Mobile_App_Development: `${ICON_BASE_URL}/assets/icons/industry_icons/Custom_Mobile_App_Development.svg`,
    Web_App_Development_FDI: `${ICON_BASE_URL}/assets/icons/industry_icons/Web_App_Development_FDI.svg`,
    API_Integration: `${ICON_BASE_URL}/assets/icons/industry_icons/API_Integration.svg`,
    Quality_Assurance: `${ICON_BASE_URL}/assets/icons/industry_icons/Quality_Assurance.svg`,
    Deployment_FDI: `${ICON_BASE_URL}/assets/icons/industry_icons/Deployment_FDI.svg`,
    Support_and_Maintenance: `${ICON_BASE_URL}/assets/icons/industry_icons/Support_and_Maintenance.svg`,
  },

  whyChooseIcons: {
    Native_User: `${ICON_BASE_URL}/assets/icons/why_choose/Native_User.svg`,
    Agile_Development: `${ICON_BASE_URL}/assets/icons/why_choose/Agile_Development.svg`,
    HundredTransparency: `${ICON_BASE_URL}/assets/icons/why_choose/HundredTransparency.svg`,
    Cross_Platform: `${ICON_BASE_URL}/assets/icons/why_choose/Cross_Platform.svg`,
    Tech_Stack: `${ICON_BASE_URL}/assets/icons/why_choose/Tech_Stack.svg`,
    Flexible_Engagement: `${ICON_BASE_URL}/assets/icons/why_choose/Flexible_Engagement.svg`,
    Expert_Designers_Developers: `${ICON_BASE_URL}/assets/icons/why_choose/Expert_Designers_Developers.svg`,
    Expertise_Across_Industries: `${ICON_BASE_URL}/assets/icons/why_choose/Expertise_Across_Industries.svg`,
    Outcome_Focused: `${ICON_BASE_URL}/assets/icons/why_choose/Outcome_Focused.svg`,
    Rapid_Delivery: `${ICON_BASE_URL}/assets/icons/why_choose/Rapid_Delivery.svg`,
    Shorten_Market: `${ICON_BASE_URL}/assets/icons/why_choose/Shorten_Market.svg`,
    Specializes_Technologies: `${ICON_BASE_URL}/assets/icons/why_choose/Specializes_Technologies.svg`,
    Detailed_Project_Assessment: `${ICON_BASE_URL}/assets/icons/why_choose/Detailed_Project_Assessment.svg`,
    Expertise_Modern_Frameworks: `${ICON_BASE_URL}/assets/icons/why_choose/Expertise_Modern_Frameworks.svg`,
    Agile_Methodology_Development: `${ICON_BASE_URL}/assets/icons/why_choose/Agile_Methodology_Development.svg`,
    Customer_centric_Approach: `${ICON_BASE_URL}/assets/icons/why_choose/Customer_centric_Approach.svg`,
    Experienced_Cross_Platform_Experts: `${ICON_BASE_URL}/assets/icons/why_choose/Experienced_Cross_Platform_Experts.svg`,
    Project_Transparency: `${ICON_BASE_URL}/assets/icons/why_choose/Project_Transparency.svg`,
    Cost_effective_Solutions: `${ICON_BASE_URL}/assets/icons/why_choose/Cost_effective_Solutions.svg`,
    Security_Compliance: `${ICON_BASE_URL}/assets/icons/why_choose/Security_Compliance.svg`,
    Incessant_Post_Launch_Support: `${ICON_BASE_URL}/assets/icons/why_choose/Incessant_Post_Launch_Support.svg`,
    Enhance_Reputation: `${ICON_BASE_URL}/assets/icons/why_choose/Enhance_Reputation.svg`,
    Proven_Results: `${ICON_BASE_URL}/assets/icons/why_choose/Proven_Results.svg`,
    Strong_Online_Presence: `${ICON_BASE_URL}/assets/icons/why_choose/Strong_Online_Presence.svg`,
    Custom_Designs: `${ICON_BASE_URL}/assets/icons/why_choose/Custom_Designs.svg`,
    Project_Management: `${ICON_BASE_URL}/assets/icons/why_choose/Project_Management.svg`,
    Boost_Conversion_Rates: `${ICON_BASE_URL}/assets/icons/why_choose/Boost_Conversion_Rates.svg`,
    Optimized_Performance: `${ICON_BASE_URL}/assets/icons/why_choose/Optimized_Performance.svg`,
    Dedicated_Teams: `${ICON_BASE_URL}/assets/icons/why_choose/Dedicated_Teams.svg`,
    Third_Party_Integration: Third_Party_Integration,
    Transparent_Communication: `${ICON_BASE_URL}/assets/icons/why_choose/Transparent_Communication.svg`,
    Continuous_Maintenance_Support: `${ICON_BASE_URL}/assets/icons/why_choose/Continuous_Maintenance_Support.svg`,
    SEO_Support: `${ICON_BASE_URL}/assets/icons/why_choose/SEO_Support.svg`,
    AI_Driven_Automation: `${ICON_BASE_URL}/assets/icons/why_choose/AI_Driven_Automation.svg`,
    End_to_End_Transparency: `${ICON_BASE_URL}/assets/icons/why_choose/End_to_End_Transparency.svg`,
    Faster_Time_Market: `${ICON_BASE_URL}/assets/icons/why_choose/Faster_Time_Market.svg`,
    Full_Cycle_QA_Services: `${ICON_BASE_URL}/assets/icons/why_choose/Full_Cycle_QA_Services.svg`,
    Increased_Product_Quality: `${ICON_BASE_URL}/assets/icons/why_choose/Increased_Product_Quality.svg`,
    Scalability_whyChoose: `${ICON_BASE_URL}/assets/icons/why_choose/Scalability.svg`,
    Experienced_Team: `${ICON_BASE_URL}/assets/icons/why_choose/Experienced_Team.svg`,
    Post_Deployment_Support: `${ICON_BASE_URL}/assets/icons/why_choose/Post_Deployment_Support.svg`,
    Blockchain_Mastery: `${ICON_BASE_URL}/assets/icons/why_choose/Blockchain_Mastery.svg`,
    Decentralized_Storage: `${ICON_BASE_URL}/assets/icons/why_choose/Decentralized_Storage.svg`,
    Community_Growth: `${ICON_BASE_URL}/assets/icons/why_choose/Community_Growth.svg`,
    You_re_in_Control: `${ICON_BASE_URL}/assets/icons/why_choose/You_re_in_Control.svg`,
    Enterprise_Level_Security: `${ICON_BASE_URL}/assets/icons/why_choose/Enterprise_Level_Security.svg`,
    Round_the_Clock_Support: `${ICON_BASE_URL}/assets/icons/why_choose/Round_the_Clock_Support.svg`,
    Ongoing_Support: `${ICON_BASE_URL}/assets/icons/why_choose/Ongoing_Support.svg`,
    High_End_Expertise: `${ICON_BASE_URL}/assets/icons/why_choose/High_End_Expertise.svg`,
    Design_Thinking_Strategy: `${ICON_BASE_URL}/assets/icons/why_choose/Design_Thinking_Strategy.svg`,
    Blockchain_Platform_Expertise: `${ICON_BASE_URL}/assets/icons/why_choose/Blockchain_Platform_Expertise.svg`,

    Innovation_Led_Approach: `${ICON_BASE_URL}/assets/icons/why_choose/Innovation_Led_Approach.svg`,
    Unmatched_Flexibility: `${ICON_BASE_URL}/assets/icons/why_choose/Unmatched_Flexibility.svg`,
    Industry_Wide_Experience: `${ICON_BASE_URL}/assets/icons/why_choose/Industry_Wide_Experience.svg`,
    Cost_Effective_Solutions: `${ICON_BASE_URL}/assets/icons/why_choose/Cost_effective_Solutions.svg`,
    Comprehensive_Expertise: `${ICON_BASE_URL}/assets/icons/why_choose/Comprehensive_Expertise.svg`,
    Cross_Device_Compatibility: `${ICON_BASE_URL}/assets/icons/why_choose/Cross_Device_Compatibility.svg`,

    Advanced_Methodology: `${ICON_BASE_URL}/assets/icons/why_choose/Advanced_Methodology.svg`,
    Affordable_Solution: `${ICON_BASE_URL}/assets/icons/why_choose/Affordable_Solution.svg`,
    Expeditious_Support: `${ICON_BASE_URL}/assets/icons/why_choose/Expeditious_Support.svg`,
    Flexible_Hiring_Models: `${ICON_BASE_URL}/assets/icons/why_choose/Flexible_Hiring_Models.svg`,
    NDA_Protection: `${ICON_BASE_URL}/assets/icons/why_choose/NDA_Protection.svg`,
    Skilled_Workforce: `${ICON_BASE_URL}/assets/icons/why_choose/Skilled_Workforce.svg`,

    Latest_Technologies: `${ICON_BASE_URL}/assets/icons/why_choose/Latest_Technologies.svg`,
    IOT_Transparency: `${ICON_BASE_URL}/assets/icons/why_choose/Transparency.svg`,
    Unified_Approach: `${ICON_BASE_URL}/assets/icons/why_choose/Unified_Approach.svg`,
    Quick_Turnaround: `${ICON_BASE_URL}/assets/icons/why_choose/Quick_Turnaround.svg`,
    Transparent_Pricing: `${ICON_BASE_URL}/assets/icons/why_choose/Transparent_Pricing.svg`,
    Reduced_Maintenance_Overhead: `${ICON_BASE_URL}/assets/icons/why_choose/Reduced_Maintenance_Overhead.svg`,

    Better_ROI: `${ICON_BASE_URL}/assets/icons/why_choose/Better_ROI.svg`,
    Cloud_Technologies_Expertise: `${ICON_BASE_URL}/assets/icons/why_choose/Cloud_Technologies_Expertise.svg`,
    Custom_Solutions: `${ICON_BASE_URL}/assets/icons/why_choose/Custom_Solutions.svg`,
    End_to_End_Support: `${ICON_BASE_URL}/assets/icons/why_choose/End_to_End_Support.svg`,
    Proven_Experience: `${ICON_BASE_URL}/assets/icons/why_choose/Proven_Experience.svg`,
    Serverless_Deployment: `${ICON_BASE_URL}/assets/icons/why_choose/Serverless_Deployment.svg`,

    Enhanced_Focus_Core_Business: `${ICON_BASE_URL}/assets/icons/why_choose/Enhanced_Focus_Core_Business.svg`,
    Budget_Optimization: `${ICON_BASE_URL}/assets/icons/why_choose/Budget_Optimization.svg`,
    Futuristic_Approach: `${ICON_BASE_URL}/assets/icons/why_choose/Futuristic_Approach.svg`,
    Long_Term_Partnership: `${ICON_BASE_URL}/assets/icons/why_choose/Long_Term_Partnership.svg`,
    Diverse_Experience: `${ICON_BASE_URL}/assets/icons/why_choose/Diverse_Experience.svg`,
    Operational_Excellence: `${ICON_BASE_URL}/assets/icons/why_choose/Operational_Excellence.svg`,

    Improve_User_Experience: `${ICON_BASE_URL}/assets/icons/why_choose/Improve_User_Experience.svg`,
    Budget_Friendly: `${ICON_BASE_URL}/assets/icons/why_choose/Budget_Friendly.svg`,
    Scalable_Engagement_Models: `${ICON_BASE_URL}/assets/icons/why_choose/Scalable_Engagement_Models.svg`,
    Proactive_Monitoring_and_Maintenance: `${ICON_BASE_URL}/assets/icons/why_choose/Proactive_Monitoring_and_Maintenance.svg`,
    Advanced_Toolkit: `${ICON_BASE_URL}/assets/icons/why_choose/Advanced_Toolkit.svg`,
    DailySupport: DailySupport,

    Advanced_Technology: `${ICON_BASE_URL}/assets/icons/why_choose/Advanced_Technology.svg`,
    Customized_Solutions: `${ICON_BASE_URL}/assets/icons/why_choose/Customized_Solutions.svg`,
    On_Time_Delivery: `${ICON_BASE_URL}/assets/icons/why_choose/On_Time_Delivery.svg`,
    Post_Launch_Support: `${ICON_BASE_URL}/assets/icons/why_choose/Post_Launch_Support.svg`,
    Union: `${ICON_BASE_URL}/assets/icons/why_choose/Union.svg`,
    User_Focused_Design: `${ICON_BASE_URL}/assets/icons/why_choose/User_Focused_Design.svg`,

    Collaborative_Approach: `${ICON_BASE_URL}/assets/icons/why_choose/Collaborative_Approach.svg`,
    Complete_Business_Planning: `${ICON_BASE_URL}/assets/icons/why_choose/Complete_Business_Planning.svg`,
    Data_Security_Management: `${ICON_BASE_URL}/assets/icons/why_choose/Data_Security_Management.svg`,
    Extensive_Experience: `${ICON_BASE_URL}/assets/icons/why_choose/Extensive_Experience.svg`,
    Personalized_Enterprise_Services: `${ICON_BASE_URL}/assets/icons/why_choose/Personalized_Enterprise_Services.svg`,
    Quality_first_Approach: `${ICON_BASE_URL}/assets/icons/why_choose/Quality_first_Approach.svg`,

    Cost_effective_Solutions_MVP: `${ICON_BASE_URL}/assets/icons/why_choose/Cost_effective_Solutions_MVP.svg`,
    Customer_centric_Development: `${ICON_BASE_URL}/assets/icons/why_choose/Customer_centric_Development.svg`,
    Diversified_Portfolio: `${ICON_BASE_URL}/assets/icons/why_choose/Diversified_Portfolio.svg`,
    Expertise_in_New_Tech: `${ICON_BASE_URL}/assets/icons/why_choose/Expertise_in_New_Tech.svg`,
    Highly_talented_Team: `${ICON_BASE_URL}/assets/icons/why_choose/Highly_talented_Team.svg`,
    Qualitative_Services: `${ICON_BASE_URL}/assets/icons/why_choose/Qualitative_Services.svg`,
  },

  aiServicesIcon: {
    AI_Agent_Software: `${ICON_BASE_URL}/assets/icons/AI_services/AI_Agent_Software.svg`,
    AI_App_Development: `${ICON_BASE_URL}/assets/icons/AI_services/AI_App_Development.svg`,
    AI_as_a_Service: `${ICON_BASE_URL}/assets/icons/AI_services/AI_as_a_Service.svg`,
    AI_Consulting_Services: `${ICON_BASE_URL}/assets/icons/AI_services/AI_Consulting_Services.svg`,
    AI_Integration: `${ICON_BASE_URL}/assets/icons/AI_services/AI_Integration.svg`,
    AI_Product_Development: `${ICON_BASE_URL}/assets/icons/AI_services/AI_Product_Development.svg`,
    AIOps: `${ICON_BASE_URL}/assets/icons/AI_services/AIOps.svg`,
    Conversational_AI_Development: `${ICON_BASE_URL}/assets/icons/AI_services/Conversational_AI_Development.svg`,
    Custom_AI_Solution_Development: `${ICON_BASE_URL}/assets/icons/AI_services/Custom_AI_Solution_Development.svg`,
    Generative_AI_Development: `${ICON_BASE_URL}/assets/icons/AI_services/Generative_AI_Development.svg`,
    LLM_Fine_Tuning: `${ICON_BASE_URL}/assets/icons/AI_services/LLM_Fine_Tuning.svg`,
    ML_Development_and_Model_Engineering: `${ICON_BASE_URL}/assets/icons/AI_services/ML_Development_and_Model_Engineering.svg`,

    Computer_Vision: `${ICON_BASE_URL}/assets/icons/AI_services/Computer_Vision.svg`,
    Data_Science: `${ICON_BASE_URL}/assets/icons/AI_services/Data_Science.svg`,
    Deep_Learning: `${ICON_BASE_URL}/assets/icons/AI_services/Deep_Learning.svg`,
    Generative_AI: `${ICON_BASE_URL}/assets/icons/AI_services/Generative_AI.svg`,
    Multimodal_AI: `${ICON_BASE_URL}/assets/icons/AI_services/Multimodal_AI.svg`,
    Natural_Language_Processing: `${ICON_BASE_URL}/assets/icons/AI_services/Natural_Language_Processing.svg`,
    Predictive_Analytics: `${ICON_BASE_URL}/assets/icons/AI_services/Predictive_Analytics.svg`,

    Advanced_Programming_Languages: `${ICON_BASE_URL}/assets/icons/AI_services/Advanced_Programming_Languages.svg`,
    AI_Libraries: `${ICON_BASE_URL}/assets/icons/AI_services/AI_Libraries.svg`,
    Big_Data: `${ICON_BASE_URL}/assets/icons/AI_services/Big_Data.svg`,
    Cloud_Computing: `${ICON_BASE_URL}/assets/icons/AI_services/Cloud_Computing.svg`,
    Cutting_Edge_AI_Frameworks: `${ICON_BASE_URL}/assets/icons/AI_services/Cutting_Edge_AI_Frameworks.svg`,
    Data_Driven_Insights: `${ICON_BASE_URL}/assets/icons/AI_services/Data_Driven_Insights.svg`,
    MLOps: `${ICON_BASE_URL}/assets/icons/AI_services/MLOps.svg`,
  },

  mobile: {
    andriod: `${ICON_BASE_URL}/assets/icons/mobile/andriod.svg`,
    ios: `${ICON_BASE_URL}/assets/icons/mobile/ios.svg`,
    react: `${ICON_BASE_URL}/assets/icons/mobile/react.svg`,
    hybrid: `${ICON_BASE_URL}/assets/icons/mobile/hybrid.svg`,
    flutter: `${ICON_BASE_URL}/assets/icons/technology_icon/Flutter.svg`, // ← most common location in your project
    pwa: `${ICON_BASE_URL}/assets/icons/pwa.svg`,
    wearable: `${ICON_BASE_URL}/assets/icons/Wearable.svg`,
    crossPlatform: `${ICON_BASE_URL}/assets/icons/technology_icon/cross_Platform.svg`,
    mobileGame: `${ICON_BASE_URL}/assets/icons/Mobile_Game.svg`,
  },

  serviceSec: {
    image1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/custom_web.svg`,
    image2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/ui-ux-web.svg`,
    image3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/frontend_developnen.svg`,
    image4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/backend_development.svg`,
    image5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/web_portal.svg`,
    image6: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/enterprise.svg`,
    image7: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/html5.svg`,
    image8: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/custom_ecommerce.svg`,
    image9: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/Build_Connections.svg`,
    image10: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/Accessibility_247.svg`,
    image11: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/Customization_and_Scalability.svg`,
    image12: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/Brand_crediblity.svg`,
    image13: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/Organic_Traffic.svg`,
    image14: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/icons/Higher_Visibility.svg`,
  },

  industrySolution: {
    advancedSearch: `${ICON_BASE_URL}/assets/icons/industry-solution/advanced-search.svg`,
    location: `${ICON_BASE_URL}/assets/icons/industry-solution/location.svg`,
    realTime: `${ICON_BASE_URL}/assets/icons/industry-solution/real-time.svg`,
    raiting: `${ICON_BASE_URL}/assets/icons/industry-solution/raiting.svg`,
    detailMenu: `${ICON_BASE_URL}/assets/icons/industry-solution/detail-menu.svg`,
    semless: `${ICON_BASE_URL}/assets/icons/industry-solution/semless.svg`, // ← probably "seamless"
  },

  statisticIcons: {
    badge: `${ICON_BASE_URL}/assets/icons/statistic-icons/badge.svg`,
    appDownload: `${ICON_BASE_URL}/assets/icons/statistic-icons/app-download.svg`,
    appDelivered: `${ICON_BASE_URL}/assets/icons/statistic-icons/app-delivered.svg`,
    happyClients: `${ICON_BASE_URL}/assets/icons/statistic-icons/happy_clients.svg`,
  },

  benifitsStep: {
    insight: `${ICON_BASE_URL}/assets/icons/benifits-step/insight.svg`,
    broaderClintel: `${ICON_BASE_URL}/assets/icons/benifits-step/broader-clintel.svg`,
    optimizeResource: `${ICON_BASE_URL}/assets/icons/benifits-step/optimize-resource.svg`,
    person: `${ICON_BASE_URL}/assets/icons/benifits-step/person.svg`,
    improveCustomer: `${ICON_BASE_URL}/assets/icons/benifits-step/improve-customer.svg`,
    improvedUser: `${ICON_BASE_URL}/assets/icons/Improved_User.svg`,
    betterUser: `${ICON_BASE_URL}/assets/icons/Better_User.svg`,
    increasesSales: `${ICON_BASE_URL}/assets/icons/Increases_Sales.svg`,
    marketingChannel: `${ICON_BASE_URL}/assets/icons/Marketing_Channel.svg`,
    futureProofing: `${ICON_BASE_URL}/assets/icons/Future_Proofing.svg`,
    competitiveEdge: `${ICON_BASE_URL}/assets/icons/Competitive_Edge.svg`,
    improvedOperationalEfficiency: `${ICON_BASE_URL}/assets/icons/Improved_Operational_Efficiency.svg`,
    revenueGeneration: `${ICON_BASE_URL}/assets/icons/Revenue_Generation.svg`,
  },

  industryBenifit: {
    insights: `${ICON_BASE_URL}/assets/icons/industry-benifit/insights.svg`,
    optimusResource: `${ICON_BASE_URL}/assets/icons/industry-benifit/optimus-resource.svg`,
    broaderClientele: `${ICON_BASE_URL}/assets/icons/industry-benifit/broader-clientele.svg`,
    personalizedBranding: `${ICON_BASE_URL}/assets/icons/industry-benifit/personalized-branding.svg`,
    marketingOpportunities: `${ICON_BASE_URL}/assets/icons/industry-benifit/marketing-opportunities.svg`,
    customerExperience: `${ICON_BASE_URL}/assets/icons/industry-benifit/customer-experience.svg`,
  },
  industryServices: {
    web: `${ICON_BASE_URL}/assets/icons/industry-services/web.svg`,
    mobile: `${ICON_BASE_URL}/assets/icons/industry-services/mobile.svg`,
    backend: `${ICON_BASE_URL}/assets/icons/industry-services/backend.svg`,
    uiUx: `${ICON_BASE_URL}/assets/icons/industry-services/ui-ux.svg`,
  },

  presentationTabs: {
    customer: `${ICON_BASE_URL}/assets/icons/presentation-tabs/customer.svg`,
    customerGray: `${ICON_BASE_URL}/assets/icons/presentation-tabs/customer-gray.svg`,
    shop: `${ICON_BASE_URL}/assets/icons/presentation-tabs/shop.svg`,
    shopGray: `${ICON_BASE_URL}/assets/icons/presentation-tabs/shop-gray.svg`,
    admin: `${ICON_BASE_URL}/assets/icons/presentation-tabs/admin.svg`,
    adminGray: `${ICON_BASE_URL}/assets/icons/presentation-tabs/admin-gray.svg`,
    driver: `${ICON_BASE_URL}/assets/icons/presentation-tabs/driver.svg`,
    driverGray: `${ICON_BASE_URL}/assets/icons/presentation-tabs/driver-gray.svg`,
  },

  values: {
    beReal: `${ICON_BASE_URL}/assets/images/about/values_icons/be_real.svg`,
    beAccountable: `${ICON_BASE_URL}/assets/images/about/values_icons/be_acceptable.svg`, // ← note spelling in your original
    passionate: `${ICON_BASE_URL}/assets/images/about/values_icons/passionate.svg`,
    makingDifference: `${ICON_BASE_URL}/assets/images/about/values_icons/making-difference.svg`,
    questToLearn: `${ICON_BASE_URL}/assets/images/about/values_icons/quest-to-learn.svg`,
    collaborativeWorking: `${ICON_BASE_URL}/assets/images/about/values_icons/colaborative.svg`, // ← note spelling
    resultsMatter: `${ICON_BASE_URL}/assets/images/about/values_icons/result-matter.svg`,
    alwaysConnected: `${ICON_BASE_URL}/assets/images/about/values_icons/always-connected.svg`,
  },

  responsive: {
    beReal: `${ICON_BASE_URL}/images/about/our-values/be-real.svg`,
    beAccountable: `${ICON_BASE_URL}/images/about/our-values/be-accountable.svg`,
    passionateInnovative: `${ICON_BASE_URL}/images/about/our-values/Passionate_Innovative.svg`,
    makingDifference: `${ICON_BASE_URL}/images/about/our-values/making-difference.svg`,
  },

  laravel: {
    custom_laravel_web: `${ICON_BASE_URL}/assets/icons/laravel/custom-larawel.svg`, // ← note original typo
    intutivecrm: `${ICON_BASE_URL}/assets/icons/laravel/intutive-crm.svg`, // ← note spelling
    laravel_cms: `${ICON_BASE_URL}/assets/icons/laravel/laravel-cms.svg`,
    laravel_web_development: `${ICON_BASE_URL}/assets/icons/laravel/larawel-web-development.svg`,

    hiring: {
      fullTime: `${ICON_BASE_URL}/assets/icons/laravel/full-time.svg`,
      partTime: `${ICON_BASE_URL}/assets/icons/laravel/part-time.svg`,
      hourly: `${ICON_BASE_URL}/assets/icons/laravel/hourly.svg`,
    },

    projectModels: {
      timeMaterial: `${ICON_BASE_URL}/assets/icons/laravel/time_material.svg`,
      fixedPrice: `${ICON_BASE_URL}/assets/icons/laravel/fixed-price.svg`,
    },

    reasons: {
      resultDriven: `${ICON_BASE_URL}/assets/icons/laravel/result-driven.svg`,
      provenExperience: `${ICON_BASE_URL}/assets/icons/laravel/proven-experience.svg`,
      attentionToDetails: `${ICON_BASE_URL}/assets/icons/laravel/attention.svg`,
      affordableSolutions: `${ICON_BASE_URL}/assets/icons/laravel/affordable.svg`,
      specializedTechnicalTeam: `${ICON_BASE_URL}/assets/icons/laravel/specialized-technical.svg`,
      bestInClassSupport: `${ICON_BASE_URL}/assets/icons/laravel/best-in-class.svg`,
    },

    benefits: {
      robust: `${ICON_BASE_URL}/assets/icons/laravel/robust.svg`,
      unified: `${ICON_BASE_URL}/assets/icons/laravel/unified.svg`,
      easyDeployment: `${ICON_BASE_URL}/assets/icons/laravel/easy-deployment.svg`,
      realTime: `${ICON_BASE_URL}/assets/icons/laravel/real-time.svg`,
      seemlessIntegration: `${ICON_BASE_URL}/assets/icons/laravel/seemless-integration.svg`,
      effectiveDatabase: `${ICON_BASE_URL}/assets/icons/laravel/effective-database.svg`,
      simpleError: `${ICON_BASE_URL}/assets/icons/laravel/simple-error.svg`,
      elaboratedPackage: `${ICON_BASE_URL}/assets/icons/laravel/elaborated-package.svg`,
    },
  },
  processIcons: {
    simpleError: `${ICON_BASE_URL}/assets/icons/laravel-page/why-choose/simple-error-and-exception-handling.svg`,
    effectiveDatabase: `${ICON_BASE_URL}/assets/icons/laravel-page/why-choose/effective-database-abstraction.svg`,
    seamless: `${ICON_BASE_URL}/assets/icons/laravel-page/why-choose/seamless-integration.svg`,
    realTime: `${ICON_BASE_URL}/assets/icons/laravel-page/why-choose/real-time-analysis.svg`,
    easyDeployment: `${ICON_BASE_URL}/assets/icons/laravel-page/why-choose/easy-deployment.svg`,
    unified: `${ICON_BASE_URL}/assets/icons/laravel-page/why-choose/unified-apis.svg`,
    robust: `${ICON_BASE_URL}/assets/icons/laravel-page/why-choose/robust-security.svg`,
    elaboratedPackage: `${ICON_BASE_URL}/assets/icons/laravel-page/why-choose/elaborated-package-system.svg`,
  },

  industry1: `${ICON_BASE_URL}/assets/icons/laravel-page/about/custom-laravel-development.svg`,
  industry2: `${ICON_BASE_URL}/assets/icons/laravel-page/about/laravel-web-development.svg`,
  industry3: `${ICON_BASE_URL}/assets/icons/laravel-page/about/enterprise-solution.svg`,
  industry4: `${ICON_BASE_URL}/assets/icons/laravel-page/about/intuitive-crm-development.svg`,
  industry5: `${ICON_BASE_URL}/assets/icons/laravel-page/about/laravel-ecommerce-development.svg`,
  industry6: `${ICON_BASE_URL}/assets/icons/laravel-page/about/laravel-cms-development.svg`,
  industry7: `${ICON_BASE_URL}/assets/icons/laravel-page/about/laravel-migration-services.svg`,
  industry8: `${ICON_BASE_URL}/assets/icons/laravel-page/about/api-development-integration.svg`,
  industry9: `${ICON_BASE_URL}/assets/icons/laravel-page/about/long-term-maintenance-support.svg`,

  solutionSection: {
    solution1: `${ICON_BASE_URL}/assets/icons/Cross_Platform_Development.svg`,
    solution2: `${ICON_BASE_URL}/assets/icons/Ecommerce_Web_Development.svg`,
    solution3: `${ICON_BASE_URL}/assets/icons/Open_Source_Development.svg`,
    solution4: `${ICON_BASE_URL}/assets/icons/QA_Testing_Services.svg`,
    solution5: `${ICON_BASE_URL}/assets/icons/NFT_Development.svg`,
    solution6: `${ICON_BASE_URL}/assets/icons/Blockchain_Development.svg`,
    solution7: `${ICON_BASE_URL}/assets/icons/Wearable_App_Development.svg`,
    solution8: `${ICON_BASE_URL}/assets/icons/Progressive Web_Application_Development.svg`,
    solution9: `${ICON_BASE_URL}/assets/icons/IoT_Development.svg`,
    solution10: `${ICON_BASE_URL}/assets/icons/Software_Maintenance_Support.svg`,
    solution11: `${ICON_BASE_URL}/assets/icons/Startup_App_Development.svg`,
    solution12: `${ICON_BASE_URL}/assets/icons/Enterprise_App_Development.svg`,
    solution13: `${ICON_BASE_URL}/assets/icons/MVP_Development.svg`,
    solution14: `${ICON_BASE_URL}/assets/icons/AI_Chatbot_Development.svg`,
    solution15: `${ICON_BASE_URL}/assets/icons/ARVR_Development.svg`,
  },

  foodAppDeliverySolution: {
    solutionItems: {
      cloudKitchenAppDevelopment: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/solutions/cloud-kitchen-app-development.svg`,
      foodOrderingSolutions: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/solutions/food-ordering-solutions.svg`,
      inventoryManagementSolutions: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/solutions/inventory-management-solutions.svg`,
      orderManagementSolutions: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/solutions/order-management-solutions.svg`,
      restaurantMobileApp: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/solutions/restaurant-mobile-app.svg`,
      restaurantSearchPortals: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/solutions/restaurant-search-portals.svg`,
    },

    whyItems: {
      customApiIntegrations: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/whychoosekonstant/custom-api-integrations.svg`,
      transparentCommunication: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/whychoosekonstant/transparent-communication.svg`,
      onTimeDelivery: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/whychoosekonstant/on-time-delivery.svg`,
      supportAndMaintenance: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/whychoosekonstant/support-and-maintenance.svg`,
      latestTechStack: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/whychoosekonstant/latest-tech-stack.svg`,
      customerSupport24x7: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/whychoosekonstant/24x7-customer-support.svg`,
    },

    benefitItems: {
      increasedEfficiency: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/benefits/increased-efficiency.svg`,
      amplifiedVisibility: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/benefits/amplified-visibility.svg`,
      dataDrivenInsights: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/benefits/data-driven-insights.svg`,
      optimizedEngagement: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/benefits/optimized-engagement.svg`,
      savesTime: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/benefits/saves-time.svg`,
      realTimeTracking: `${ICON_BASE_URL}/assets/icons/food-app-delivery-solution/benefits/real-time-tracking.svg`,
    },
  },
  contactUs: {
    dubai: `${ICON_BASE_URL}/assets/icons/dubai.svg`,
    dubaiFlag: `${ICON_BASE_URL}/assets/icons/dubai-flag.svg`,
  },
} as const;
